import '../../assets/DatePicker.css';var Fr = Object.defineProperty;
var Hr = (r, a, t) => a in r ? Fr(r, a, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[a] = t;
var y = (r, a, t) => Hr(r, typeof a != "symbol" ? a + "" : a, t);
import { jsx as st, jsxs as Wr } from "react/jsx-runtime";
import * as S from "react";
import h, { createElement as Jn, Component as G, useLayoutEffect as er, useEffect as tr, cloneElement as nr, createRef as Me, useRef as rr, useState as Br, forwardRef as Qr } from "react";
import { r as ar, R as Kr } from "../../index-DC7FmJPK.mjs";
import { a as me, b as Le } from "../../addMonths-0Td1fWRC.mjs";
import { t as x, c as X, m as Nt, a as Rt, s as Ge, g as on, b as Vr, d as Ur, e as wt, h as or, i as qr, j as sr, k as ir, l as $r, n as $t, o as jr, w as wn, p as zr, q as ke, r as jt, f as zt, u as sn, v as yt } from "../../format-CkEOCppP.mjs";
import { s as We, a as Xr } from "../../subMonths-BIscnKAQ.mjs";
import { Input as Gr } from "../Input/Input.js";
function cn(r, a) {
  const t = +x(r);
  return X(r, t + a);
}
function Zr(r, a) {
  return cn(r, a * Nt);
}
function Xt(r, a) {
  return cn(r, a * Rt);
}
function ln(r, a) {
  const t = a * 3;
  return me(r, t);
}
function Jr(r, a) {
  return cn(r, a * 1e3);
}
function bt(r, a) {
  const t = a * 7;
  return Le(r, t);
}
function De(r, a) {
  return me(r, a * 12);
}
function yn(r) {
  let a;
  return r.forEach(function(t) {
    const e = x(t);
    (a === void 0 || a < e || isNaN(Number(e))) && (a = e);
  }), a || /* @__PURE__ */ new Date(NaN);
}
function bn(r) {
  let a;
  return r.forEach((t) => {
    const e = x(t);
    (!a || a > e || isNaN(+e)) && (a = e);
  }), a || /* @__PURE__ */ new Date(NaN);
}
function ea(r, a) {
  const t = Ge(r), e = Ge(a);
  return +t == +e;
}
function _t(r, a) {
  const t = x(r), e = x(a), n = t.getFullYear() - e.getFullYear(), o = t.getMonth() - e.getMonth();
  return n * 12 + o;
}
function Te(r) {
  const a = x(r);
  return Math.trunc(a.getMonth() / 3) + 1;
}
function kt(r, a) {
  const t = x(r), e = x(a), n = t.getFullYear() - e.getFullYear(), o = Te(t) - Te(e);
  return n * 4 + o;
}
function xt(r, a) {
  const t = x(r), e = x(a);
  return t.getFullYear() - e.getFullYear();
}
function cr(r) {
  const a = x(r);
  return a.setHours(23, 59, 59, 999), a;
}
function ta(r) {
  const a = x(r), t = a.getMonth();
  return a.setFullYear(a.getFullYear(), t + 1, 0), a.setHours(23, 59, 59, 999), a;
}
function Gt(r) {
  const a = x(r), t = a.getMonth(), e = t - t % 3;
  return a.setMonth(e, 1), a.setHours(0, 0, 0, 0), a;
}
function lr(r) {
  const a = x(r);
  return a.setDate(1), a.setHours(0, 0, 0, 0), a;
}
function ur(r) {
  const a = x(r), t = a.getFullYear();
  return a.setFullYear(t + 1, 0, 0), a.setHours(23, 59, 59, 999), a;
}
function na(r, a) {
  var i, c;
  const t = on(), e = t.weekStartsOn ?? ((c = (i = t.locale) == null ? void 0 : i.options) == null ? void 0 : c.weekStartsOn) ?? 0, n = x(r), o = n.getDay(), s = (o < e ? -7 : 0) + 6 - (o - e);
  return n.setDate(n.getDate() + s), n.setHours(23, 59, 59, 999), n;
}
function _n(r) {
  return x(r).getDate();
}
function ra(r) {
  return x(r).getDay();
}
function aa(r) {
  const a = x(r), t = a.getFullYear(), e = a.getMonth(), n = X(r, 0);
  return n.setFullYear(t, e + 1, 0), n.setHours(0, 0, 0, 0), n.getDate();
}
function oa() {
  return Object.assign({}, on());
}
function fe(r) {
  return x(r).getHours();
}
function sa(r) {
  let t = x(r).getDay();
  return t === 0 && (t = 7), t;
}
function he(r) {
  return x(r).getMinutes();
}
function re(r) {
  return x(r).getMonth();
}
function we(r) {
  return x(r).getSeconds();
}
function Zt(r) {
  return x(r).getTime();
}
function R(r) {
  return x(r).getFullYear();
}
function Se(r, a) {
  const t = x(r), e = x(a);
  return t.getTime() > e.getTime();
}
function Ye(r, a) {
  const t = x(r), e = x(a);
  return +t < +e;
}
function ia(r, a) {
  const t = x(r), e = x(a);
  return +t == +e;
}
function ca(r, a) {
  const t = a instanceof Date ? X(a, 0) : new a(0);
  return t.setFullYear(
    r.getFullYear(),
    r.getMonth(),
    r.getDate()
  ), t.setHours(
    r.getHours(),
    r.getMinutes(),
    r.getSeconds(),
    r.getMilliseconds()
  ), t;
}
const la = 10;
class dr {
  constructor() {
    y(this, "subPriority", 0);
  }
  validate(a, t) {
    return !0;
  }
}
class ua extends dr {
  constructor(a, t, e, n, o) {
    super(), this.value = a, this.validateValue = t, this.setValue = e, this.priority = n, o && (this.subPriority = o);
  }
  validate(a, t) {
    return this.validateValue(a, this.value, t);
  }
  set(a, t, e) {
    return this.setValue(a, t, this.value, e);
  }
}
class da extends dr {
  constructor() {
    super(...arguments);
    y(this, "priority", la);
    y(this, "subPriority", -1);
  }
  set(t, e) {
    return e.timestampIsSet ? t : X(t, ca(t, Date));
  }
}
class F {
  run(a, t, e, n) {
    const o = this.parse(a, t, e, n);
    return o ? {
      setter: new ua(
        o.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: o.rest
    } : null;
  }
  validate(a, t, e) {
    return !0;
  }
}
class pa extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 140);
    y(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, e, n) {
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(t, { width: "abbreviated" }) || n.era(t, { width: "narrow" });
      case "GGGGG":
        return n.era(t, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(t, { width: "wide" }) || n.era(t, { width: "abbreviated" }) || n.era(t, { width: "narrow" });
    }
  }
  set(t, e, n) {
    return e.era = n, t.setFullYear(n, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const j = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, ue = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function z(r, a) {
  return r && {
    value: a(r.value),
    rest: r.rest
  };
}
function q(r, a) {
  const t = a.match(r);
  return t ? {
    value: parseInt(t[0], 10),
    rest: a.slice(t[0].length)
  } : null;
}
function de(r, a) {
  const t = a.match(r);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: a.slice(1)
    };
  const e = t[1] === "+" ? 1 : -1, n = t[2] ? parseInt(t[2], 10) : 0, o = t[3] ? parseInt(t[3], 10) : 0, s = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: e * (n * Nt + o * Rt + s * Vr),
    rest: a.slice(t[0].length)
  };
}
function pr(r) {
  return q(j.anyDigitsSigned, r);
}
function $(r, a) {
  switch (r) {
    case 1:
      return q(j.singleDigit, a);
    case 2:
      return q(j.twoDigits, a);
    case 3:
      return q(j.threeDigits, a);
    case 4:
      return q(j.fourDigits, a);
    default:
      return q(new RegExp("^\\d{1," + r + "}"), a);
  }
}
function Ct(r, a) {
  switch (r) {
    case 1:
      return q(j.singleDigitSigned, a);
    case 2:
      return q(j.twoDigitsSigned, a);
    case 3:
      return q(j.threeDigitsSigned, a);
    case 4:
      return q(j.fourDigitsSigned, a);
    default:
      return q(new RegExp("^-?\\d{1," + r + "}"), a);
  }
}
function un(r) {
  switch (r) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function fr(r, a) {
  const t = a > 0, e = t ? a : 1 - a;
  let n;
  if (e <= 50)
    n = r || 100;
  else {
    const o = e + 50, s = Math.trunc(o / 100) * 100, i = r >= o % 100;
    n = r + s - (i ? 100 : 0);
  }
  return t ? n : 1 - n;
}
function hr(r) {
  return r % 400 === 0 || r % 4 === 0 && r % 100 !== 0;
}
class fa extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 130);
    y(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, e, n) {
    const o = (s) => ({
      year: s,
      isTwoDigitYear: e === "yy"
    });
    switch (e) {
      case "y":
        return z($(4, t), o);
      case "yo":
        return z(
          n.ordinalNumber(t, {
            unit: "year"
          }),
          o
        );
      default:
        return z($(e.length, t), o);
    }
  }
  validate(t, e) {
    return e.isTwoDigitYear || e.year > 0;
  }
  set(t, e, n) {
    const o = t.getFullYear();
    if (n.isTwoDigitYear) {
      const i = fr(
        n.year,
        o
      );
      return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const s = !("era" in e) || e.era === 1 ? n.year : 1 - n.year;
    return t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class ha extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 130);
    y(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, e, n) {
    const o = (s) => ({
      year: s,
      isTwoDigitYear: e === "YY"
    });
    switch (e) {
      case "Y":
        return z($(4, t), o);
      case "Yo":
        return z(
          n.ordinalNumber(t, {
            unit: "year"
          }),
          o
        );
      default:
        return z($(e.length, t), o);
    }
  }
  validate(t, e) {
    return e.isTwoDigitYear || e.year > 0;
  }
  set(t, e, n, o) {
    const s = Ur(t, o);
    if (n.isTwoDigitYear) {
      const c = fr(
        n.year,
        s
      );
      return t.setFullYear(
        c,
        0,
        o.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), wt(t, o);
    }
    const i = !("era" in e) || e.era === 1 ? n.year : 1 - n.year;
    return t.setFullYear(i, 0, o.firstWeekContainsDate), t.setHours(0, 0, 0, 0), wt(t, o);
  }
}
class ma extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 130);
    y(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e) {
    return Ct(e === "R" ? 4 : e.length, t);
  }
  set(t, e, n) {
    const o = X(t, 0);
    return o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0), or(o);
  }
}
class va extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 130);
    y(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, e) {
    return Ct(e === "u" ? 4 : e.length, t);
  }
  set(t, e, n) {
    return t.setFullYear(n, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class ga extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 120);
    y(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, n) {
    switch (e) {
      case "Q":
      case "QQ":
        return $(e.length, t);
      case "Qo":
        return n.ordinalNumber(t, { unit: "quarter" });
      case "QQQ":
        return n.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || n.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 4;
  }
  set(t, e, n) {
    return t.setMonth((n - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Da extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 120);
    y(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, n) {
    switch (e) {
      case "q":
      case "qq":
        return $(e.length, t);
      case "qo":
        return n.ordinalNumber(t, { unit: "quarter" });
      case "qqq":
        return n.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || n.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || n.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || n.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 4;
  }
  set(t, e, n) {
    return t.setMonth((n - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class wa extends F {
  constructor() {
    super(...arguments);
    y(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    y(this, "priority", 110);
  }
  parse(t, e, n) {
    const o = (s) => s - 1;
    switch (e) {
      case "M":
        return z(
          q(j.month, t),
          o
        );
      case "MM":
        return z($(2, t), o);
      case "Mo":
        return z(
          n.ordinalNumber(t, {
            unit: "month"
          }),
          o
        );
      case "MMM":
        return n.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.month(t, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return n.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(t, { width: "wide", context: "formatting" }) || n.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 11;
  }
  set(t, e, n) {
    return t.setMonth(n, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class ya extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 110);
    y(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, n) {
    const o = (s) => s - 1;
    switch (e) {
      case "L":
        return z(
          q(j.month, t),
          o
        );
      case "LL":
        return z($(2, t), o);
      case "Lo":
        return z(
          n.ordinalNumber(t, {
            unit: "month"
          }),
          o
        );
      case "LLL":
        return n.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || n.month(t, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return n.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(t, { width: "wide", context: "standalone" }) || n.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || n.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 11;
  }
  set(t, e, n) {
    return t.setMonth(n, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function ba(r, a, t) {
  const e = x(r), n = qr(e, t) - a;
  return e.setDate(e.getDate() - n * 7), e;
}
class _a extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 100);
    y(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, e, n) {
    switch (e) {
      case "w":
        return q(j.week, t);
      case "wo":
        return n.ordinalNumber(t, { unit: "week" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 53;
  }
  set(t, e, n, o) {
    return wt(ba(t, n, o), o);
  }
}
function ka(r, a) {
  const t = x(r), e = sr(t) - a;
  return t.setDate(t.getDate() - e * 7), t;
}
class xa extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 100);
    y(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, n) {
    switch (e) {
      case "I":
        return q(j.week, t);
      case "Io":
        return n.ordinalNumber(t, { unit: "week" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 53;
  }
  set(t, e, n) {
    return or(ka(t, n));
  }
}
const Ca = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Ma = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Sa extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 90);
    y(this, "subPriority", 1);
    y(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, n) {
    switch (e) {
      case "d":
        return q(j.date, t);
      case "do":
        return n.ordinalNumber(t, { unit: "date" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    const n = t.getFullYear(), o = hr(n), s = t.getMonth();
    return o ? e >= 1 && e <= Ma[s] : e >= 1 && e <= Ca[s];
  }
  set(t, e, n) {
    return t.setDate(n), t.setHours(0, 0, 0, 0), t;
  }
}
class Ea extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 90);
    y(this, "subpriority", 1);
    y(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, n) {
    switch (e) {
      case "D":
      case "DD":
        return q(j.dayOfYear, t);
      case "Do":
        return n.ordinalNumber(t, { unit: "date" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    const n = t.getFullYear();
    return hr(n) ? e >= 1 && e <= 366 : e >= 1 && e <= 365;
  }
  set(t, e, n) {
    return t.setMonth(0, n), t.setHours(0, 0, 0, 0), t;
  }
}
function dn(r, a, t) {
  var d, p, f, m;
  const e = on(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((p = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : p.weekStartsOn) ?? e.weekStartsOn ?? ((m = (f = e.locale) == null ? void 0 : f.options) == null ? void 0 : m.weekStartsOn) ?? 0, o = x(r), s = o.getDay(), c = (a % 7 + 7) % 7, l = 7 - n, u = a < 0 || a > 6 ? a - (s + l) % 7 : (c + l) % 7 - (s + l) % 7;
  return Le(o, u);
}
class Pa extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 90);
    y(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, e, n) {
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.day(t, { width: "short", context: "formatting" }) || n.day(t, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return n.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(t, { width: "short", context: "formatting" }) || n.day(t, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return n.day(t, { width: "wide", context: "formatting" }) || n.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.day(t, { width: "short", context: "formatting" }) || n.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 6;
  }
  set(t, e, n, o) {
    return t = dn(t, n, o), t.setHours(0, 0, 0, 0), t;
  }
}
class Oa extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 90);
    y(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, n, o) {
    const s = (i) => {
      const c = Math.floor((i - 1) / 7) * 7;
      return (i + o.weekStartsOn + 6) % 7 + c;
    };
    switch (e) {
      case "e":
      case "ee":
        return z($(e.length, t), s);
      case "eo":
        return z(
          n.ordinalNumber(t, {
            unit: "day"
          }),
          s
        );
      case "eee":
        return n.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.day(t, { width: "short", context: "formatting" }) || n.day(t, { width: "narrow", context: "formatting" });
      case "eeeee":
        return n.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(t, { width: "short", context: "formatting" }) || n.day(t, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return n.day(t, { width: "wide", context: "formatting" }) || n.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.day(t, { width: "short", context: "formatting" }) || n.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 6;
  }
  set(t, e, n, o) {
    return t = dn(t, n, o), t.setHours(0, 0, 0, 0), t;
  }
}
class Ta extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 90);
    y(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, e, n, o) {
    const s = (i) => {
      const c = Math.floor((i - 1) / 7) * 7;
      return (i + o.weekStartsOn + 6) % 7 + c;
    };
    switch (e) {
      case "c":
      case "cc":
        return z($(e.length, t), s);
      case "co":
        return z(
          n.ordinalNumber(t, {
            unit: "day"
          }),
          s
        );
      case "ccc":
        return n.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || n.day(t, { width: "short", context: "standalone" }) || n.day(t, { width: "narrow", context: "standalone" });
      case "ccccc":
        return n.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(t, { width: "short", context: "standalone" }) || n.day(t, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return n.day(t, { width: "wide", context: "standalone" }) || n.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || n.day(t, { width: "short", context: "standalone" }) || n.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 6;
  }
  set(t, e, n, o) {
    return t = dn(t, n, o), t.setHours(0, 0, 0, 0), t;
  }
}
function Na(r, a) {
  const t = x(r), e = sa(t), n = a - e;
  return Le(t, n);
}
class Ra extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 90);
    y(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, n) {
    const o = (s) => s === 0 ? 7 : s;
    switch (e) {
      case "i":
      case "ii":
        return $(e.length, t);
      case "io":
        return n.ordinalNumber(t, { unit: "day" });
      case "iii":
        return z(
          n.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || n.day(t, {
            width: "short",
            context: "formatting"
          }) || n.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiii":
        return z(
          n.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiiii":
        return z(
          n.day(t, {
            width: "short",
            context: "formatting"
          }) || n.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiii":
      default:
        return z(
          n.day(t, {
            width: "wide",
            context: "formatting"
          }) || n.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || n.day(t, {
            width: "short",
            context: "formatting"
          }) || n.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 7;
  }
  set(t, e, n) {
    return t = Na(t, n), t.setHours(0, 0, 0, 0), t;
  }
}
class Ya extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 80);
    y(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, e, n) {
    switch (e) {
      case "a":
      case "aa":
      case "aaa":
        return n.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, e, n) {
    return t.setHours(un(n), 0, 0, 0), t;
  }
}
class Ia extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 80);
    y(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, e, n) {
    switch (e) {
      case "b":
      case "bb":
      case "bbb":
        return n.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, e, n) {
    return t.setHours(un(n), 0, 0, 0), t;
  }
}
class La extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 80);
    y(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, e, n) {
    switch (e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, e, n) {
    return t.setHours(un(n), 0, 0, 0), t;
  }
}
class Aa extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 70);
    y(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, e, n) {
    switch (e) {
      case "h":
        return q(j.hour12h, t);
      case "ho":
        return n.ordinalNumber(t, { unit: "hour" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 12;
  }
  set(t, e, n) {
    const o = t.getHours() >= 12;
    return o && n < 12 ? t.setHours(n + 12, 0, 0, 0) : !o && n === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(n, 0, 0, 0), t;
  }
}
class Fa extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 70);
    y(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, e, n) {
    switch (e) {
      case "H":
        return q(j.hour23h, t);
      case "Ho":
        return n.ordinalNumber(t, { unit: "hour" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 23;
  }
  set(t, e, n) {
    return t.setHours(n, 0, 0, 0), t;
  }
}
class Ha extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 70);
    y(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, e, n) {
    switch (e) {
      case "K":
        return q(j.hour11h, t);
      case "Ko":
        return n.ordinalNumber(t, { unit: "hour" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 11;
  }
  set(t, e, n) {
    return t.getHours() >= 12 && n < 12 ? t.setHours(n + 12, 0, 0, 0) : t.setHours(n, 0, 0, 0), t;
  }
}
class Wa extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 70);
    y(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, e, n) {
    switch (e) {
      case "k":
        return q(j.hour24h, t);
      case "ko":
        return n.ordinalNumber(t, { unit: "hour" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 24;
  }
  set(t, e, n) {
    const o = n <= 24 ? n % 24 : n;
    return t.setHours(o, 0, 0, 0), t;
  }
}
class Ba extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 60);
    y(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, e, n) {
    switch (e) {
      case "m":
        return q(j.minute, t);
      case "mo":
        return n.ordinalNumber(t, { unit: "minute" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 59;
  }
  set(t, e, n) {
    return t.setMinutes(n, 0, 0), t;
  }
}
class Qa extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 50);
    y(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, e, n) {
    switch (e) {
      case "s":
        return q(j.second, t);
      case "so":
        return n.ordinalNumber(t, { unit: "second" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 59;
  }
  set(t, e, n) {
    return t.setSeconds(n, 0), t;
  }
}
class Ka extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 30);
    y(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, e) {
    const n = (o) => Math.trunc(o * Math.pow(10, -e.length + 3));
    return z($(e.length, t), n);
  }
  set(t, e, n) {
    return t.setMilliseconds(n), t;
  }
}
class Va extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 10);
    y(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, e) {
    switch (e) {
      case "X":
        return de(
          ue.basicOptionalMinutes,
          t
        );
      case "XX":
        return de(ue.basic, t);
      case "XXXX":
        return de(
          ue.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return de(
          ue.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return de(ue.extended, t);
    }
  }
  set(t, e, n) {
    return e.timestampIsSet ? t : X(
      t,
      t.getTime() - ir(t) - n
    );
  }
}
class Ua extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 10);
    y(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, e) {
    switch (e) {
      case "x":
        return de(
          ue.basicOptionalMinutes,
          t
        );
      case "xx":
        return de(ue.basic, t);
      case "xxxx":
        return de(
          ue.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return de(
          ue.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return de(ue.extended, t);
    }
  }
  set(t, e, n) {
    return e.timestampIsSet ? t : X(
      t,
      t.getTime() - ir(t) - n
    );
  }
}
class qa extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 40);
    y(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return pr(t);
  }
  set(t, e, n) {
    return [X(t, n * 1e3), { timestampIsSet: !0 }];
  }
}
class $a extends F {
  constructor() {
    super(...arguments);
    y(this, "priority", 20);
    y(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return pr(t);
  }
  set(t, e, n) {
    return [X(t, n), { timestampIsSet: !0 }];
  }
}
const ja = {
  G: new pa(),
  y: new fa(),
  Y: new ha(),
  R: new ma(),
  u: new va(),
  Q: new ga(),
  q: new Da(),
  M: new wa(),
  L: new ya(),
  w: new _a(),
  I: new xa(),
  d: new Sa(),
  D: new Ea(),
  E: new Pa(),
  e: new Oa(),
  c: new Ta(),
  i: new Ra(),
  a: new Ya(),
  b: new Ia(),
  B: new La(),
  h: new Aa(),
  H: new Fa(),
  K: new Ha(),
  k: new Wa(),
  m: new Ba(),
  s: new Qa(),
  S: new Ka(),
  X: new Va(),
  x: new Ua(),
  t: new qa(),
  T: new $a()
}, za = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Xa = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ga = /^'([^]*?)'?$/, Za = /''/g, Ja = /\S/, eo = /[a-zA-Z]/;
function Ft(r, a, t, e) {
  var g, v, D, C, b, P, E, A;
  const n = oa(), o = (e == null ? void 0 : e.locale) ?? n.locale ?? $r, s = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((v = (g = e == null ? void 0 : e.locale) == null ? void 0 : g.options) == null ? void 0 : v.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((C = (D = n.locale) == null ? void 0 : D.options) == null ? void 0 : C.firstWeekContainsDate) ?? 1, i = (e == null ? void 0 : e.weekStartsOn) ?? ((P = (b = e == null ? void 0 : e.locale) == null ? void 0 : b.options) == null ? void 0 : P.weekStartsOn) ?? n.weekStartsOn ?? ((A = (E = n.locale) == null ? void 0 : E.options) == null ? void 0 : A.weekStartsOn) ?? 0;
  if (a === "")
    return r === "" ? x(t) : X(t, NaN);
  const c = {
    firstWeekContainsDate: s,
    weekStartsOn: i,
    locale: o
  }, l = [new da()], u = a.match(Xa).map((_) => {
    const k = _[0];
    if (k in $t) {
      const M = $t[k];
      return M(_, o.formatLong);
    }
    return _;
  }).join("").match(za), d = [];
  for (let _ of u) {
    !(e != null && e.useAdditionalWeekYearTokens) && jr(_) && wn(_, a, r), !(e != null && e.useAdditionalDayOfYearTokens) && zr(_) && wn(_, a, r);
    const k = _[0], M = ja[k];
    if (M) {
      const { incompatibleTokens: V } = M;
      if (Array.isArray(V)) {
        const H = d.find(
          (Q) => V.includes(Q.token) || Q.token === k
        );
        if (H)
          throw new RangeError(
            `The format string mustn't contain \`${H.fullToken}\` and \`${_}\` at the same time`
          );
      } else if (M.incompatibleTokens === "*" && d.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${_}\` and any other token at the same time`
        );
      d.push({ token: k, fullToken: _ });
      const B = M.run(
        r,
        _,
        o.match,
        c
      );
      if (!B)
        return X(t, NaN);
      l.push(B.setter), r = B.rest;
    } else {
      if (k.match(eo))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + k + "`"
        );
      if (_ === "''" ? _ = "'" : k === "'" && (_ = to(_)), r.indexOf(_) === 0)
        r = r.slice(_.length);
      else
        return X(t, NaN);
    }
  }
  if (r.length > 0 && Ja.test(r))
    return X(t, NaN);
  const p = l.map((_) => _.priority).sort((_, k) => k - _).filter((_, k, M) => M.indexOf(_) === k).map(
    (_) => l.filter((k) => k.priority === _).sort((k, M) => M.subPriority - k.subPriority)
  ).map((_) => _[0]);
  let f = x(t);
  if (isNaN(f.getTime()))
    return X(t, NaN);
  const m = {};
  for (const _ of p) {
    if (!_.validate(f, c))
      return X(t, NaN);
    const k = _.set(f, m, c);
    Array.isArray(k) ? (f = k[0], Object.assign(m, k[1])) : f = k;
  }
  return X(t, f);
}
function to(r) {
  return r.match(Ga)[1].replace(Za, "'");
}
function no(r, a) {
  const t = x(r), e = x(a);
  return t.getFullYear() === e.getFullYear() && t.getMonth() === e.getMonth();
}
function ro(r, a) {
  const t = Gt(r), e = Gt(a);
  return +t == +e;
}
function ao(r, a) {
  const t = x(r), e = x(a);
  return t.getFullYear() === e.getFullYear();
}
function Ze(r, a) {
  const t = +x(r), [e, n] = [
    +x(a.start),
    +x(a.end)
  ].sort((o, s) => o - s);
  return t >= e && t <= n;
}
function oo(r, a) {
  const e = lo(r);
  let n;
  if (e.date) {
    const c = uo(e.date, 2);
    n = po(c.restDateString, c.year);
  }
  if (!n || isNaN(n.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const o = n.getTime();
  let s = 0, i;
  if (e.time && (s = fo(e.time), isNaN(s)))
    return /* @__PURE__ */ new Date(NaN);
  if (e.timezone) {
    if (i = ho(e.timezone), isNaN(i))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const c = new Date(o + s), l = /* @__PURE__ */ new Date(0);
    return l.setFullYear(
      c.getUTCFullYear(),
      c.getUTCMonth(),
      c.getUTCDate()
    ), l.setHours(
      c.getUTCHours(),
      c.getUTCMinutes(),
      c.getUTCSeconds(),
      c.getUTCMilliseconds()
    ), l;
  }
  return new Date(o + s + i);
}
const it = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, so = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, io = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, co = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function lo(r) {
  const a = {}, t = r.split(it.dateTimeDelimiter);
  let e;
  if (t.length > 2)
    return a;
  if (/:/.test(t[0]) ? e = t[0] : (a.date = t[0], e = t[1], it.timeZoneDelimiter.test(a.date) && (a.date = r.split(it.timeZoneDelimiter)[0], e = r.substr(
    a.date.length,
    r.length
  ))), e) {
    const n = it.timezone.exec(e);
    n ? (a.time = e.replace(n[1], ""), a.timezone = n[1]) : a.time = e;
  }
  return a;
}
function uo(r, a) {
  const t = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + a) + "})|(\\d{2}|[+-]\\d{" + (2 + a) + "})$)"
  ), e = r.match(t);
  if (!e) return { year: NaN, restDateString: "" };
  const n = e[1] ? parseInt(e[1]) : null, o = e[2] ? parseInt(e[2]) : null;
  return {
    year: o === null ? n : o * 100,
    restDateString: r.slice((e[1] || e[2]).length)
  };
}
function po(r, a) {
  if (a === null) return /* @__PURE__ */ new Date(NaN);
  const t = r.match(so);
  if (!t) return /* @__PURE__ */ new Date(NaN);
  const e = !!t[4], n = qe(t[1]), o = qe(t[2]) - 1, s = qe(t[3]), i = qe(t[4]), c = qe(t[5]) - 1;
  if (e)
    return wo(a, i, c) ? mo(a, i, c) : /* @__PURE__ */ new Date(NaN);
  {
    const l = /* @__PURE__ */ new Date(0);
    return !go(a, o, s) || !Do(a, n) ? /* @__PURE__ */ new Date(NaN) : (l.setUTCFullYear(a, o, Math.max(n, s)), l);
  }
}
function qe(r) {
  return r ? parseInt(r) : 1;
}
function fo(r) {
  const a = r.match(io);
  if (!a) return NaN;
  const t = Ht(a[1]), e = Ht(a[2]), n = Ht(a[3]);
  return yo(t, e, n) ? t * Nt + e * Rt + n * 1e3 : NaN;
}
function Ht(r) {
  return r && parseFloat(r.replace(",", ".")) || 0;
}
function ho(r) {
  if (r === "Z") return 0;
  const a = r.match(co);
  if (!a) return 0;
  const t = a[1] === "+" ? -1 : 1, e = parseInt(a[2]), n = a[3] && parseInt(a[3]) || 0;
  return bo(e, n) ? t * (e * Nt + n * Rt) : NaN;
}
function mo(r, a, t) {
  const e = /* @__PURE__ */ new Date(0);
  e.setUTCFullYear(r, 0, 4);
  const n = e.getUTCDay() || 7, o = (a - 1) * 7 + t + 1 - n;
  return e.setUTCDate(e.getUTCDate() + o), e;
}
const vo = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function mr(r) {
  return r % 400 === 0 || r % 4 === 0 && r % 100 !== 0;
}
function go(r, a, t) {
  return a >= 0 && a <= 11 && t >= 1 && t <= (vo[a] || (mr(r) ? 29 : 28));
}
function Do(r, a) {
  return a >= 1 && a <= (mr(r) ? 366 : 365);
}
function wo(r, a, t) {
  return a >= 1 && a <= 53 && t >= 0 && t <= 6;
}
function yo(r, a, t) {
  return r === 24 ? a === 0 && t === 0 : t >= 0 && t < 60 && a >= 0 && a < 60 && r >= 0 && r < 25;
}
function bo(r, a) {
  return a >= 0 && a <= 59;
}
function ae(r, a) {
  const t = x(r), e = t.getFullYear(), n = t.getDate(), o = X(r, 0);
  o.setFullYear(e, a, 15), o.setHours(0, 0, 0, 0);
  const s = aa(o);
  return t.setMonth(a, Math.min(n, s)), t;
}
function _o(r, a) {
  let t = x(r);
  return isNaN(+t) ? X(r, NaN) : (a.year != null && t.setFullYear(a.year), a.month != null && (t = ae(t, a.month)), a.date != null && t.setDate(a.date), a.hours != null && t.setHours(a.hours), a.minutes != null && t.setMinutes(a.minutes), a.seconds != null && t.setSeconds(a.seconds), a.milliseconds != null && t.setMilliseconds(a.milliseconds), t);
}
function ht(r, a) {
  const t = x(r);
  return t.setHours(a), t;
}
function mt(r, a) {
  const t = x(r);
  return t.setMinutes(a), t;
}
function Ae(r, a) {
  const t = x(r), e = Math.trunc(t.getMonth() / 3) + 1, n = a - e;
  return ae(t, t.getMonth() + n * 3);
}
function vt(r, a) {
  const t = x(r);
  return t.setSeconds(a), t;
}
function ce(r, a) {
  const t = x(r);
  return isNaN(+t) ? X(r, NaN) : (t.setFullYear(a), t);
}
function vr(r, a) {
  return ln(r, -a);
}
function kn(r, a) {
  return bt(r, -a);
}
function Be(r, a) {
  return De(r, -a);
}
function gr(r) {
  var a, t, e = "";
  if (typeof r == "string" || typeof r == "number") e += r;
  else if (typeof r == "object") if (Array.isArray(r)) {
    var n = r.length;
    for (a = 0; a < n; a++) r[a] && (t = gr(r[a])) && (e && (e += " "), e += t);
  } else for (t in r) r[t] && (e && (e += " "), e += t);
  return e;
}
function Z() {
  for (var r, a, t = 0, e = "", n = arguments.length; t < n; t++) (r = arguments[t]) && (a = gr(r)) && (e && (e += " "), e += a);
  return e;
}
function ko(r, a) {
  r.prototype = Object.create(a.prototype), r.prototype.constructor = r, Jt(r, a);
}
function Jt(r, a) {
  return Jt = Object.setPrototypeOf || function(e, n) {
    return e.__proto__ = n, e;
  }, Jt(r, a);
}
function xo(r, a) {
  if (r == null) return {};
  var t = {}, e = Object.keys(r), n, o;
  for (o = 0; o < e.length; o++)
    n = e[o], !(a.indexOf(n) >= 0) && (t[n] = r[n]);
  return t;
}
function xn(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function Co(r, a, t) {
  return r === a ? !0 : r.correspondingElement ? r.correspondingElement.classList.contains(t) : r.classList.contains(t);
}
function Mo(r, a, t) {
  if (r === a)
    return !0;
  for (; r.parentNode || r.host; ) {
    if (r.parentNode && Co(r, a, t))
      return !0;
    r = r.parentNode || r.host;
  }
  return r;
}
function So(r) {
  return document.documentElement.clientWidth <= r.clientX || document.documentElement.clientHeight <= r.clientY;
}
var Eo = function() {
  if (!(typeof window > "u" || typeof window.addEventListener != "function")) {
    var a = !1, t = Object.defineProperty({}, "passive", {
      get: function() {
        a = !0;
      }
    }), e = function() {
    };
    return window.addEventListener("testPassiveEventSupport", e, t), window.removeEventListener("testPassiveEventSupport", e, t), a;
  }
};
function Po(r) {
  return r === void 0 && (r = 0), function() {
    return ++r;
  };
}
var Oo = Po(), en, ct = {}, Wt = {}, To = ["touchstart", "touchmove"], No = "ignore-react-onclickoutside";
function Cn(r, a) {
  var t = {}, e = To.indexOf(a) !== -1;
  return e && en && (t.passive = !r.props.preventDefault), t;
}
function Yt(r, a) {
  var t, e, n = r.displayName || r.name || "Component";
  return e = t = /* @__PURE__ */ function(o) {
    ko(s, o);
    function s(c) {
      var l;
      return l = o.call(this, c) || this, l.__outsideClickHandler = function(u) {
        if (typeof l.__clickOutsideHandlerProp == "function") {
          l.__clickOutsideHandlerProp(u);
          return;
        }
        var d = l.getInstance();
        if (typeof d.props.handleClickOutside == "function") {
          d.props.handleClickOutside(u);
          return;
        }
        if (typeof d.handleClickOutside == "function") {
          d.handleClickOutside(u);
          return;
        }
        throw new Error("WrappedComponent: " + n + " lacks a handleClickOutside(event) function for processing outside click events.");
      }, l.__getComponentNode = function() {
        var u = l.getInstance();
        return typeof u.setClickOutsideRef == "function" ? u.setClickOutsideRef() : ar.findDOMNode(u);
      }, l.enableOnClickOutside = function() {
        if (!(typeof document > "u" || Wt[l._uid])) {
          typeof en > "u" && (en = Eo()), Wt[l._uid] = !0;
          var u = l.props.eventTypes;
          u.forEach || (u = [u]), ct[l._uid] = function(d) {
            if (l.componentNode !== null && !(l.initTimeStamp > d.timeStamp) && (l.props.preventDefault && d.preventDefault(), l.props.stopPropagation && d.stopPropagation(), !(l.props.excludeScrollbar && So(d)))) {
              var p = d.composed && d.composedPath && d.composedPath().shift() || d.target;
              Mo(p, l.componentNode, l.props.outsideClickIgnoreClass) === document && l.__outsideClickHandler(d);
            }
          }, u.forEach(function(d) {
            document.addEventListener(d, ct[l._uid], Cn(xn(l), d));
          });
        }
      }, l.disableOnClickOutside = function() {
        delete Wt[l._uid];
        var u = ct[l._uid];
        if (u && typeof document < "u") {
          var d = l.props.eventTypes;
          d.forEach || (d = [d]), d.forEach(function(p) {
            return document.removeEventListener(p, u, Cn(xn(l), p));
          }), delete ct[l._uid];
        }
      }, l.getRef = function(u) {
        return l.instanceRef = u;
      }, l._uid = Oo(), l.initTimeStamp = performance.now(), l;
    }
    var i = s.prototype;
    return i.getInstance = function() {
      if (r.prototype && !r.prototype.isReactComponent)
        return this;
      var l = this.instanceRef;
      return l.getInstance ? l.getInstance() : l;
    }, i.componentDidMount = function() {
      typeof document > "u" || !document.createElement || (this.getInstance(), this.componentNode = this.__getComponentNode(), !this.props.disableOnClickOutside && this.enableOnClickOutside());
    }, i.componentDidUpdate = function() {
      this.componentNode = this.__getComponentNode();
    }, i.componentWillUnmount = function() {
      this.disableOnClickOutside();
    }, i.render = function() {
      var l = this.props;
      l.excludeScrollbar;
      var u = xo(l, ["excludeScrollbar"]);
      return r.prototype && r.prototype.isReactComponent ? u.ref = this.getRef : u.wrappedRef = this.getRef, u.disableOnClickOutside = this.disableOnClickOutside, u.enableOnClickOutside = this.enableOnClickOutside, Jn(r, u);
    }, s;
  }(G), t.displayName = "OnClickOutside(" + n + ")", t.defaultProps = {
    eventTypes: ["mousedown", "touchstart"],
    excludeScrollbar: !1,
    outsideClickIgnoreClass: No,
    preventDefault: !1,
    stopPropagation: !1
  }, t.getClass = function() {
    return r.getClass ? r.getClass() : r;
  }, e;
}
function Ue(r) {
  return Dr(r) ? (r.nodeName || "").toLowerCase() : "#document";
}
function oe(r) {
  var a;
  return (r == null || (a = r.ownerDocument) == null ? void 0 : a.defaultView) || window;
}
function ye(r) {
  var a;
  return (a = (Dr(r) ? r.ownerDocument : r.document) || window.document) == null ? void 0 : a.documentElement;
}
function Dr(r) {
  return r instanceof Node || r instanceof oe(r).Node;
}
function te(r) {
  return r instanceof Element || r instanceof oe(r).Element;
}
function ve(r) {
  return r instanceof HTMLElement || r instanceof oe(r).HTMLElement;
}
function Mn(r) {
  return typeof ShadowRoot > "u" ? !1 : r instanceof ShadowRoot || r instanceof oe(r).ShadowRoot;
}
function nt(r) {
  const {
    overflow: a,
    overflowX: t,
    overflowY: e,
    display: n
  } = ie(r);
  return /auto|scroll|overlay|hidden|clip/.test(a + e + t) && !["inline", "contents"].includes(n);
}
function Ro(r) {
  return ["table", "td", "th"].includes(Ue(r));
}
function It(r) {
  return [":popover-open", ":modal"].some((a) => {
    try {
      return r.matches(a);
    } catch {
      return !1;
    }
  });
}
function pn(r) {
  const a = fn(), t = te(r) ? ie(r) : r;
  return t.transform !== "none" || t.perspective !== "none" || (t.containerType ? t.containerType !== "normal" : !1) || !a && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !a && (t.filter ? t.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((e) => (t.willChange || "").includes(e)) || ["paint", "layout", "strict", "content"].some((e) => (t.contain || "").includes(e));
}
function Yo(r) {
  let a = Ee(r);
  for (; ve(a) && !Qe(a); ) {
    if (pn(a))
      return a;
    if (It(a))
      return null;
    a = Ee(a);
  }
  return null;
}
function fn() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Qe(r) {
  return ["html", "body", "#document"].includes(Ue(r));
}
function ie(r) {
  return oe(r).getComputedStyle(r);
}
function Lt(r) {
  return te(r) ? {
    scrollLeft: r.scrollLeft,
    scrollTop: r.scrollTop
  } : {
    scrollLeft: r.scrollX,
    scrollTop: r.scrollY
  };
}
function Ee(r) {
  if (Ue(r) === "html")
    return r;
  const a = (
    // Step into the shadow DOM of the parent of a slotted node.
    r.assignedSlot || // DOM Element detected.
    r.parentNode || // ShadowRoot detected.
    Mn(r) && r.host || // Fallback.
    ye(r)
  );
  return Mn(a) ? a.host : a;
}
function wr(r) {
  const a = Ee(r);
  return Qe(a) ? r.ownerDocument ? r.ownerDocument.body : r.body : ve(a) && nt(a) ? a : wr(a);
}
function Je(r, a, t) {
  var e;
  a === void 0 && (a = []), t === void 0 && (t = !0);
  const n = wr(r), o = n === ((e = r.ownerDocument) == null ? void 0 : e.body), s = oe(n);
  return o ? a.concat(s, s.visualViewport || [], nt(n) ? n : [], s.frameElement && t ? Je(s.frameElement) : []) : a.concat(n, Je(n, [], t));
}
const Ke = Math.min, Ne = Math.max, Mt = Math.round, lt = Math.floor, Pe = (r) => ({
  x: r,
  y: r
}), Io = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Lo = {
  start: "end",
  end: "start"
};
function Ao(r, a, t) {
  return Ne(r, Ke(a, t));
}
function At(r, a) {
  return typeof r == "function" ? r(a) : r;
}
function Ve(r) {
  return r.split("-")[0];
}
function rt(r) {
  return r.split("-")[1];
}
function Fo(r) {
  return r === "x" ? "y" : "x";
}
function hn(r) {
  return r === "y" ? "height" : "width";
}
function et(r) {
  return ["top", "bottom"].includes(Ve(r)) ? "y" : "x";
}
function mn(r) {
  return Fo(et(r));
}
function Ho(r, a, t) {
  t === void 0 && (t = !1);
  const e = rt(r), n = mn(r), o = hn(n);
  let s = n === "x" ? e === (t ? "end" : "start") ? "right" : "left" : e === "start" ? "bottom" : "top";
  return a.reference[o] > a.floating[o] && (s = St(s)), [s, St(s)];
}
function Wo(r) {
  const a = St(r);
  return [tn(r), a, tn(a)];
}
function tn(r) {
  return r.replace(/start|end/g, (a) => Lo[a]);
}
function Bo(r, a, t) {
  const e = ["left", "right"], n = ["right", "left"], o = ["top", "bottom"], s = ["bottom", "top"];
  switch (r) {
    case "top":
    case "bottom":
      return t ? a ? n : e : a ? e : n;
    case "left":
    case "right":
      return a ? o : s;
    default:
      return [];
  }
}
function Qo(r, a, t, e) {
  const n = rt(r);
  let o = Bo(Ve(r), t === "start", e);
  return n && (o = o.map((s) => s + "-" + n), a && (o = o.concat(o.map(tn)))), o;
}
function St(r) {
  return r.replace(/left|right|bottom|top/g, (a) => Io[a]);
}
function Ko(r) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...r
  };
}
function yr(r) {
  return typeof r != "number" ? Ko(r) : {
    top: r,
    right: r,
    bottom: r,
    left: r
  };
}
function Et(r) {
  const {
    x: a,
    y: t,
    width: e,
    height: n
  } = r;
  return {
    width: e,
    height: n,
    top: t,
    left: a,
    right: a + e,
    bottom: t + n,
    x: a,
    y: t
  };
}
function Sn(r, a, t) {
  let {
    reference: e,
    floating: n
  } = r;
  const o = et(a), s = mn(a), i = hn(s), c = Ve(a), l = o === "y", u = e.x + e.width / 2 - n.width / 2, d = e.y + e.height / 2 - n.height / 2, p = e[i] / 2 - n[i] / 2;
  let f;
  switch (c) {
    case "top":
      f = {
        x: u,
        y: e.y - n.height
      };
      break;
    case "bottom":
      f = {
        x: u,
        y: e.y + e.height
      };
      break;
    case "right":
      f = {
        x: e.x + e.width,
        y: d
      };
      break;
    case "left":
      f = {
        x: e.x - n.width,
        y: d
      };
      break;
    default:
      f = {
        x: e.x,
        y: e.y
      };
  }
  switch (rt(a)) {
    case "start":
      f[s] -= p * (t && l ? -1 : 1);
      break;
    case "end":
      f[s] += p * (t && l ? -1 : 1);
      break;
  }
  return f;
}
const Vo = async (r, a, t) => {
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: s
  } = t, i = o.filter(Boolean), c = await (s.isRTL == null ? void 0 : s.isRTL(a));
  let l = await s.getElementRects({
    reference: r,
    floating: a,
    strategy: n
  }), {
    x: u,
    y: d
  } = Sn(l, e, c), p = e, f = {}, m = 0;
  for (let g = 0; g < i.length; g++) {
    const {
      name: v,
      fn: D
    } = i[g], {
      x: C,
      y: b,
      data: P,
      reset: E
    } = await D({
      x: u,
      y: d,
      initialPlacement: e,
      placement: p,
      strategy: n,
      middlewareData: f,
      rects: l,
      platform: s,
      elements: {
        reference: r,
        floating: a
      }
    });
    u = C ?? u, d = b ?? d, f = {
      ...f,
      [v]: {
        ...f[v],
        ...P
      }
    }, E && m <= 50 && (m++, typeof E == "object" && (E.placement && (p = E.placement), E.rects && (l = E.rects === !0 ? await s.getElementRects({
      reference: r,
      floating: a,
      strategy: n
    }) : E.rects), {
      x: u,
      y: d
    } = Sn(l, p, c)), g = -1);
  }
  return {
    x: u,
    y: d,
    placement: p,
    strategy: n,
    middlewareData: f
  };
};
async function Uo(r, a) {
  var t;
  a === void 0 && (a = {});
  const {
    x: e,
    y: n,
    platform: o,
    rects: s,
    elements: i,
    strategy: c
  } = r, {
    boundary: l = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: p = !1,
    padding: f = 0
  } = At(a, r), m = yr(f), v = i[p ? d === "floating" ? "reference" : "floating" : d], D = Et(await o.getClippingRect({
    element: (t = await (o.isElement == null ? void 0 : o.isElement(v))) == null || t ? v : v.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(i.floating)),
    boundary: l,
    rootBoundary: u,
    strategy: c
  })), C = d === "floating" ? {
    x: e,
    y: n,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, b = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(i.floating)), P = await (o.isElement == null ? void 0 : o.isElement(b)) ? await (o.getScale == null ? void 0 : o.getScale(b)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, E = Et(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: C,
    offsetParent: b,
    strategy: c
  }) : C);
  return {
    top: (D.top - E.top + m.top) / P.y,
    bottom: (E.bottom - D.bottom + m.bottom) / P.y,
    left: (D.left - E.left + m.left) / P.x,
    right: (E.right - D.right + m.right) / P.x
  };
}
const qo = (r) => ({
  name: "arrow",
  options: r,
  async fn(a) {
    const {
      x: t,
      y: e,
      placement: n,
      rects: o,
      platform: s,
      elements: i,
      middlewareData: c
    } = a, {
      element: l,
      padding: u = 0
    } = At(r, a) || {};
    if (l == null)
      return {};
    const d = yr(u), p = {
      x: t,
      y: e
    }, f = mn(n), m = hn(f), g = await s.getDimensions(l), v = f === "y", D = v ? "top" : "left", C = v ? "bottom" : "right", b = v ? "clientHeight" : "clientWidth", P = o.reference[m] + o.reference[f] - p[f] - o.floating[m], E = p[f] - o.reference[f], A = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(l));
    let _ = A ? A[b] : 0;
    (!_ || !await (s.isElement == null ? void 0 : s.isElement(A))) && (_ = i.floating[b] || o.floating[m]);
    const k = P / 2 - E / 2, M = _ / 2 - g[m] / 2 - 1, V = Ke(d[D], M), B = Ke(d[C], M), H = V, Q = _ - g[m] - B, T = _ / 2 - g[m] / 2 + k, O = Ao(H, T, Q), Y = !c.arrow && rt(n) != null && T !== O && o.reference[m] / 2 - (T < H ? V : B) - g[m] / 2 < 0, N = Y ? T < H ? T - H : T - Q : 0;
    return {
      [f]: p[f] + N,
      data: {
        [f]: O,
        centerOffset: T - O - N,
        ...Y && {
          alignmentOffset: N
        }
      },
      reset: Y
    };
  }
}), $o = function(r) {
  return r === void 0 && (r = {}), {
    name: "flip",
    options: r,
    async fn(a) {
      var t, e;
      const {
        placement: n,
        middlewareData: o,
        rects: s,
        initialPlacement: i,
        platform: c,
        elements: l
      } = a, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: p,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: g = !0,
        ...v
      } = At(r, a);
      if ((t = o.arrow) != null && t.alignmentOffset)
        return {};
      const D = Ve(n), C = et(i), b = Ve(i) === i, P = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), E = p || (b || !g ? [St(i)] : Wo(i)), A = m !== "none";
      !p && A && E.push(...Qo(i, g, m, P));
      const _ = [i, ...E], k = await Uo(a, v), M = [];
      let V = ((e = o.flip) == null ? void 0 : e.overflows) || [];
      if (u && M.push(k[D]), d) {
        const T = Ho(n, s, P);
        M.push(k[T[0]], k[T[1]]);
      }
      if (V = [...V, {
        placement: n,
        overflows: M
      }], !M.every((T) => T <= 0)) {
        var B, H;
        const T = (((B = o.flip) == null ? void 0 : B.index) || 0) + 1, O = _[T];
        if (O)
          return {
            data: {
              index: T,
              overflows: V
            },
            reset: {
              placement: O
            }
          };
        let Y = (H = V.filter((N) => N.overflows[0] <= 0).sort((N, ee) => N.overflows[1] - ee.overflows[1])[0]) == null ? void 0 : H.placement;
        if (!Y)
          switch (f) {
            case "bestFit": {
              var Q;
              const N = (Q = V.filter((ee) => {
                if (A) {
                  const K = et(ee.placement);
                  return K === C || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  K === "y";
                }
                return !0;
              }).map((ee) => [ee.placement, ee.overflows.filter((K) => K > 0).reduce((K, Ar) => K + Ar, 0)]).sort((ee, K) => ee[1] - K[1])[0]) == null ? void 0 : Q[0];
              N && (Y = N);
              break;
            }
            case "initialPlacement":
              Y = i;
              break;
          }
        if (n !== Y)
          return {
            reset: {
              placement: Y
            }
          };
      }
      return {};
    }
  };
};
async function jo(r, a) {
  const {
    placement: t,
    platform: e,
    elements: n
  } = r, o = await (e.isRTL == null ? void 0 : e.isRTL(n.floating)), s = Ve(t), i = rt(t), c = et(t) === "y", l = ["left", "top"].includes(s) ? -1 : 1, u = o && c ? -1 : 1, d = At(a, r);
  let {
    mainAxis: p,
    crossAxis: f,
    alignmentAxis: m
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return i && typeof m == "number" && (f = i === "end" ? m * -1 : m), c ? {
    x: f * u,
    y: p * l
  } : {
    x: p * l,
    y: f * u
  };
}
const zo = function(r) {
  return r === void 0 && (r = 0), {
    name: "offset",
    options: r,
    async fn(a) {
      var t, e;
      const {
        x: n,
        y: o,
        placement: s,
        middlewareData: i
      } = a, c = await jo(a, r);
      return s === ((t = i.offset) == null ? void 0 : t.placement) && (e = i.arrow) != null && e.alignmentOffset ? {} : {
        x: n + c.x,
        y: o + c.y,
        data: {
          ...c,
          placement: s
        }
      };
    }
  };
};
function br(r) {
  const a = ie(r);
  let t = parseFloat(a.width) || 0, e = parseFloat(a.height) || 0;
  const n = ve(r), o = n ? r.offsetWidth : t, s = n ? r.offsetHeight : e, i = Mt(t) !== o || Mt(e) !== s;
  return i && (t = o, e = s), {
    width: t,
    height: e,
    $: i
  };
}
function vn(r) {
  return te(r) ? r : r.contextElement;
}
function Fe(r) {
  const a = vn(r);
  if (!ve(a))
    return Pe(1);
  const t = a.getBoundingClientRect(), {
    width: e,
    height: n,
    $: o
  } = br(a);
  let s = (o ? Mt(t.width) : t.width) / e, i = (o ? Mt(t.height) : t.height) / n;
  return (!s || !Number.isFinite(s)) && (s = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: s,
    y: i
  };
}
const Xo = /* @__PURE__ */ Pe(0);
function _r(r) {
  const a = oe(r);
  return !fn() || !a.visualViewport ? Xo : {
    x: a.visualViewport.offsetLeft,
    y: a.visualViewport.offsetTop
  };
}
function Go(r, a, t) {
  return a === void 0 && (a = !1), !t || a && t !== oe(r) ? !1 : a;
}
function Ie(r, a, t, e) {
  a === void 0 && (a = !1), t === void 0 && (t = !1);
  const n = r.getBoundingClientRect(), o = vn(r);
  let s = Pe(1);
  a && (e ? te(e) && (s = Fe(e)) : s = Fe(r));
  const i = Go(o, t, e) ? _r(o) : Pe(0);
  let c = (n.left + i.x) / s.x, l = (n.top + i.y) / s.y, u = n.width / s.x, d = n.height / s.y;
  if (o) {
    const p = oe(o), f = e && te(e) ? oe(e) : e;
    let m = p, g = m.frameElement;
    for (; g && e && f !== m; ) {
      const v = Fe(g), D = g.getBoundingClientRect(), C = ie(g), b = D.left + (g.clientLeft + parseFloat(C.paddingLeft)) * v.x, P = D.top + (g.clientTop + parseFloat(C.paddingTop)) * v.y;
      c *= v.x, l *= v.y, u *= v.x, d *= v.y, c += b, l += P, m = oe(g), g = m.frameElement;
    }
  }
  return Et({
    width: u,
    height: d,
    x: c,
    y: l
  });
}
function Zo(r) {
  let {
    elements: a,
    rect: t,
    offsetParent: e,
    strategy: n
  } = r;
  const o = n === "fixed", s = ye(e), i = a ? It(a.floating) : !1;
  if (e === s || i && o)
    return t;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = Pe(1);
  const u = Pe(0), d = ve(e);
  if ((d || !d && !o) && ((Ue(e) !== "body" || nt(s)) && (c = Lt(e)), ve(e))) {
    const p = Ie(e);
    l = Fe(e), u.x = p.x + e.clientLeft, u.y = p.y + e.clientTop;
  }
  return {
    width: t.width * l.x,
    height: t.height * l.y,
    x: t.x * l.x - c.scrollLeft * l.x + u.x,
    y: t.y * l.y - c.scrollTop * l.y + u.y
  };
}
function Jo(r) {
  return Array.from(r.getClientRects());
}
function kr(r) {
  return Ie(ye(r)).left + Lt(r).scrollLeft;
}
function es(r) {
  const a = ye(r), t = Lt(r), e = r.ownerDocument.body, n = Ne(a.scrollWidth, a.clientWidth, e.scrollWidth, e.clientWidth), o = Ne(a.scrollHeight, a.clientHeight, e.scrollHeight, e.clientHeight);
  let s = -t.scrollLeft + kr(r);
  const i = -t.scrollTop;
  return ie(e).direction === "rtl" && (s += Ne(a.clientWidth, e.clientWidth) - n), {
    width: n,
    height: o,
    x: s,
    y: i
  };
}
function ts(r, a) {
  const t = oe(r), e = ye(r), n = t.visualViewport;
  let o = e.clientWidth, s = e.clientHeight, i = 0, c = 0;
  if (n) {
    o = n.width, s = n.height;
    const l = fn();
    (!l || l && a === "fixed") && (i = n.offsetLeft, c = n.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: i,
    y: c
  };
}
function ns(r, a) {
  const t = Ie(r, !0, a === "fixed"), e = t.top + r.clientTop, n = t.left + r.clientLeft, o = ve(r) ? Fe(r) : Pe(1), s = r.clientWidth * o.x, i = r.clientHeight * o.y, c = n * o.x, l = e * o.y;
  return {
    width: s,
    height: i,
    x: c,
    y: l
  };
}
function En(r, a, t) {
  let e;
  if (a === "viewport")
    e = ts(r, t);
  else if (a === "document")
    e = es(ye(r));
  else if (te(a))
    e = ns(a, t);
  else {
    const n = _r(r);
    e = {
      ...a,
      x: a.x - n.x,
      y: a.y - n.y
    };
  }
  return Et(e);
}
function xr(r, a) {
  const t = Ee(r);
  return t === a || !te(t) || Qe(t) ? !1 : ie(t).position === "fixed" || xr(t, a);
}
function rs(r, a) {
  const t = a.get(r);
  if (t)
    return t;
  let e = Je(r, [], !1).filter((i) => te(i) && Ue(i) !== "body"), n = null;
  const o = ie(r).position === "fixed";
  let s = o ? Ee(r) : r;
  for (; te(s) && !Qe(s); ) {
    const i = ie(s), c = pn(s);
    !c && i.position === "fixed" && (n = null), (o ? !c && !n : !c && i.position === "static" && !!n && ["absolute", "fixed"].includes(n.position) || nt(s) && !c && xr(r, s)) ? e = e.filter((u) => u !== s) : n = i, s = Ee(s);
  }
  return a.set(r, e), e;
}
function as(r) {
  let {
    element: a,
    boundary: t,
    rootBoundary: e,
    strategy: n
  } = r;
  const s = [...t === "clippingAncestors" ? It(a) ? [] : rs(a, this._c) : [].concat(t), e], i = s[0], c = s.reduce((l, u) => {
    const d = En(a, u, n);
    return l.top = Ne(d.top, l.top), l.right = Ke(d.right, l.right), l.bottom = Ke(d.bottom, l.bottom), l.left = Ne(d.left, l.left), l;
  }, En(a, i, n));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function os(r) {
  const {
    width: a,
    height: t
  } = br(r);
  return {
    width: a,
    height: t
  };
}
function ss(r, a, t) {
  const e = ve(a), n = ye(a), o = t === "fixed", s = Ie(r, !0, o, a);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Pe(0);
  if (e || !e && !o)
    if ((Ue(a) !== "body" || nt(n)) && (i = Lt(a)), e) {
      const d = Ie(a, !0, o, a);
      c.x = d.x + a.clientLeft, c.y = d.y + a.clientTop;
    } else n && (c.x = kr(n));
  const l = s.left + i.scrollLeft - c.x, u = s.top + i.scrollTop - c.y;
  return {
    x: l,
    y: u,
    width: s.width,
    height: s.height
  };
}
function Bt(r) {
  return ie(r).position === "static";
}
function Pn(r, a) {
  return !ve(r) || ie(r).position === "fixed" ? null : a ? a(r) : r.offsetParent;
}
function Cr(r, a) {
  const t = oe(r);
  if (It(r))
    return t;
  if (!ve(r)) {
    let n = Ee(r);
    for (; n && !Qe(n); ) {
      if (te(n) && !Bt(n))
        return n;
      n = Ee(n);
    }
    return t;
  }
  let e = Pn(r, a);
  for (; e && Ro(e) && Bt(e); )
    e = Pn(e, a);
  return e && Qe(e) && Bt(e) && !pn(e) ? t : e || Yo(r) || t;
}
const is = async function(r) {
  const a = this.getOffsetParent || Cr, t = this.getDimensions, e = await t(r.floating);
  return {
    reference: ss(r.reference, await a(r.floating), r.strategy),
    floating: {
      x: 0,
      y: 0,
      width: e.width,
      height: e.height
    }
  };
};
function cs(r) {
  return ie(r).direction === "rtl";
}
const ls = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Zo,
  getDocumentElement: ye,
  getClippingRect: as,
  getOffsetParent: Cr,
  getElementRects: is,
  getClientRects: Jo,
  getDimensions: os,
  getScale: Fe,
  isElement: te,
  isRTL: cs
};
function us(r, a) {
  let t = null, e;
  const n = ye(r);
  function o() {
    var i;
    clearTimeout(e), (i = t) == null || i.disconnect(), t = null;
  }
  function s(i, c) {
    i === void 0 && (i = !1), c === void 0 && (c = 1), o();
    const {
      left: l,
      top: u,
      width: d,
      height: p
    } = r.getBoundingClientRect();
    if (i || a(), !d || !p)
      return;
    const f = lt(u), m = lt(n.clientWidth - (l + d)), g = lt(n.clientHeight - (u + p)), v = lt(l), C = {
      rootMargin: -f + "px " + -m + "px " + -g + "px " + -v + "px",
      threshold: Ne(0, Ke(1, c)) || 1
    };
    let b = !0;
    function P(E) {
      const A = E[0].intersectionRatio;
      if (A !== c) {
        if (!b)
          return s();
        A ? s(!1, A) : e = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      b = !1;
    }
    try {
      t = new IntersectionObserver(P, {
        ...C,
        // Handle <iframe>s
        root: n.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(P, C);
    }
    t.observe(r);
  }
  return s(!0), o;
}
function ds(r, a, t, e) {
  e === void 0 && (e = {});
  const {
    ancestorScroll: n = !0,
    ancestorResize: o = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = e, l = vn(r), u = n || o ? [...l ? Je(l) : [], ...Je(a)] : [];
  u.forEach((D) => {
    n && D.addEventListener("scroll", t, {
      passive: !0
    }), o && D.addEventListener("resize", t);
  });
  const d = l && i ? us(l, t) : null;
  let p = -1, f = null;
  s && (f = new ResizeObserver((D) => {
    let [C] = D;
    C && C.target === l && f && (f.unobserve(a), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var b;
      (b = f) == null || b.observe(a);
    })), t();
  }), l && !c && f.observe(l), f.observe(a));
  let m, g = c ? Ie(r) : null;
  c && v();
  function v() {
    const D = Ie(r);
    g && (D.x !== g.x || D.y !== g.y || D.width !== g.width || D.height !== g.height) && t(), g = D, m = requestAnimationFrame(v);
  }
  return t(), () => {
    var D;
    u.forEach((C) => {
      n && C.removeEventListener("scroll", t), o && C.removeEventListener("resize", t);
    }), d == null || d(), (D = f) == null || D.disconnect(), f = null, c && cancelAnimationFrame(m);
  };
}
const ps = zo, fs = $o, On = qo, hs = (r, a, t) => {
  const e = /* @__PURE__ */ new Map(), n = {
    platform: ls,
    ...t
  }, o = {
    ...n.platform,
    _c: e
  };
  return Vo(r, a, {
    ...n,
    platform: o
  });
};
var gt = typeof document < "u" ? er : tr;
function Pt(r, a) {
  if (r === a)
    return !0;
  if (typeof r != typeof a)
    return !1;
  if (typeof r == "function" && r.toString() === a.toString())
    return !0;
  let t, e, n;
  if (r && a && typeof r == "object") {
    if (Array.isArray(r)) {
      if (t = r.length, t !== a.length) return !1;
      for (e = t; e-- !== 0; )
        if (!Pt(r[e], a[e]))
          return !1;
      return !0;
    }
    if (n = Object.keys(r), t = n.length, t !== Object.keys(a).length)
      return !1;
    for (e = t; e-- !== 0; )
      if (!{}.hasOwnProperty.call(a, n[e]))
        return !1;
    for (e = t; e-- !== 0; ) {
      const o = n[e];
      if (!(o === "_owner" && r.$$typeof) && !Pt(r[o], a[o]))
        return !1;
    }
    return !0;
  }
  return r !== r && a !== a;
}
function Mr(r) {
  return typeof window > "u" ? 1 : (r.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Tn(r, a) {
  const t = Mr(r);
  return Math.round(a * t) / t;
}
function Nn(r) {
  const a = S.useRef(r);
  return gt(() => {
    a.current = r;
  }), a;
}
function ms(r) {
  r === void 0 && (r = {});
  const {
    placement: a = "bottom",
    strategy: t = "absolute",
    middleware: e = [],
    platform: n,
    elements: {
      reference: o,
      floating: s
    } = {},
    transform: i = !0,
    whileElementsMounted: c,
    open: l
  } = r, [u, d] = S.useState({
    x: 0,
    y: 0,
    strategy: t,
    placement: a,
    middlewareData: {},
    isPositioned: !1
  }), [p, f] = S.useState(e);
  Pt(p, e) || f(e);
  const [m, g] = S.useState(null), [v, D] = S.useState(null), C = S.useCallback((N) => {
    N !== A.current && (A.current = N, g(N));
  }, []), b = S.useCallback((N) => {
    N !== _.current && (_.current = N, D(N));
  }, []), P = o || m, E = s || v, A = S.useRef(null), _ = S.useRef(null), k = S.useRef(u), M = c != null, V = Nn(c), B = Nn(n), H = S.useCallback(() => {
    if (!A.current || !_.current)
      return;
    const N = {
      placement: a,
      strategy: t,
      middleware: p
    };
    B.current && (N.platform = B.current), hs(A.current, _.current, N).then((ee) => {
      const K = {
        ...ee,
        isPositioned: !0
      };
      Q.current && !Pt(k.current, K) && (k.current = K, ar.flushSync(() => {
        d(K);
      }));
    });
  }, [p, a, t, B]);
  gt(() => {
    l === !1 && k.current.isPositioned && (k.current.isPositioned = !1, d((N) => ({
      ...N,
      isPositioned: !1
    })));
  }, [l]);
  const Q = S.useRef(!1);
  gt(() => (Q.current = !0, () => {
    Q.current = !1;
  }), []), gt(() => {
    if (P && (A.current = P), E && (_.current = E), P && E) {
      if (V.current)
        return V.current(P, E, H);
      H();
    }
  }, [P, E, H, V, M]);
  const T = S.useMemo(() => ({
    reference: A,
    floating: _,
    setReference: C,
    setFloating: b
  }), [C, b]), O = S.useMemo(() => ({
    reference: P,
    floating: E
  }), [P, E]), Y = S.useMemo(() => {
    const N = {
      position: t,
      left: 0,
      top: 0
    };
    if (!O.floating)
      return N;
    const ee = Tn(O.floating, u.x), K = Tn(O.floating, u.y);
    return i ? {
      ...N,
      transform: "translate(" + ee + "px, " + K + "px)",
      ...Mr(O.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: t,
      left: ee,
      top: K
    };
  }, [t, i, O.floating, u.x, u.y]);
  return S.useMemo(() => ({
    ...u,
    update: H,
    refs: T,
    elements: O,
    floatingStyles: Y
  }), [u, H, T, O, Y]);
}
const vs = (r) => {
  function a(t) {
    return {}.hasOwnProperty.call(t, "current");
  }
  return {
    name: "arrow",
    options: r,
    fn(t) {
      const {
        element: e,
        padding: n
      } = typeof r == "function" ? r(t) : r;
      return e && a(e) ? e.current != null ? On({
        element: e.current,
        padding: n
      }).fn(t) : {} : e ? On({
        element: e,
        padding: n
      }).fn(t) : {};
    }
  };
}, gs = (r, a) => ({
  ...ps(r),
  options: [r, a]
}), Ds = (r, a) => ({
  ...fs(r),
  options: [r, a]
}), ws = (r, a) => ({
  ...vs(r),
  options: [r, a]
}), Sr = {
  ...S
}, ys = Sr.useInsertionEffect, bs = ys || ((r) => r());
function _s(r) {
  const a = S.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return bs(() => {
    a.current = r;
  }), S.useCallback(function() {
    for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
      e[n] = arguments[n];
    return a.current == null ? void 0 : a.current(...e);
  }, []);
}
var Ot = typeof document < "u" ? er : tr;
function nn() {
  return nn = Object.assign ? Object.assign.bind() : function(r) {
    for (var a = 1; a < arguments.length; a++) {
      var t = arguments[a];
      for (var e in t)
        Object.prototype.hasOwnProperty.call(t, e) && (r[e] = t[e]);
    }
    return r;
  }, nn.apply(this, arguments);
}
let Rn = !1, ks = 0;
const Yn = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + ks++
);
function xs() {
  const [r, a] = S.useState(() => Rn ? Yn() : void 0);
  return Ot(() => {
    r == null && a(Yn());
  }, []), S.useEffect(() => {
    Rn = !0;
  }, []), r;
}
const Cs = Sr.useId, Er = Cs || xs;
let tt;
process.env.NODE_ENV !== "production" && (tt = /* @__PURE__ */ new Set());
function Ms() {
  for (var r, a = arguments.length, t = new Array(a), e = 0; e < a; e++)
    t[e] = arguments[e];
  const n = "Floating UI: " + t.join(" ");
  if (!((r = tt) != null && r.has(n))) {
    var o;
    (o = tt) == null || o.add(n), console.warn(n);
  }
}
function Ss() {
  for (var r, a = arguments.length, t = new Array(a), e = 0; e < a; e++)
    t[e] = arguments[e];
  const n = "Floating UI: " + t.join(" ");
  if (!((r = tt) != null && r.has(n))) {
    var o;
    (o = tt) == null || o.add(n), console.error(n);
  }
}
const Es = /* @__PURE__ */ S.forwardRef(function(a, t) {
  const {
    context: {
      placement: e,
      elements: {
        floating: n
      },
      middlewareData: {
        arrow: o
      }
    },
    width: s = 14,
    height: i = 7,
    tipRadius: c = 0,
    strokeWidth: l = 0,
    staticOffset: u,
    stroke: d,
    d: p,
    style: {
      transform: f,
      ...m
    } = {},
    ...g
  } = a;
  process.env.NODE_ENV !== "production" && (t || Ms("The `ref` prop is required for `FloatingArrow`."));
  const v = Er(), [D, C] = S.useState(!1);
  if (Ot(() => {
    if (!n) return;
    ie(n).direction === "rtl" && C(!0);
  }, [n]), !n)
    return null;
  const b = l * 2, P = b / 2, E = s / 2 * (c / -8 + 1), A = i / 2 * c / 4, [_, k] = e.split("-"), M = !!p, V = _ === "top" || _ === "bottom", B = u && k === "end" ? "bottom" : "top";
  let H = u && k === "end" ? "right" : "left";
  u && D && (H = k === "end" ? "left" : "right");
  const Q = (o == null ? void 0 : o.x) != null ? u || o.x : "", T = (o == null ? void 0 : o.y) != null ? u || o.y : "", O = p || "M0,0" + (" H" + s) + (" L" + (s - E) + "," + (i - A)) + (" Q" + s / 2 + "," + i + " " + E + "," + (i - A)) + " Z", Y = {
    top: M ? "rotate(180deg)" : "",
    left: M ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: M ? "" : "rotate(180deg)",
    right: M ? "rotate(-90deg)" : "rotate(90deg)"
  }[_];
  return /* @__PURE__ */ S.createElement("svg", nn({}, g, {
    "aria-hidden": !0,
    ref: t,
    width: M ? s : s + b,
    height: s,
    viewBox: "0 0 " + s + " " + (i > s ? i : s),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [H]: Q,
      [B]: T,
      [_]: V || M ? "100%" : "calc(100% - " + b / 2 + "px)",
      transform: "" + Y + (f ?? ""),
      ...m
    }
  }), b > 0 && /* @__PURE__ */ S.createElement("path", {
    clipPath: "url(#" + v + ")",
    fill: "none",
    stroke: d,
    strokeWidth: b + (p ? 0 : 1),
    d: O
  }), /* @__PURE__ */ S.createElement("path", {
    stroke: b && !p ? g.fill : "none",
    d: O
  }), /* @__PURE__ */ S.createElement("clipPath", {
    id: v
  }, /* @__PURE__ */ S.createElement("rect", {
    x: -P,
    y: P * (M ? -1 : 1),
    width: s + b,
    height: s
  })));
});
function Ps() {
  const r = /* @__PURE__ */ new Map();
  return {
    emit(a, t) {
      var e;
      (e = r.get(a)) == null || e.forEach((n) => n(t));
    },
    on(a, t) {
      r.set(a, [...r.get(a) || [], t]);
    },
    off(a, t) {
      var e;
      r.set(a, ((e = r.get(a)) == null ? void 0 : e.filter((n) => n !== t)) || []);
    }
  };
}
const Os = /* @__PURE__ */ S.createContext(null), Ts = /* @__PURE__ */ S.createContext(null), Ns = () => {
  var r;
  return ((r = S.useContext(Os)) == null ? void 0 : r.id) || null;
}, Rs = () => S.useContext(Ts);
function Ys(r) {
  const {
    open: a = !1,
    onOpenChange: t,
    elements: e
  } = r, n = Er(), o = S.useRef({}), [s] = S.useState(() => Ps()), i = Ns() != null;
  if (process.env.NODE_ENV !== "production") {
    const f = e.reference;
    f && !te(f) && Ss("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [c, l] = S.useState(e.reference), u = _s((f, m, g) => {
    o.current.openEvent = f ? m : void 0, s.emit("openchange", {
      open: f,
      event: m,
      reason: g,
      nested: i
    }), t == null || t(f, m, g);
  }), d = S.useMemo(() => ({
    setPositionReference: l
  }), []), p = S.useMemo(() => ({
    reference: c || e.reference || null,
    floating: e.floating || null,
    domReference: e.reference
  }), [c, e.reference, e.floating]);
  return S.useMemo(() => ({
    dataRef: o,
    open: a,
    onOpenChange: u,
    elements: p,
    events: s,
    floatingId: n,
    refs: d
  }), [a, u, p, s, n, d]);
}
function Is(r) {
  r === void 0 && (r = {});
  const {
    nodeId: a
  } = r, t = Ys({
    ...r,
    elements: {
      reference: null,
      floating: null,
      ...r.elements
    }
  }), e = r.rootContext || t, n = e.elements, [o, s] = S.useState(null), [i, c] = S.useState(null), u = (n == null ? void 0 : n.reference) || o, d = S.useRef(null), p = Rs();
  Ot(() => {
    u && (d.current = u);
  }, [u]);
  const f = ms({
    ...r,
    elements: {
      ...n,
      ...i && {
        reference: i
      }
    }
  }), m = S.useCallback((b) => {
    const P = te(b) ? {
      getBoundingClientRect: () => b.getBoundingClientRect(),
      contextElement: b
    } : b;
    c(P), f.refs.setReference(P);
  }, [f.refs]), g = S.useCallback((b) => {
    (te(b) || b === null) && (d.current = b, s(b)), (te(f.refs.reference.current) || f.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    b !== null && !te(b)) && f.refs.setReference(b);
  }, [f.refs]), v = S.useMemo(() => ({
    ...f.refs,
    setReference: g,
    setPositionReference: m,
    domReference: d
  }), [f.refs, g, m]), D = S.useMemo(() => ({
    ...f.elements,
    domReference: u
  }), [f.elements, u]), C = S.useMemo(() => ({
    ...f,
    ...e,
    refs: v,
    elements: D,
    nodeId: a
  }), [f, v, D, a, e]);
  return Ot(() => {
    e.dataRef.current.floatingContext = C;
    const b = p == null ? void 0 : p.nodesRef.current.find((P) => P.id === a);
    b && (b.context = C);
  }), S.useMemo(() => ({
    ...f,
    context: C,
    refs: v,
    elements: D
  }), [f, v, D, C]);
}
/*!
  react-datepicker v7.3.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/
var rn = function(a, t) {
  return rn = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(e, n) {
    e.__proto__ = n;
  } || function(e, n) {
    for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
  }, rn(a, t);
};
function J(r, a) {
  if (typeof a != "function" && a !== null) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
  rn(r, a);
  function t() {
    this.constructor = r;
  }
  r.prototype = a === null ? Object.create(a) : (t.prototype = a.prototype, new t());
}
var L = function() {
  return L = Object.assign || function(t) {
    for (var e, n = 1, o = arguments.length; n < o; n++) {
      e = arguments[n];
      for (var s in e) Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
    }
    return t;
  }, L.apply(this, arguments);
};
function pe(r, a, t) {
  if (t || arguments.length === 2) for (var e = 0, n = a.length, o; e < n; e++)
    (o || !(e in a)) && (o || (o = Array.prototype.slice.call(a, 0, e)), o[e] = a[e]);
  return r.concat(o || Array.prototype.slice.call(a));
}
var Ls = function(r) {
  var a = r.showTimeSelectOnly, t = a === void 0 ? !1 : a, e = r.showTime, n = e === void 0 ? !1 : e, o = r.className, s = r.children, i = t ? "Choose Time" : "Choose Date".concat(n ? " and Time" : "");
  return h.createElement("div", { className: o, role: "dialog", "aria-label": i, "aria-modal": "true" }, s);
}, w;
(function(r) {
  r.ArrowUp = "ArrowUp", r.ArrowDown = "ArrowDown", r.ArrowLeft = "ArrowLeft", r.ArrowRight = "ArrowRight", r.PageUp = "PageUp", r.PageDown = "PageDown", r.Home = "Home", r.End = "End", r.Enter = "Enter", r.Space = " ", r.Tab = "Tab", r.Escape = "Escape", r.Backspace = "Backspace", r.X = "x";
})(w || (w = {}));
function Pr() {
  var r = typeof window < "u" ? window : globalThis;
  return r;
}
var at = 12, As = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function W(r) {
  if (r == null)
    return /* @__PURE__ */ new Date();
  var a = typeof r == "string" ? oo(r) : x(r);
  return ge(a) ? a : /* @__PURE__ */ new Date();
}
function Fs(r, a, t, e, n) {
  var o, s = null, i = Re(t) || Re(Xe()), c = !0;
  if (Array.isArray(a))
    return a.forEach(function(u) {
      var d = Ft(r, u, /* @__PURE__ */ new Date(), {
        locale: i,
        useAdditionalWeekYearTokens: !0,
        useAdditionalDayOfYearTokens: !0
      });
      e && (c = ge(d, n) && r === U(d, u, t)), ge(d, n) && c && (s = d);
    }), s;
  if (s = Ft(r, a, /* @__PURE__ */ new Date(), {
    locale: i,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  }), e)
    c = ge(s) && r === U(s, a, t);
  else if (!ge(s)) {
    var l = ((o = a.match(As)) !== null && o !== void 0 ? o : []).map(function(u) {
      var d = u[0];
      if (d === "p" || d === "P") {
        var p = $t[d];
        return i ? p(u, i.formatLong) : d;
      }
      return u;
    }).join("");
    r.length > 0 && (s = Ft(r, l.slice(0, r.length), /* @__PURE__ */ new Date(), {
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    })), ge(s) || (s = new Date(r));
  }
  return ge(s) && c ? s : null;
}
function ge(r, a) {
  return jt(r) && !Ye(r, a ?? /* @__PURE__ */ new Date("1/1/1800"));
}
function U(r, a, t) {
  if (t === "en")
    return zt(r, a, {
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    });
  var e = t ? Re(t) : void 0;
  return t && !e && console.warn('A locale object was not found for the provided string ["'.concat(t, '"].')), !e && Xe() && Re(Xe()) && (e = Re(Xe())), zt(r, a, {
    locale: e,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  });
}
function se(r, a) {
  var t = a.dateFormat, e = a.locale, n = Array.isArray(t) && t.length > 0 ? t[0] : t;
  return r && U(r, n, e) || "";
}
function Hs(r, a, t) {
  if (!r)
    return "";
  var e = se(r, t), n = a ? se(a, t) : "";
  return "".concat(e, " - ").concat(n);
}
function Ws(r, a) {
  if (!(r != null && r.length))
    return "";
  var t = r[0] ? se(r[0], a) : "";
  if (r.length === 1)
    return t;
  if (r.length === 2 && r[1]) {
    var e = se(r[1], a);
    return "".concat(t, ", ").concat(e);
  }
  var n = r.length - 1;
  return "".concat(t, " (+").concat(n, ")");
}
function Qt(r, a) {
  var t = a.hour, e = t === void 0 ? 0 : t, n = a.minute, o = n === void 0 ? 0 : n, s = a.second, i = s === void 0 ? 0 : s;
  return ht(mt(vt(r, i), o), e);
}
function Bs(r) {
  return sr(r);
}
function Qs(r, a) {
  return U(r, "ddd", a);
}
function Dt(r) {
  return Ge(r);
}
function xe(r, a, t) {
  var e = Re(a || Xe());
  return wt(r, {
    locale: e,
    weekStartsOn: t
  });
}
function Ce(r) {
  return lr(r);
}
function je(r) {
  return sn(r);
}
function In(r) {
  return Gt(r);
}
function Ln() {
  return Ge(W());
}
function An(r) {
  return cr(r);
}
function Ks(r) {
  return na(r);
}
function le(r, a) {
  return r && a ? ao(r, a) : !r && !a;
}
function ne(r, a) {
  return r && a ? no(r, a) : !r && !a;
}
function Tt(r, a) {
  return r && a ? ro(r, a) : !r && !a;
}
function I(r, a) {
  return r && a ? ea(r, a) : !r && !a;
}
function Oe(r, a) {
  return r && a ? ia(r, a) : !r && !a;
}
function ze(r, a, t) {
  var e, n = Ge(a), o = cr(t);
  try {
    e = Ze(r, { start: n, end: o });
  } catch {
    e = !1;
  }
  return e;
}
function Xe() {
  var r = Pr();
  return r.__localeId__;
}
function Re(r) {
  if (typeof r == "string") {
    var a = Pr();
    return a.__localeData__ ? a.__localeData__[r] : void 0;
  } else
    return r;
}
function Vs(r, a, t) {
  return a(U(r, "EEEE", t));
}
function Us(r, a) {
  return U(r, "EEEEEE", a);
}
function qs(r, a) {
  return U(r, "EEE", a);
}
function gn(r, a) {
  return U(ae(W(), r), "LLLL", a);
}
function Or(r, a) {
  return U(ae(W(), r), "LLL", a);
}
function $s(r, a) {
  return U(Ae(W(), r), "QQQ", a);
}
function be(r, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, n = t.maxDate, o = t.excludeDates, s = t.excludeDateIntervals, i = t.includeDates, c = t.includeDateIntervals, l = t.filterDate;
  return ot(r, { minDate: e, maxDate: n }) || o && o.some(function(u) {
    var d;
    return u instanceof Date ? I(r, u) : I(r, (d = u.date) !== null && d !== void 0 ? d : /* @__PURE__ */ new Date());
  }) || s && s.some(function(u) {
    var d = u.start, p = u.end;
    return Ze(r, { start: d, end: p });
  }) || i && !i.some(function(u) {
    return I(r, u);
  }) || c && !c.some(function(u) {
    var d = u.start, p = u.end;
    return Ze(r, { start: d, end: p });
  }) || l && !l(W(r)) || !1;
}
function Dn(r, a) {
  var t = a === void 0 ? {} : a, e = t.excludeDates, n = t.excludeDateIntervals;
  return n && n.length > 0 ? n.some(function(o) {
    var s = o.start, i = o.end;
    return Ze(r, { start: s, end: i });
  }) : e && e.some(function(o) {
    var s;
    return o instanceof Date ? I(r, o) : I(r, (s = o.date) !== null && s !== void 0 ? s : /* @__PURE__ */ new Date());
  }) || !1;
}
function Tr(r, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, n = t.maxDate, o = t.excludeDates, s = t.includeDates, i = t.filterDate;
  return ot(r, {
    minDate: e ? lr(e) : void 0,
    maxDate: n ? ta(n) : void 0
  }) || (o == null ? void 0 : o.some(function(c) {
    return ne(r, c instanceof Date ? c : c.date);
  })) || s && !s.some(function(c) {
    return ne(r, c);
  }) || i && !i(W(r)) || !1;
}
function ut(r, a, t, e) {
  var n = R(r), o = re(r), s = R(a), i = re(a), c = R(e);
  return n === s && n === c ? o <= t && t <= i : n < s ? c === n && o <= t || c === s && i >= t || c < s && c > n : !1;
}
function js(r, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, n = t.maxDate, o = t.excludeDates, s = t.includeDates;
  return ot(r, { minDate: e, maxDate: n }) || o && o.some(function(i) {
    return ne(i instanceof Date ? i : i.date, r);
  }) || s && !s.some(function(i) {
    return ne(i, r);
  }) || !1;
}
function Kt(r, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, n = t.maxDate, o = t.excludeDates, s = t.includeDates, i = t.filterDate;
  return ot(r, { minDate: e, maxDate: n }) || (o == null ? void 0 : o.some(function(c) {
    return Tt(r, c instanceof Date ? c : c.date);
  })) || s && !s.some(function(c) {
    return Tt(r, c);
  }) || i && !i(W(r)) || !1;
}
function dt(r, a, t) {
  if (!a || !t || !jt(a) || !jt(t))
    return !1;
  var e = R(a), n = R(t);
  return e <= r && n >= r;
}
function an(r, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, n = t.maxDate, o = t.excludeDates, s = t.includeDates, i = t.filterDate, c = new Date(r, 0, 1);
  return ot(c, {
    minDate: e ? sn(e) : void 0,
    maxDate: n ? ur(n) : void 0
  }) || (o == null ? void 0 : o.some(function(l) {
    return le(c, l instanceof Date ? l : l.date);
  })) || s && !s.some(function(l) {
    return le(c, l);
  }) || i && !i(W(c)) || !1;
}
function pt(r, a, t, e) {
  var n = R(r), o = Te(r), s = R(a), i = Te(a), c = R(e);
  return n === s && n === c ? o <= t && t <= i : n < s ? c === n && o <= t || c === s && i >= t || c < s && c > n : !1;
}
function ot(r, a) {
  var t, e = a === void 0 ? {} : a, n = e.minDate, o = e.maxDate;
  return (t = n && yt(r, n) < 0 || o && yt(r, o) > 0) !== null && t !== void 0 ? t : !1;
}
function Fn(r, a) {
  return a.some(function(t) {
    return fe(t) === fe(r) && he(t) === he(r) && we(t) === we(r);
  });
}
function Hn(r, a) {
  var t = a === void 0 ? {} : a, e = t.excludeTimes, n = t.includeTimes, o = t.filterTime;
  return e && Fn(r, e) || n && !Fn(r, n) || o && !o(r) || !1;
}
function Wn(r, a) {
  var t = a.minTime, e = a.maxTime;
  if (!t || !e)
    throw new Error("Both minTime and maxTime props required");
  var n = W();
  n = ht(n, fe(r)), n = mt(n, he(r)), n = vt(n, we(r));
  var o = W();
  o = ht(o, fe(t)), o = mt(o, he(t)), o = vt(o, we(t));
  var s = W();
  s = ht(s, fe(e)), s = mt(s, he(e)), s = vt(s, we(e));
  var i;
  try {
    i = !Ze(n, { start: o, end: s });
  } catch {
    i = !1;
  }
  return i;
}
function Bn(r, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, n = t.includeDates, o = We(r, 1);
  return e && _t(e, o) > 0 || n && n.every(function(s) {
    return _t(s, o) > 0;
  }) || !1;
}
function Qn(r, a) {
  var t = a === void 0 ? {} : a, e = t.maxDate, n = t.includeDates, o = me(r, 1);
  return e && _t(o, e) > 0 || n && n.every(function(s) {
    return _t(o, s) > 0;
  }) || !1;
}
function zs(r, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, n = t.includeDates, o = sn(r), s = vr(o, 1);
  return e && kt(e, s) > 0 || n && n.every(function(i) {
    return kt(i, s) > 0;
  }) || !1;
}
function Xs(r, a) {
  var t = a === void 0 ? {} : a, e = t.maxDate, n = t.includeDates, o = ur(r), s = ln(o, 1);
  return e && kt(s, e) > 0 || n && n.every(function(i) {
    return kt(s, i) > 0;
  }) || !1;
}
function Kn(r, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, n = t.includeDates, o = Be(r, 1);
  return e && xt(e, o) > 0 || n && n.every(function(s) {
    return xt(s, o) > 0;
  }) || !1;
}
function Gs(r, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, n = t.yearItemNumber, o = n === void 0 ? at : n, s = je(Be(r, o)), i = _e(s, o).endPeriod, c = e && R(e);
  return c && c > i || !1;
}
function Vn(r, a) {
  var t = a === void 0 ? {} : a, e = t.maxDate, n = t.includeDates, o = De(r, 1);
  return e && xt(o, e) > 0 || n && n.every(function(s) {
    return xt(o, s) > 0;
  }) || !1;
}
function Zs(r, a) {
  var t = a === void 0 ? {} : a, e = t.maxDate, n = t.yearItemNumber, o = n === void 0 ? at : n, s = De(r, o), i = _e(s, o).startPeriod, c = e && R(e);
  return c && c < i || !1;
}
function Nr(r) {
  var a = r.minDate, t = r.includeDates;
  if (t && a) {
    var e = t.filter(function(n) {
      return yt(n, a) >= 0;
    });
    return bn(e);
  } else return t ? bn(t) : a;
}
function Rr(r) {
  var a = r.maxDate, t = r.includeDates;
  if (t && a) {
    var e = t.filter(function(n) {
      return yt(n, a) <= 0;
    });
    return yn(e);
  } else return t ? yn(t) : a;
}
function Un(r, a) {
  var t;
  r === void 0 && (r = []), a === void 0 && (a = "react-datepicker__day--highlighted");
  for (var e = /* @__PURE__ */ new Map(), n = 0, o = r.length; n < o; n++) {
    var s = r[n];
    if (ke(s)) {
      var i = U(s, "MM.dd.yyyy"), c = e.get(i) || [];
      c.includes(a) || (c.push(a), e.set(i, c));
    } else if (typeof s == "object") {
      var l = Object.keys(s), u = (t = l[0]) !== null && t !== void 0 ? t : "", d = s[u];
      if (typeof u == "string" && Array.isArray(d))
        for (var p = 0, f = d.length; p < f; p++) {
          var m = d[p];
          if (m) {
            var i = U(m, "MM.dd.yyyy"), c = e.get(i) || [];
            c.includes(u) || (c.push(u), e.set(i, c));
          }
        }
    }
  }
  return e;
}
function Js(r, a) {
  return r.length !== a.length ? !1 : r.every(function(t, e) {
    return t === a[e];
  });
}
function ei(r, a) {
  r === void 0 && (r = []), a === void 0 && (a = "react-datepicker__day--holidays");
  var t = /* @__PURE__ */ new Map();
  return r.forEach(function(e) {
    var n = e.date, o = e.holidayName;
    if (ke(n)) {
      var s = U(n, "MM.dd.yyyy"), i = t.get(s) || {
        className: "",
        holidayNames: []
      };
      if (!("className" in i && i.className === a && Js(i.holidayNames, [o]))) {
        i.className = a;
        var c = i.holidayNames;
        i.holidayNames = c ? pe(pe([], c, !0), [o], !1) : [o], t.set(s, i);
      }
    }
  }), t;
}
function ti(r, a, t, e, n) {
  for (var o = n.length, s = [], i = 0; i < o; i++) {
    var c = r, l = n[i];
    l && (c = Zr(c, fe(l)), c = Xt(c, he(l)), c = Jr(c, we(l)));
    var u = Xt(r, (t + 1) * e);
    Se(c, a) && Ye(c, u) && l != null && s.push(l);
  }
  return s;
}
function qn(r) {
  return r < 10 ? "0".concat(r) : "".concat(r);
}
function _e(r, a) {
  a === void 0 && (a = at);
  var t = Math.ceil(R(r) / a) * a, e = t - (a - 1);
  return { startPeriod: e, endPeriod: t };
}
function ni(r) {
  var a = new Date(r.getFullYear(), r.getMonth(), r.getDate()), t = new Date(r.getFullYear(), r.getMonth(), r.getDate(), 24);
  return Math.round((+t - +a) / 36e5);
}
function $n(r) {
  var a = r.getSeconds(), t = r.getMilliseconds();
  return x(r.getTime() - a * 1e3 - t);
}
function ri(r, a) {
  return $n(r).getTime() === $n(a).getTime();
}
function jn(r) {
  if (!ke(r))
    throw new Error("Invalid date");
  var a = new Date(r);
  return a.setHours(0, 0, 0, 0), a;
}
function zn(r, a) {
  if (!ke(r) || !ke(a))
    throw new Error("Invalid date received");
  var t = jn(r), e = jn(a);
  return Ye(t, e);
}
function Yr(r) {
  return r.key === w.Space;
}
var ai = (
  /** @class */
  function(r) {
    J(a, r);
    function a(t) {
      var e = r.call(this, t) || this;
      return e.onTimeChange = function(n) {
        var o, s;
        e.setState({ time: n });
        var i = e.props.date, c = i instanceof Date && !isNaN(+i), l = c ? i : /* @__PURE__ */ new Date();
        if (n != null && n.includes(":")) {
          var u = n.split(":"), d = u[0], p = u[1];
          l.setHours(Number(d)), l.setMinutes(Number(p));
        }
        (s = (o = e.props).onChange) === null || s === void 0 || s.call(o, l);
      }, e.renderTimeInput = function() {
        var n = e.state.time, o = e.props, s = o.date, i = o.timeString, c = o.customTimeInput;
        return c ? nr(c, {
          date: s,
          value: n,
          onChange: e.onTimeChange
        }) : h.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", required: !0, value: n, onChange: function(l) {
          e.onTimeChange(l.target.value || i);
        } });
      }, e.state = {
        time: e.props.timeString
      }, e;
    }
    return a.getDerivedStateFromProps = function(t, e) {
      return t.timeString !== e.time ? {
        time: t.timeString
      } : null;
    }, a.prototype.render = function() {
      return h.createElement(
        "div",
        { className: "react-datepicker__input-time-container" },
        h.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel),
        h.createElement(
          "div",
          { className: "react-datepicker-time__input-container" },
          h.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())
        )
      );
    }, a;
  }(G)
), oi = (
  /** @class */
  function(r) {
    J(a, r);
    function a() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.dayEl = Me(), t.handleClick = function(e) {
        !t.isDisabled() && t.props.onClick && t.props.onClick(e);
      }, t.handleMouseEnter = function(e) {
        !t.isDisabled() && t.props.onMouseEnter && t.props.onMouseEnter(e);
      }, t.handleOnKeyDown = function(e) {
        var n, o, s = e.key;
        s === w.Space && (e.preventDefault(), e.key = w.Enter), (o = (n = t.props).handleOnKeyDown) === null || o === void 0 || o.call(n, e);
      }, t.isSameDay = function(e) {
        return I(t.props.day, e);
      }, t.isKeyboardSelected = function() {
        var e;
        if (t.props.disabledKeyboardNavigation)
          return !1;
        var n = t.props.selectsMultiple ? (e = t.props.selectedDates) === null || e === void 0 ? void 0 : e.some(function(s) {
          return t.isSameDayOrWeek(s);
        }) : t.isSameDayOrWeek(t.props.selected), o = t.props.preSelection && t.isDisabled(t.props.preSelection);
        return !n && t.isSameDayOrWeek(t.props.preSelection) && !o;
      }, t.isDisabled = function(e) {
        return e === void 0 && (e = t.props.day), be(e, {
          minDate: t.props.minDate,
          maxDate: t.props.maxDate,
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals,
          includeDateIntervals: t.props.includeDateIntervals,
          includeDates: t.props.includeDates,
          filterDate: t.props.filterDate
        });
      }, t.isExcluded = function() {
        return Dn(t.props.day, {
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals
        });
      }, t.isStartOfWeek = function() {
        return I(t.props.day, xe(t.props.day, t.props.locale, t.props.calendarStartDay));
      }, t.isSameWeek = function(e) {
        return t.props.showWeekPicker && I(e, xe(t.props.day, t.props.locale, t.props.calendarStartDay));
      }, t.isSameDayOrWeek = function(e) {
        return t.isSameDay(e) || t.isSameWeek(e);
      }, t.getHighLightedClass = function() {
        var e = t.props, n = e.day, o = e.highlightDates;
        if (!o)
          return !1;
        var s = U(n, "MM.dd.yyyy");
        return o.get(s);
      }, t.getHolidaysClass = function() {
        var e, n = t.props, o = n.day, s = n.holidays;
        if (!s)
          return [void 0];
        var i = U(o, "MM.dd.yyyy");
        return s.has(i) ? [(e = s.get(i)) === null || e === void 0 ? void 0 : e.className] : [void 0];
      }, t.isInRange = function() {
        var e = t.props, n = e.day, o = e.startDate, s = e.endDate;
        return !o || !s ? !1 : ze(n, o, s);
      }, t.isInSelectingRange = function() {
        var e, n = t.props, o = n.day, s = n.selectsStart, i = n.selectsEnd, c = n.selectsRange, l = n.selectsDisabledDaysInRange, u = n.startDate, d = n.endDate, p = (e = t.props.selectingDate) !== null && e !== void 0 ? e : t.props.preSelection;
        return !(s || i || c) || !p || !l && t.isDisabled() ? !1 : s && d && (Ye(p, d) || Oe(p, d)) ? ze(o, p, d) : i && u && (Se(p, u) || Oe(p, u)) || c && u && !d && (Se(p, u) || Oe(p, u)) ? ze(o, u, p) : !1;
      }, t.isSelectingRangeStart = function() {
        var e;
        if (!t.isInSelectingRange())
          return !1;
        var n = t.props, o = n.day, s = n.startDate, i = n.selectsStart, c = (e = t.props.selectingDate) !== null && e !== void 0 ? e : t.props.preSelection;
        return i ? I(o, c) : I(o, s);
      }, t.isSelectingRangeEnd = function() {
        var e;
        if (!t.isInSelectingRange())
          return !1;
        var n = t.props, o = n.day, s = n.endDate, i = n.selectsEnd, c = n.selectsRange, l = (e = t.props.selectingDate) !== null && e !== void 0 ? e : t.props.preSelection;
        return i || c ? I(o, l) : I(o, s);
      }, t.isRangeStart = function() {
        var e = t.props, n = e.day, o = e.startDate, s = e.endDate;
        return !o || !s ? !1 : I(o, n);
      }, t.isRangeEnd = function() {
        var e = t.props, n = e.day, o = e.startDate, s = e.endDate;
        return !o || !s ? !1 : I(s, n);
      }, t.isWeekend = function() {
        var e = ra(t.props.day);
        return e === 0 || e === 6;
      }, t.isAfterMonth = function() {
        return t.props.month !== void 0 && (t.props.month + 1) % 12 === re(t.props.day);
      }, t.isBeforeMonth = function() {
        return t.props.month !== void 0 && (re(t.props.day) + 1) % 12 === t.props.month;
      }, t.isCurrentDay = function() {
        return t.isSameDay(W());
      }, t.isSelected = function() {
        var e;
        return t.props.selectsMultiple ? (e = t.props.selectedDates) === null || e === void 0 ? void 0 : e.some(function(n) {
          return t.isSameDayOrWeek(n);
        }) : t.isSameDayOrWeek(t.props.selected);
      }, t.getClassNames = function(e) {
        var n = t.props.dayClassName ? t.props.dayClassName(e) : void 0;
        return Z("react-datepicker__day", n, "react-datepicker__day--" + Qs(t.props.day), {
          "react-datepicker__day--disabled": t.isDisabled(),
          "react-datepicker__day--excluded": t.isExcluded(),
          "react-datepicker__day--selected": t.isSelected(),
          "react-datepicker__day--keyboard-selected": t.isKeyboardSelected(),
          "react-datepicker__day--range-start": t.isRangeStart(),
          "react-datepicker__day--range-end": t.isRangeEnd(),
          "react-datepicker__day--in-range": t.isInRange(),
          "react-datepicker__day--in-selecting-range": t.isInSelectingRange(),
          "react-datepicker__day--selecting-range-start": t.isSelectingRangeStart(),
          "react-datepicker__day--selecting-range-end": t.isSelectingRangeEnd(),
          "react-datepicker__day--today": t.isCurrentDay(),
          "react-datepicker__day--weekend": t.isWeekend(),
          "react-datepicker__day--outside-month": t.isAfterMonth() || t.isBeforeMonth()
        }, t.getHighLightedClass(), t.getHolidaysClass());
      }, t.getAriaLabel = function() {
        var e = t.props, n = e.day, o = e.ariaLabelPrefixWhenEnabled, s = o === void 0 ? "Choose" : o, i = e.ariaLabelPrefixWhenDisabled, c = i === void 0 ? "Not available" : i, l = t.isDisabled() || t.isExcluded() ? c : s;
        return "".concat(l, " ").concat(U(n, "PPPP", t.props.locale));
      }, t.getTitle = function() {
        var e = t.props, n = e.day, o = e.holidays, s = o === void 0 ? /* @__PURE__ */ new Map() : o, i = e.excludeDates, c = U(n, "MM.dd.yyyy"), l = [];
        return s.has(c) && l.push.apply(l, s.get(c).holidayNames), t.isExcluded() && l.push(i == null ? void 0 : i.filter(function(u) {
          return u instanceof Date ? I(u, n) : I(u == null ? void 0 : u.date, n);
        }).map(function(u) {
          if (!(u instanceof Date))
            return u == null ? void 0 : u.message;
        })), l.join(", ");
      }, t.getTabIndex = function() {
        var e = t.props.selected, n = t.props.preSelection, o = !(t.props.showWeekPicker && (t.props.showWeekNumber || !t.isStartOfWeek())) && (t.isKeyboardSelected() || t.isSameDay(e) && I(n, e)) ? 0 : -1;
        return o;
      }, t.handleFocusDay = function() {
        var e;
        t.shouldFocusDay() && ((e = t.dayEl.current) === null || e === void 0 || e.focus({ preventScroll: !0 }));
      }, t.renderDayContents = function() {
        return t.props.monthShowsDuplicateDaysEnd && t.isAfterMonth() || t.props.monthShowsDuplicateDaysStart && t.isBeforeMonth() ? null : t.props.renderDayContents ? t.props.renderDayContents(_n(t.props.day), t.props.day) : _n(t.props.day);
      }, t.render = function() {
        return (
          // TODO: Use <option> instead of the "option" role to ensure accessibility across all devices.
          h.createElement(
            "div",
            { ref: t.dayEl, className: t.getClassNames(t.props.day), onKeyDown: t.handleOnKeyDown, onClick: t.handleClick, onMouseEnter: t.props.usePointerEvent ? void 0 : t.handleMouseEnter, onPointerEnter: t.props.usePointerEvent ? t.handleMouseEnter : void 0, tabIndex: t.getTabIndex(), "aria-label": t.getAriaLabel(), role: "option", title: t.getTitle(), "aria-disabled": t.isDisabled(), "aria-current": t.isCurrentDay() ? "date" : void 0, "aria-selected": t.isSelected() || t.isInRange() },
            t.renderDayContents(),
            t.getTitle() !== "" && h.createElement("span", { className: "overlay" }, t.getTitle())
          )
        );
      }, t;
    }
    return a.prototype.componentDidMount = function() {
      this.handleFocusDay();
    }, a.prototype.componentDidUpdate = function() {
      this.handleFocusDay();
    }, a.prototype.shouldFocusDay = function() {
      var t = !1;
      return this.getTabIndex() === 0 && this.isSameDay(this.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (t = !0), this.props.inline && !this.props.shouldFocusDayInline && (t = !1), this.isDayActiveElement() && (t = !0), this.isDuplicateDay() && (t = !1)), t;
    }, a.prototype.isDayActiveElement = function() {
      var t, e, n;
      return ((e = (t = this.props.containerRef) === null || t === void 0 ? void 0 : t.current) === null || e === void 0 ? void 0 : e.contains(document.activeElement)) && ((n = document.activeElement) === null || n === void 0 ? void 0 : n.classList.contains("react-datepicker__day"));
    }, a.prototype.isDuplicateDay = function() {
      return (
        //day is one of the non rendered duplicate days
        this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth()
      );
    }, a;
  }(G)
), si = (
  /** @class */
  function(r) {
    J(a, r);
    function a() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.weekNumberEl = Me(), t.handleClick = function(e) {
        t.props.onClick && t.props.onClick(e);
      }, t.handleOnKeyDown = function(e) {
        var n, o, s = e.key;
        s === w.Space && (e.preventDefault(), e.key = w.Enter), (o = (n = t.props).handleOnKeyDown) === null || o === void 0 || o.call(n, e);
      }, t.isKeyboardSelected = function() {
        return !t.props.disabledKeyboardNavigation && !I(t.props.date, t.props.selected) && I(t.props.date, t.props.preSelection);
      }, t.getTabIndex = function() {
        return t.props.showWeekPicker && t.props.showWeekNumber && (t.isKeyboardSelected() || I(t.props.date, t.props.selected) && I(t.props.preSelection, t.props.selected)) ? 0 : -1;
      }, t.handleFocusWeekNumber = function(e) {
        var n = !1;
        t.getTabIndex() === 0 && !(e != null && e.isInputFocused) && I(t.props.date, t.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (n = !0), t.props.inline && !t.props.shouldFocusDayInline && (n = !1), t.props.containerRef && t.props.containerRef.current && t.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (n = !0)), n && t.weekNumberEl.current && t.weekNumberEl.current.focus({ preventScroll: !0 });
      }, t;
    }
    return Object.defineProperty(a, "defaultProps", {
      get: function() {
        return {
          ariaLabelPrefix: "week "
        };
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.componentDidMount = function() {
      this.handleFocusWeekNumber();
    }, a.prototype.componentDidUpdate = function(t) {
      this.handleFocusWeekNumber(t);
    }, a.prototype.render = function() {
      var t = this.props, e = t.weekNumber, n = t.ariaLabelPrefix, o = n === void 0 ? a.defaultProps.ariaLabelPrefix : n, s = t.onClick, i = {
        "react-datepicker__week-number": !0,
        "react-datepicker__week-number--clickable": !!s,
        "react-datepicker__week-number--selected": !!s && I(this.props.date, this.props.selected),
        "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected()
      };
      return h.createElement("div", { ref: this.weekNumberEl, className: Z(i), "aria-label": "".concat(o, " ").concat(this.props.weekNumber), onClick: this.handleClick, onKeyDown: this.handleOnKeyDown, tabIndex: this.getTabIndex() }, e);
    }, a;
  }(G)
), ii = (
  /** @class */
  function(r) {
    J(a, r);
    function a() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.isDisabled = function(e) {
        return be(e, {
          minDate: t.props.minDate,
          maxDate: t.props.maxDate,
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals,
          includeDateIntervals: t.props.includeDateIntervals,
          includeDates: t.props.includeDates,
          filterDate: t.props.filterDate
        });
      }, t.handleDayClick = function(e, n) {
        t.props.onDayClick && t.props.onDayClick(e, n);
      }, t.handleDayMouseEnter = function(e) {
        t.props.onDayMouseEnter && t.props.onDayMouseEnter(e);
      }, t.handleWeekClick = function(e, n, o) {
        for (var s, i, c, l = new Date(e), u = 0; u < 7; u++) {
          var d = new Date(e);
          d.setDate(d.getDate() + u);
          var p = !t.isDisabled(d);
          if (p) {
            l = d;
            break;
          }
        }
        typeof t.props.onWeekSelect == "function" && t.props.onWeekSelect(l, n, o), t.props.showWeekPicker && t.handleDayClick(l, o), ((s = t.props.shouldCloseOnSelect) !== null && s !== void 0 ? s : a.defaultProps.shouldCloseOnSelect) && ((c = (i = t.props).setOpen) === null || c === void 0 || c.call(i, !1));
      }, t.formatWeekNumber = function(e) {
        return t.props.formatWeekNumber ? t.props.formatWeekNumber(e) : Bs(e);
      }, t.renderDays = function() {
        var e = t.startOfWeek(), n = [], o = t.formatWeekNumber(e);
        if (t.props.showWeekNumber) {
          var s = t.props.onWeekSelect || t.props.showWeekPicker ? t.handleWeekClick.bind(t, e, o) : void 0;
          n.push(h.createElement(si, L({ key: "W" }, a.defaultProps, t.props, { weekNumber: o, date: e, onClick: s })));
        }
        return n.concat([0, 1, 2, 3, 4, 5, 6].map(function(i) {
          var c = Le(e, i);
          return h.createElement(oi, L({}, a.defaultProps, t.props, { ariaLabelPrefixWhenEnabled: t.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: t.props.disabledDayAriaLabelPrefix, key: c.valueOf(), day: c, onClick: t.handleDayClick.bind(t, c), onMouseEnter: t.handleDayMouseEnter.bind(t, c) }));
        }));
      }, t.startOfWeek = function() {
        return xe(t.props.day, t.props.locale, t.props.calendarStartDay);
      }, t.isKeyboardSelected = function() {
        return !t.props.disabledKeyboardNavigation && !I(t.startOfWeek(), t.props.selected) && I(t.startOfWeek(), t.props.preSelection);
      }, t;
    }
    return Object.defineProperty(a, "defaultProps", {
      get: function() {
        return {
          shouldCloseOnSelect: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.render = function() {
      var t = {
        "react-datepicker__week": !0,
        "react-datepicker__week--selected": I(this.startOfWeek(), this.props.selected),
        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
      };
      return h.createElement("div", { className: Z(t) }, this.renderDays());
    }, a;
  }(G)
), $e, ci = 6, He = {
  TWO_COLUMNS: "two_columns",
  THREE_COLUMNS: "three_columns",
  FOUR_COLUMNS: "four_columns"
}, Vt = ($e = {}, $e[He.TWO_COLUMNS] = {
  grid: [
    [0, 1],
    [2, 3],
    [4, 5],
    [6, 7],
    [8, 9],
    [10, 11]
  ],
  verticalNavigationOffset: 2
}, $e[He.THREE_COLUMNS] = {
  grid: [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [9, 10, 11]
  ],
  verticalNavigationOffset: 3
}, $e[He.FOUR_COLUMNS] = {
  grid: [
    [0, 1, 2, 3],
    [4, 5, 6, 7],
    [8, 9, 10, 11]
  ],
  verticalNavigationOffset: 4
}, $e), ft = 1;
function Xn(r, a) {
  return r ? He.FOUR_COLUMNS : a ? He.TWO_COLUMNS : He.THREE_COLUMNS;
}
var li = (
  /** @class */
  function(r) {
    J(a, r);
    function a() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.MONTH_REFS = pe([], Array(12), !0).map(function() {
        return Me();
      }), t.QUARTER_REFS = pe([], Array(4), !0).map(function() {
        return Me();
      }), t.isDisabled = function(e) {
        return be(e, {
          minDate: t.props.minDate,
          maxDate: t.props.maxDate,
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals,
          includeDateIntervals: t.props.includeDateIntervals,
          includeDates: t.props.includeDates,
          filterDate: t.props.filterDate
        });
      }, t.isExcluded = function(e) {
        return Dn(e, {
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals
        });
      }, t.handleDayClick = function(e, n) {
        var o, s;
        (s = (o = t.props).onDayClick) === null || s === void 0 || s.call(o, e, n, t.props.orderInDisplay);
      }, t.handleDayMouseEnter = function(e) {
        var n, o;
        (o = (n = t.props).onDayMouseEnter) === null || o === void 0 || o.call(n, e);
      }, t.handleMouseLeave = function() {
        var e, n;
        (n = (e = t.props).onMouseLeave) === null || n === void 0 || n.call(e);
      }, t.isRangeStartMonth = function(e) {
        var n = t.props, o = n.day, s = n.startDate, i = n.endDate;
        return !s || !i ? !1 : ne(ae(o, e), s);
      }, t.isRangeStartQuarter = function(e) {
        var n = t.props, o = n.day, s = n.startDate, i = n.endDate;
        return !s || !i ? !1 : Tt(Ae(o, e), s);
      }, t.isRangeEndMonth = function(e) {
        var n = t.props, o = n.day, s = n.startDate, i = n.endDate;
        return !s || !i ? !1 : ne(ae(o, e), i);
      }, t.isRangeEndQuarter = function(e) {
        var n = t.props, o = n.day, s = n.startDate, i = n.endDate;
        return !s || !i ? !1 : Tt(Ae(o, e), i);
      }, t.isInSelectingRangeMonth = function(e) {
        var n, o = t.props, s = o.day, i = o.selectsStart, c = o.selectsEnd, l = o.selectsRange, u = o.startDate, d = o.endDate, p = (n = t.props.selectingDate) !== null && n !== void 0 ? n : t.props.preSelection;
        return !(i || c || l) || !p ? !1 : i && d ? ut(p, d, e, s) : c && u || l && u && !d ? ut(u, p, e, s) : !1;
      }, t.isSelectingMonthRangeStart = function(e) {
        var n;
        if (!t.isInSelectingRangeMonth(e))
          return !1;
        var o = t.props, s = o.day, i = o.startDate, c = o.selectsStart, l = ae(s, e), u = (n = t.props.selectingDate) !== null && n !== void 0 ? n : t.props.preSelection;
        return c ? ne(l, u) : ne(l, i);
      }, t.isSelectingMonthRangeEnd = function(e) {
        var n;
        if (!t.isInSelectingRangeMonth(e))
          return !1;
        var o = t.props, s = o.day, i = o.endDate, c = o.selectsEnd, l = o.selectsRange, u = ae(s, e), d = (n = t.props.selectingDate) !== null && n !== void 0 ? n : t.props.preSelection;
        return c || l ? ne(u, d) : ne(u, i);
      }, t.isInSelectingRangeQuarter = function(e) {
        var n, o = t.props, s = o.day, i = o.selectsStart, c = o.selectsEnd, l = o.selectsRange, u = o.startDate, d = o.endDate, p = (n = t.props.selectingDate) !== null && n !== void 0 ? n : t.props.preSelection;
        return !(i || c || l) || !p ? !1 : i && d ? pt(p, d, e, s) : c && u || l && u && !d ? pt(u, p, e, s) : !1;
      }, t.isWeekInMonth = function(e) {
        var n = t.props.day, o = Le(e, 6);
        return ne(e, n) || ne(o, n);
      }, t.isCurrentMonth = function(e, n) {
        return R(e) === R(W()) && n === re(W());
      }, t.isCurrentQuarter = function(e, n) {
        return R(e) === R(W()) && n === Te(W());
      }, t.isSelectedMonth = function(e, n, o) {
        return re(o) === n && R(e) === R(o);
      }, t.isSelectMonthInList = function(e, n, o) {
        return o.some(function(s) {
          return t.isSelectedMonth(e, n, s);
        });
      }, t.isSelectedQuarter = function(e, n, o) {
        return Te(e) === n && R(e) === R(o);
      }, t.renderWeeks = function() {
        for (var e = [], n = t.props.fixedHeight, o = 0, s = !1, i = xe(Ce(t.props.day), t.props.locale, t.props.calendarStartDay), c = function(m) {
          return t.props.showWeekPicker ? xe(m, t.props.locale, t.props.calendarStartDay) : t.props.preSelection;
        }, l = function(m) {
          return t.props.showWeekPicker ? xe(m, t.props.locale, t.props.calendarStartDay) : t.props.selected;
        }, u = t.props.selected ? l(t.props.selected) : void 0, d = t.props.preSelection ? c(t.props.preSelection) : void 0; e.push(h.createElement(ii, L({}, t.props, { ariaLabelPrefix: t.props.weekAriaLabelPrefix, key: o, day: i, month: re(t.props.day), onDayClick: t.handleDayClick, onDayMouseEnter: t.handleDayMouseEnter, selected: u, preSelection: d, showWeekNumber: t.props.showWeekNumbers }))), !s; ) {
          o++, i = bt(i, 1);
          var p = n && o >= ci, f = !n && !t.isWeekInMonth(i);
          if (p || f)
            if (t.props.peekNextMonth)
              s = !0;
            else
              break;
        }
        return e;
      }, t.onMonthClick = function(e, n) {
        var o = t.isMonthDisabledForLabelDate(n), s = o.isDisabled, i = o.labelDate;
        s || t.handleDayClick(Ce(i), e);
      }, t.onMonthMouseEnter = function(e) {
        var n = t.isMonthDisabledForLabelDate(e), o = n.isDisabled, s = n.labelDate;
        o || t.handleDayMouseEnter(Ce(s));
      }, t.handleMonthNavigation = function(e, n) {
        var o, s, i, c;
        (s = (o = t.props).setPreSelection) === null || s === void 0 || s.call(o, n), (c = (i = t.MONTH_REFS[e]) === null || i === void 0 ? void 0 : i.current) === null || c === void 0 || c.focus();
      }, t.handleKeyboardNavigation = function(e, n, o) {
        var s, i = t.props, c = i.selected, l = i.preSelection, u = i.setPreSelection, d = i.minDate, p = i.maxDate, f = i.showFourColumnMonthYearPicker, m = i.showTwoColumnMonthYearPicker;
        if (l) {
          var g = Xn(f, m), v = t.getVerticalOffset(g), D = (s = Vt[g]) === null || s === void 0 ? void 0 : s.grid, C = function(_, k, M) {
            var V, B, H = k, Q = M;
            switch (_) {
              case w.ArrowRight:
                H = me(k, ft), Q = M === 11 ? 0 : M + ft;
                break;
              case w.ArrowLeft:
                H = We(k, ft), Q = M === 0 ? 11 : M - ft;
                break;
              case w.ArrowUp:
                H = We(k, v), Q = !((V = D == null ? void 0 : D[0]) === null || V === void 0) && V.includes(M) ? M + 12 - v : M - v;
                break;
              case w.ArrowDown:
                H = me(k, v), Q = !((B = D == null ? void 0 : D[D.length - 1]) === null || B === void 0) && B.includes(M) ? M - 12 + v : M + v;
                break;
            }
            return { newCalculatedDate: H, newCalculatedMonth: Q };
          }, b = function(_, k, M) {
            for (var V = 40, B = _, H = !1, Q = 0, T = C(B, k, M), O = T.newCalculatedDate, Y = T.newCalculatedMonth; !H; ) {
              if (Q >= V) {
                O = k, Y = M;
                break;
              }
              if (d && O < d) {
                B = w.ArrowRight;
                var N = C(B, O, Y);
                O = N.newCalculatedDate, Y = N.newCalculatedMonth;
              }
              if (p && O > p) {
                B = w.ArrowLeft;
                var N = C(B, O, Y);
                O = N.newCalculatedDate, Y = N.newCalculatedMonth;
              }
              if (js(O, t.props)) {
                var N = C(B, O, Y);
                O = N.newCalculatedDate, Y = N.newCalculatedMonth;
              } else
                H = !0;
              Q++;
            }
            return { newCalculatedDate: O, newCalculatedMonth: Y };
          };
          if (n === w.Enter) {
            t.isMonthDisabled(o) || (t.onMonthClick(e, o), u == null || u(c));
            return;
          }
          var P = b(n, l, o), E = P.newCalculatedDate, A = P.newCalculatedMonth;
          switch (n) {
            case w.ArrowRight:
            case w.ArrowLeft:
            case w.ArrowUp:
            case w.ArrowDown:
              t.handleMonthNavigation(A, E);
              break;
          }
        }
      }, t.getVerticalOffset = function(e) {
        var n, o;
        return (o = (n = Vt[e]) === null || n === void 0 ? void 0 : n.verticalNavigationOffset) !== null && o !== void 0 ? o : 0;
      }, t.onMonthKeyDown = function(e, n) {
        var o = t.props, s = o.disabledKeyboardNavigation, i = o.handleOnMonthKeyDown, c = e.key;
        c !== w.Tab && e.preventDefault(), s || t.handleKeyboardNavigation(e, c, n), i && i(e);
      }, t.onQuarterClick = function(e, n) {
        var o = Ae(t.props.day, n);
        Kt(o, t.props) || t.handleDayClick(In(o), e);
      }, t.onQuarterMouseEnter = function(e) {
        var n = Ae(t.props.day, e);
        Kt(n, t.props) || t.handleDayMouseEnter(In(n));
      }, t.handleQuarterNavigation = function(e, n) {
        var o, s, i, c;
        t.isDisabled(n) || t.isExcluded(n) || ((s = (o = t.props).setPreSelection) === null || s === void 0 || s.call(o, n), (c = (i = t.QUARTER_REFS[e - 1]) === null || i === void 0 ? void 0 : i.current) === null || c === void 0 || c.focus());
      }, t.onQuarterKeyDown = function(e, n) {
        var o, s, i = e.key;
        if (!t.props.disabledKeyboardNavigation)
          switch (i) {
            case w.Enter:
              t.onQuarterClick(e, n), (s = (o = t.props).setPreSelection) === null || s === void 0 || s.call(o, t.props.selected);
              break;
            case w.ArrowRight:
              if (!t.props.preSelection)
                break;
              t.handleQuarterNavigation(n === 4 ? 1 : n + 1, ln(t.props.preSelection, 1));
              break;
            case w.ArrowLeft:
              if (!t.props.preSelection)
                break;
              t.handleQuarterNavigation(n === 1 ? 4 : n - 1, vr(t.props.preSelection, 1));
              break;
          }
      }, t.isMonthDisabledForLabelDate = function(e) {
        var n, o = t.props, s = o.day, i = o.minDate, c = o.maxDate, l = o.excludeDates, u = o.includeDates, d = ae(s, e);
        return {
          isDisabled: (n = (i || c || l || u) && Tr(d, t.props)) !== null && n !== void 0 ? n : !1,
          labelDate: d
        };
      }, t.isMonthDisabled = function(e) {
        var n = t.isMonthDisabledForLabelDate(e).isDisabled;
        return n;
      }, t.getMonthClassNames = function(e) {
        var n = t.props, o = n.day, s = n.startDate, i = n.endDate, c = n.preSelection, l = n.monthClassName, u = l ? l(ae(o, e)) : void 0, d = t.getSelection();
        return Z("react-datepicker__month-text", "react-datepicker__month-".concat(e), u, {
          "react-datepicker__month-text--disabled": t.isMonthDisabled(e),
          "react-datepicker__month-text--selected": d ? t.isSelectMonthInList(o, e, d) : void 0,
          "react-datepicker__month-text--keyboard-selected": !t.props.disabledKeyboardNavigation && c && t.isSelectedMonth(o, e, c) && !t.isMonthDisabled(e),
          "react-datepicker__month-text--in-selecting-range": t.isInSelectingRangeMonth(e),
          "react-datepicker__month-text--in-range": s && i ? ut(s, i, e, o) : void 0,
          "react-datepicker__month-text--range-start": t.isRangeStartMonth(e),
          "react-datepicker__month-text--range-end": t.isRangeEndMonth(e),
          "react-datepicker__month-text--selecting-range-start": t.isSelectingMonthRangeStart(e),
          "react-datepicker__month-text--selecting-range-end": t.isSelectingMonthRangeEnd(e),
          "react-datepicker__month-text--today": t.isCurrentMonth(o, e)
        });
      }, t.getTabIndex = function(e) {
        if (t.props.preSelection == null)
          return "-1";
        var n = re(t.props.preSelection), o = !t.props.disabledKeyboardNavigation && e === n ? "0" : "-1";
        return o;
      }, t.getQuarterTabIndex = function(e) {
        if (t.props.preSelection == null)
          return "-1";
        var n = Te(t.props.preSelection), o = !t.props.disabledKeyboardNavigation && e === n ? "0" : "-1";
        return o;
      }, t.getAriaLabel = function(e) {
        var n = t.props, o = n.chooseDayAriaLabelPrefix, s = o === void 0 ? "Choose" : o, i = n.disabledDayAriaLabelPrefix, c = i === void 0 ? "Not available" : i, l = n.day, u = n.locale, d = ae(l, e), p = t.isDisabled(d) || t.isExcluded(d) ? c : s;
        return "".concat(p, " ").concat(U(d, "MMMM yyyy", u));
      }, t.getQuarterClassNames = function(e) {
        var n = t.props, o = n.day, s = n.startDate, i = n.endDate, c = n.selected, l = n.minDate, u = n.maxDate, d = n.excludeDates, p = n.includeDates, f = n.filterDate, m = n.preSelection, g = n.disabledKeyboardNavigation, v = (l || u || d || p || f) && Kt(Ae(o, e), t.props);
        return Z("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(e), {
          "react-datepicker__quarter-text--disabled": v,
          "react-datepicker__quarter-text--selected": c ? t.isSelectedQuarter(o, e, c) : void 0,
          "react-datepicker__quarter-text--keyboard-selected": !g && m && t.isSelectedQuarter(o, e, m) && !v,
          "react-datepicker__quarter-text--in-selecting-range": t.isInSelectingRangeQuarter(e),
          "react-datepicker__quarter-text--in-range": s && i ? pt(s, i, e, o) : void 0,
          "react-datepicker__quarter-text--range-start": t.isRangeStartQuarter(e),
          "react-datepicker__quarter-text--range-end": t.isRangeEndQuarter(e)
        });
      }, t.getMonthContent = function(e) {
        var n = t.props, o = n.showFullMonthYearPicker, s = n.renderMonthContent, i = n.locale, c = n.day, l = Or(e, i), u = gn(e, i);
        return s ? s(e, l, u, c) : o ? u : l;
      }, t.getQuarterContent = function(e) {
        var n, o = t.props, s = o.renderQuarterContent, i = o.locale, c = $s(e, i);
        return (n = s == null ? void 0 : s(e, c)) !== null && n !== void 0 ? n : c;
      }, t.renderMonths = function() {
        var e, n = t.props, o = n.showTwoColumnMonthYearPicker, s = n.showFourColumnMonthYearPicker, i = n.day, c = n.selected, l = (e = Vt[Xn(s, o)]) === null || e === void 0 ? void 0 : e.grid;
        return l == null ? void 0 : l.map(function(u, d) {
          return h.createElement("div", { className: "react-datepicker__month-wrapper", key: d }, u.map(function(p, f) {
            return h.createElement("div", { ref: t.MONTH_REFS[p], key: f, onClick: function(m) {
              t.onMonthClick(m, p);
            }, onKeyDown: function(m) {
              Yr(m) && (m.preventDefault(), m.key = w.Enter), t.onMonthKeyDown(m, p);
            }, onMouseEnter: t.props.usePointerEvent ? void 0 : function() {
              return t.onMonthMouseEnter(p);
            }, onPointerEnter: t.props.usePointerEvent ? function() {
              return t.onMonthMouseEnter(p);
            } : void 0, tabIndex: Number(t.getTabIndex(p)), className: t.getMonthClassNames(p), "aria-disabled": t.isMonthDisabled(p), role: "option", "aria-label": t.getAriaLabel(p), "aria-current": t.isCurrentMonth(i, p) ? "date" : void 0, "aria-selected": c ? t.isSelectedMonth(i, p, c) : void 0 }, t.getMonthContent(p));
          }));
        });
      }, t.renderQuarters = function() {
        var e = t.props, n = e.day, o = e.selected, s = [1, 2, 3, 4];
        return h.createElement("div", { className: "react-datepicker__quarter-wrapper" }, s.map(function(i, c) {
          return h.createElement("div", { key: c, ref: t.QUARTER_REFS[c], role: "option", onClick: function(l) {
            t.onQuarterClick(l, i);
          }, onKeyDown: function(l) {
            t.onQuarterKeyDown(l, i);
          }, onMouseEnter: t.props.usePointerEvent ? void 0 : function() {
            return t.onQuarterMouseEnter(i);
          }, onPointerEnter: t.props.usePointerEvent ? function() {
            return t.onQuarterMouseEnter(i);
          } : void 0, className: t.getQuarterClassNames(i), "aria-selected": o ? t.isSelectedQuarter(n, i, o) : void 0, tabIndex: Number(t.getQuarterTabIndex(i)), "aria-current": t.isCurrentQuarter(n, i) ? "date" : void 0 }, t.getQuarterContent(i));
        }));
      }, t.getClassNames = function() {
        var e = t.props, n = e.selectingDate, o = e.selectsStart, s = e.selectsEnd, i = e.showMonthYearPicker, c = e.showQuarterYearPicker, l = e.showWeekPicker;
        return Z("react-datepicker__month", {
          "react-datepicker__month--selecting-range": n && (o || s)
        }, { "react-datepicker__monthPicker": i }, { "react-datepicker__quarterPicker": c }, { "react-datepicker__weekPicker": l });
      }, t;
    }
    return a.prototype.getSelection = function() {
      var t = this.props, e = t.selected, n = t.selectedDates, o = t.selectsMultiple;
      if (o)
        return n;
      if (e)
        return [e];
    }, a.prototype.render = function() {
      var t = this.props, e = t.showMonthYearPicker, n = t.showQuarterYearPicker, o = t.day, s = t.ariaLabelPrefix, i = s === void 0 ? "Month " : s, c = i ? i.trim() + " " : "";
      return h.createElement("div", { className: this.getClassNames(), onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave, onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0, "aria-label": "".concat(c).concat(U(o, "MMMM, yyyy", this.props.locale)), role: "listbox" }, e ? this.renderMonths() : n ? this.renderQuarters() : this.renderWeeks());
    }, a;
  }(G)
), ui = (
  /** @class */
  function(r) {
    J(a, r);
    function a() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.isSelectedMonth = function(e) {
        return t.props.month === e;
      }, t.renderOptions = function() {
        return t.props.monthNames.map(function(e, n) {
          return h.createElement(
            "div",
            { className: t.isSelectedMonth(n) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: e, onClick: t.onChange.bind(t, n), "aria-selected": t.isSelectedMonth(n) ? "true" : void 0 },
            t.isSelectedMonth(n) ? h.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "",
            e
          );
        });
      }, t.onChange = function(e) {
        return t.props.onChange(e);
      }, t.handleClickOutside = function() {
        return t.props.onCancel();
      }, t;
    }
    return a.prototype.render = function() {
      return h.createElement("div", { className: "react-datepicker__month-dropdown" }, this.renderOptions());
    }, a;
  }(G)
), di = Yt(ui), pi = (
  /** @class */
  function(r) {
    J(a, r);
    function a() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.state = {
        dropdownVisible: !1
      }, t.renderSelectOptions = function(e) {
        return e.map(function(n, o) {
          return h.createElement("option", { key: n, value: o }, n);
        });
      }, t.renderSelectMode = function(e) {
        return h.createElement("select", { value: t.props.month, className: "react-datepicker__month-select", onChange: function(n) {
          return t.onChange(parseInt(n.target.value));
        } }, t.renderSelectOptions(e));
      }, t.renderReadView = function(e, n) {
        return h.createElement(
          "div",
          { key: "read", style: { visibility: e ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: t.toggleDropdown },
          h.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
          h.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, n[t.props.month])
        );
      }, t.renderDropdown = function(e) {
        return h.createElement(di, L({ key: "dropdown" }, t.props, { monthNames: e, onChange: t.onChange, onCancel: t.toggleDropdown }));
      }, t.renderScrollMode = function(e) {
        var n = t.state.dropdownVisible, o = [t.renderReadView(!n, e)];
        return n && o.unshift(t.renderDropdown(e)), o;
      }, t.onChange = function(e) {
        t.toggleDropdown(), e !== t.props.month && t.props.onChange(e);
      }, t.toggleDropdown = function() {
        return t.setState({
          dropdownVisible: !t.state.dropdownVisible
        });
      }, t;
    }
    return a.prototype.render = function() {
      var t = this, e = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(o) {
        return Or(o, t.props.locale);
      } : function(o) {
        return gn(o, t.props.locale);
      }), n;
      switch (this.props.dropdownMode) {
        case "scroll":
          n = this.renderScrollMode(e);
          break;
        case "select":
          n = this.renderSelectMode(e);
          break;
      }
      return h.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, n);
    }, a;
  }(G)
);
function fi(r, a) {
  for (var t = [], e = Ce(r), n = Ce(a); !Se(e, n); )
    t.push(W(e)), e = me(e, 1);
  return t;
}
var hi = (
  /** @class */
  function(r) {
    J(a, r);
    function a(t) {
      var e = r.call(this, t) || this;
      return e.renderOptions = function() {
        return e.state.monthYearsList.map(function(n) {
          var o = Zt(n), s = le(e.props.date, n) && ne(e.props.date, n);
          return h.createElement(
            "div",
            { className: s ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option", key: o, onClick: e.onChange.bind(e, o), "aria-selected": s ? "true" : void 0 },
            s ? h.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "",
            U(n, e.props.dateFormat, e.props.locale)
          );
        });
      }, e.onChange = function(n) {
        return e.props.onChange(n);
      }, e.handleClickOutside = function() {
        e.props.onCancel();
      }, e.state = {
        monthYearsList: fi(e.props.minDate, e.props.maxDate)
      }, e;
    }
    return a.prototype.render = function() {
      var t = Z({
        "react-datepicker__month-year-dropdown": !0,
        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
      });
      return h.createElement("div", { className: t }, this.renderOptions());
    }, a;
  }(G)
), mi = Yt(hi), vi = (
  /** @class */
  function(r) {
    J(a, r);
    function a() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.state = {
        dropdownVisible: !1
      }, t.renderSelectOptions = function() {
        for (var e = Ce(t.props.minDate), n = Ce(t.props.maxDate), o = []; !Se(e, n); ) {
          var s = Zt(e);
          o.push(h.createElement("option", { key: s, value: s }, U(e, t.props.dateFormat, t.props.locale))), e = me(e, 1);
        }
        return o;
      }, t.onSelectChange = function(e) {
        t.onChange(parseInt(e.target.value));
      }, t.renderSelectMode = function() {
        return h.createElement("select", { value: Zt(Ce(t.props.date)), className: "react-datepicker__month-year-select", onChange: t.onSelectChange }, t.renderSelectOptions());
      }, t.renderReadView = function(e) {
        var n = U(t.props.date, t.props.dateFormat, t.props.locale);
        return h.createElement(
          "div",
          { key: "read", style: { visibility: e ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: t.toggleDropdown },
          h.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
          h.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, n)
        );
      }, t.renderDropdown = function() {
        return h.createElement(mi, L({ key: "dropdown" }, t.props, { onChange: t.onChange, onCancel: t.toggleDropdown }));
      }, t.renderScrollMode = function() {
        var e = t.state.dropdownVisible, n = [t.renderReadView(!e)];
        return e && n.unshift(t.renderDropdown()), n;
      }, t.onChange = function(e) {
        t.toggleDropdown();
        var n = W(e);
        le(t.props.date, n) && ne(t.props.date, n) || t.props.onChange(n);
      }, t.toggleDropdown = function() {
        return t.setState({
          dropdownVisible: !t.state.dropdownVisible
        });
      }, t;
    }
    return a.prototype.render = function() {
      var t;
      switch (this.props.dropdownMode) {
        case "scroll":
          t = this.renderScrollMode();
          break;
        case "select":
          t = this.renderSelectMode();
          break;
      }
      return h.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, t);
    }, a;
  }(G)
), gi = (
  /** @class */
  function(r) {
    J(a, r);
    function a() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.state = {
        height: null
      }, t.scrollToTheSelectedTime = function() {
        requestAnimationFrame(function() {
          var e, n, o;
          t.list && (t.list.scrollTop = (o = t.centerLi && a.calcCenterPosition(t.props.monthRef ? t.props.monthRef.clientHeight - ((n = (e = t.header) === null || e === void 0 ? void 0 : e.clientHeight) !== null && n !== void 0 ? n : 0) : t.list.clientHeight, t.centerLi)) !== null && o !== void 0 ? o : 0);
        });
      }, t.handleClick = function(e) {
        var n, o;
        (t.props.minTime || t.props.maxTime) && Wn(e, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && Hn(e, t.props) || (o = (n = t.props).onChange) === null || o === void 0 || o.call(n, e);
      }, t.isSelectedTime = function(e) {
        return t.props.selected && ri(t.props.selected, e);
      }, t.isDisabledTime = function(e) {
        return (t.props.minTime || t.props.maxTime) && Wn(e, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && Hn(e, t.props);
      }, t.liClasses = function(e) {
        var n, o = [
          "react-datepicker__time-list-item",
          t.props.timeClassName ? t.props.timeClassName(e) : void 0
        ];
        return t.isSelectedTime(e) && o.push("react-datepicker__time-list-item--selected"), t.isDisabledTime(e) && o.push("react-datepicker__time-list-item--disabled"), t.props.injectTimes && (fe(e) * 3600 + he(e) * 60 + we(e)) % (((n = t.props.intervals) !== null && n !== void 0 ? n : a.defaultProps.intervals) * 60) !== 0 && o.push("react-datepicker__time-list-item--injected"), o.join(" ");
      }, t.handleOnKeyDown = function(e, n) {
        var o, s;
        e.key === w.Space && (e.preventDefault(), e.key = w.Enter), (e.key === w.ArrowUp || e.key === w.ArrowLeft) && e.target instanceof HTMLElement && e.target.previousSibling && (e.preventDefault(), e.target.previousSibling instanceof HTMLElement && e.target.previousSibling.focus()), (e.key === w.ArrowDown || e.key === w.ArrowRight) && e.target instanceof HTMLElement && e.target.nextSibling && (e.preventDefault(), e.target.nextSibling instanceof HTMLElement && e.target.nextSibling.focus()), e.key === w.Enter && t.handleClick(n), (s = (o = t.props).handleOnKeyDown) === null || s === void 0 || s.call(o, e);
      }, t.renderTimes = function() {
        for (var e, n = [], o = t.props.format ? t.props.format : "p", s = (e = t.props.intervals) !== null && e !== void 0 ? e : a.defaultProps.intervals, i = t.props.selected || t.props.openToDate || W(), c = Dt(i), l = t.props.injectTimes && t.props.injectTimes.sort(function(v, D) {
          return v.getTime() - D.getTime();
        }), u = 60 * ni(i), d = u / s, p = 0; p < d; p++) {
          var f = Xt(c, p * s);
          if (n.push(f), l) {
            var m = ti(c, f, p, s, l);
            n = n.concat(m);
          }
        }
        var g = n.reduce(function(v, D) {
          return D.getTime() <= i.getTime() ? D : v;
        }, n[0]);
        return n.map(function(v) {
          return h.createElement("li", { key: v.valueOf(), onClick: t.handleClick.bind(t, v), className: t.liClasses(v), ref: function(D) {
            v === g && (t.centerLi = D);
          }, onKeyDown: function(D) {
            t.handleOnKeyDown(D, v);
          }, tabIndex: v === g ? 0 : -1, role: "option", "aria-selected": t.isSelectedTime(v) ? "true" : void 0, "aria-disabled": t.isDisabledTime(v) ? "true" : void 0 }, U(v, o, t.props.locale));
        });
      }, t;
    }
    return Object.defineProperty(a, "defaultProps", {
      get: function() {
        return {
          intervals: 30,
          todayButton: null,
          timeCaption: "Time"
        };
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.componentDidMount = function() {
      this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
        height: this.props.monthRef.clientHeight - this.header.clientHeight
      });
    }, a.prototype.render = function() {
      var t = this, e, n = this.state.height;
      return h.createElement(
        "div",
        { className: "react-datepicker__time-container ".concat(((e = this.props.todayButton) !== null && e !== void 0 ? e : a.defaultProps.todayButton) ? "react-datepicker__time-container--with-today-button" : "") },
        h.createElement(
          "div",
          { className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""), ref: function(o) {
            t.header = o;
          } },
          h.createElement("div", { className: "react-datepicker-time__header" }, this.props.timeCaption)
        ),
        h.createElement(
          "div",
          { className: "react-datepicker__time" },
          h.createElement(
            "div",
            { className: "react-datepicker__time-box" },
            h.createElement("ul", { className: "react-datepicker__time-list", ref: function(o) {
              t.list = o;
            }, style: n ? { height: n } : {}, role: "listbox", "aria-label": this.props.timeCaption }, this.renderTimes())
          )
        )
      );
    }, a.calcCenterPosition = function(t, e) {
      return e.offsetTop - (t / 2 - e.clientHeight / 2);
    }, a;
  }(G)
), Gn = 3, Di = (
  /** @class */
  function(r) {
    J(a, r);
    function a(t) {
      var e = r.call(this, t) || this;
      return e.YEAR_REFS = pe([], Array(e.props.yearItemNumber), !0).map(function() {
        return Me();
      }), e.isDisabled = function(n) {
        return be(n, {
          minDate: e.props.minDate,
          maxDate: e.props.maxDate,
          excludeDates: e.props.excludeDates,
          includeDates: e.props.includeDates,
          filterDate: e.props.filterDate
        });
      }, e.isExcluded = function(n) {
        return Dn(n, {
          excludeDates: e.props.excludeDates
        });
      }, e.selectingDate = function() {
        var n;
        return (n = e.props.selectingDate) !== null && n !== void 0 ? n : e.props.preSelection;
      }, e.updateFocusOnPaginate = function(n) {
        var o = function() {
          var s, i;
          (i = (s = e.YEAR_REFS[n]) === null || s === void 0 ? void 0 : s.current) === null || i === void 0 || i.focus();
        };
        window.requestAnimationFrame(o);
      }, e.handleYearClick = function(n, o) {
        e.props.onDayClick && e.props.onDayClick(n, o);
      }, e.handleYearNavigation = function(n, o) {
        var s, i, c, l, u = e.props, d = u.date, p = u.yearItemNumber;
        if (!(d === void 0 || p === void 0)) {
          var f = _e(d, p).startPeriod;
          e.isDisabled(o) || e.isExcluded(o) || ((i = (s = e.props).setPreSelection) === null || i === void 0 || i.call(s, o), n - f < 0 ? e.updateFocusOnPaginate(p - (f - n)) : n - f >= p ? e.updateFocusOnPaginate(Math.abs(p - (n - f))) : (l = (c = e.YEAR_REFS[n - f]) === null || c === void 0 ? void 0 : c.current) === null || l === void 0 || l.focus());
        }
      }, e.isSameDay = function(n, o) {
        return I(n, o);
      }, e.isCurrentYear = function(n) {
        return n === R(W());
      }, e.isRangeStart = function(n) {
        return e.props.startDate && e.props.endDate && le(ce(W(), n), e.props.startDate);
      }, e.isRangeEnd = function(n) {
        return e.props.startDate && e.props.endDate && le(ce(W(), n), e.props.endDate);
      }, e.isInRange = function(n) {
        return dt(n, e.props.startDate, e.props.endDate);
      }, e.isInSelectingRange = function(n) {
        var o = e.props, s = o.selectsStart, i = o.selectsEnd, c = o.selectsRange, l = o.startDate, u = o.endDate;
        return !(s || i || c) || !e.selectingDate() ? !1 : s && u ? dt(n, e.selectingDate(), u) : i && l || c && l && !u ? dt(n, l, e.selectingDate()) : !1;
      }, e.isSelectingRangeStart = function(n) {
        var o;
        if (!e.isInSelectingRange(n))
          return !1;
        var s = e.props, i = s.startDate, c = s.selectsStart, l = ce(W(), n);
        return c ? le(l, (o = e.selectingDate()) !== null && o !== void 0 ? o : null) : le(l, i ?? null);
      }, e.isSelectingRangeEnd = function(n) {
        var o;
        if (!e.isInSelectingRange(n))
          return !1;
        var s = e.props, i = s.endDate, c = s.selectsEnd, l = s.selectsRange, u = ce(W(), n);
        return c || l ? le(u, (o = e.selectingDate()) !== null && o !== void 0 ? o : null) : le(u, i ?? null);
      }, e.isKeyboardSelected = function(n) {
        if (!(e.props.date === void 0 || e.props.selected == null || e.props.preSelection == null)) {
          var o = e.props, s = o.minDate, i = o.maxDate, c = o.excludeDates, l = o.includeDates, u = o.filterDate, d = je(ce(e.props.date, n)), p = (s || i || c || l || u) && an(n, e.props);
          return !e.props.disabledKeyboardNavigation && !e.props.inline && !I(d, je(e.props.selected)) && I(d, je(e.props.preSelection)) && !p;
        }
      }, e.onYearClick = function(n, o) {
        var s = e.props.date;
        s !== void 0 && e.handleYearClick(je(ce(s, o)), n);
      }, e.onYearKeyDown = function(n, o) {
        var s, i, c = n.key, l = e.props, u = l.date, d = l.yearItemNumber, p = l.handleOnKeyDown;
        if (c !== w.Tab && n.preventDefault(), !e.props.disabledKeyboardNavigation)
          switch (c) {
            case w.Enter:
              if (e.props.selected == null)
                break;
              e.onYearClick(n, o), (i = (s = e.props).setPreSelection) === null || i === void 0 || i.call(s, e.props.selected);
              break;
            case w.ArrowRight:
              if (e.props.preSelection == null)
                break;
              e.handleYearNavigation(o + 1, De(e.props.preSelection, 1));
              break;
            case w.ArrowLeft:
              if (e.props.preSelection == null)
                break;
              e.handleYearNavigation(o - 1, Be(e.props.preSelection, 1));
              break;
            case w.ArrowUp: {
              if (u === void 0 || d === void 0 || e.props.preSelection == null)
                break;
              var f = _e(u, d).startPeriod, m = Gn, g = o - m;
              if (g < f) {
                var v = d % m;
                o >= f && o < f + v ? m = v : m += v, g = o - m;
              }
              e.handleYearNavigation(g, Be(e.props.preSelection, m));
              break;
            }
            case w.ArrowDown: {
              if (u === void 0 || d === void 0 || e.props.preSelection == null)
                break;
              var D = _e(u, d).endPeriod, m = Gn, g = o + m;
              if (g > D) {
                var v = d % m;
                o <= D && o > D - v ? m = v : m += v, g = o + m;
              }
              e.handleYearNavigation(g, De(e.props.preSelection, m));
              break;
            }
          }
        p && p(n);
      }, e.getYearClassNames = function(n) {
        var o = e.props, s = o.date, i = o.minDate, c = o.maxDate, l = o.selected, u = o.excludeDates, d = o.includeDates, p = o.filterDate, f = o.yearClassName;
        return Z("react-datepicker__year-text", "react-datepicker__year-".concat(n), s ? f == null ? void 0 : f(ce(s, n)) : void 0, {
          "react-datepicker__year-text--selected": l ? n === R(l) : void 0,
          "react-datepicker__year-text--disabled": (i || c || u || d || p) && an(n, e.props),
          "react-datepicker__year-text--keyboard-selected": e.isKeyboardSelected(n),
          "react-datepicker__year-text--range-start": e.isRangeStart(n),
          "react-datepicker__year-text--range-end": e.isRangeEnd(n),
          "react-datepicker__year-text--in-range": e.isInRange(n),
          "react-datepicker__year-text--in-selecting-range": e.isInSelectingRange(n),
          "react-datepicker__year-text--selecting-range-start": e.isSelectingRangeStart(n),
          "react-datepicker__year-text--selecting-range-end": e.isSelectingRangeEnd(n),
          "react-datepicker__year-text--today": e.isCurrentYear(n)
        });
      }, e.getYearTabIndex = function(n) {
        if (e.props.disabledKeyboardNavigation || e.props.preSelection == null)
          return "-1";
        var o = R(e.props.preSelection);
        return n === o ? "0" : "-1";
      }, e.getYearContainerClassNames = function() {
        var n = e.props, o = n.selectingDate, s = n.selectsStart, i = n.selectsEnd, c = n.selectsRange;
        return Z("react-datepicker__year", {
          "react-datepicker__year--selecting-range": o && (s || i || c)
        });
      }, e.getYearContent = function(n) {
        return e.props.renderYearContent ? e.props.renderYearContent(n) : n;
      }, e;
    }
    return a.prototype.render = function() {
      var t = this, e = [], n = this.props, o = n.date, s = n.yearItemNumber, i = n.onYearMouseEnter, c = n.onYearMouseLeave;
      if (o === void 0)
        return null;
      for (var l = _e(o, s), u = l.startPeriod, d = l.endPeriod, p = function(g) {
        e.push(h.createElement("div", { ref: f.YEAR_REFS[g - u], onClick: function(v) {
          t.onYearClick(v, g);
        }, onKeyDown: function(v) {
          Yr(v) && (v.preventDefault(), v.key = w.Enter), t.onYearKeyDown(v, g);
        }, tabIndex: Number(f.getYearTabIndex(g)), className: f.getYearClassNames(g), onMouseEnter: f.props.usePointerEvent ? void 0 : function(v) {
          return i(v, g);
        }, onPointerEnter: f.props.usePointerEvent ? function(v) {
          return i(v, g);
        } : void 0, onMouseLeave: f.props.usePointerEvent ? void 0 : function(v) {
          return c(v, g);
        }, onPointerLeave: f.props.usePointerEvent ? function(v) {
          return c(v, g);
        } : void 0, key: g, "aria-current": f.isCurrentYear(g) ? "date" : void 0 }, f.getYearContent(g)));
      }, f = this, m = u; m <= d; m++)
        p(m);
      return h.createElement(
        "div",
        { className: this.getYearContainerClassNames() },
        h.createElement("div", { className: "react-datepicker__year-wrapper", onMouseLeave: this.props.usePointerEvent ? void 0 : this.props.clearSelectingDate, onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0 }, e)
      );
    }, a;
  }(G)
);
function wi(r, a, t, e) {
  for (var n = [], o = 0; o < 2 * a + 1; o++) {
    var s = r + a - o, i = !0;
    t && (i = R(t) <= s), e && i && (i = R(e) >= s), i && n.push(s);
  }
  return n;
}
var yi = (
  /** @class */
  function(r) {
    J(a, r);
    function a(t) {
      var e = r.call(this, t) || this;
      e.renderOptions = function() {
        var i = e.props.year, c = e.state.yearsList.map(function(d) {
          return h.createElement(
            "div",
            { className: i === d ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: d, onClick: e.onChange.bind(e, d), "aria-selected": i === d ? "true" : void 0 },
            i === d ? h.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "",
            d
          );
        }), l = e.props.minDate ? R(e.props.minDate) : null, u = e.props.maxDate ? R(e.props.maxDate) : null;
        return (!u || !e.state.yearsList.find(function(d) {
          return d === u;
        })) && c.unshift(h.createElement(
          "div",
          { className: "react-datepicker__year-option", key: "upcoming", onClick: e.incrementYears },
          h.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
        )), (!l || !e.state.yearsList.find(function(d) {
          return d === l;
        })) && c.push(h.createElement(
          "div",
          { className: "react-datepicker__year-option", key: "previous", onClick: e.decrementYears },
          h.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
        )), c;
      }, e.onChange = function(i) {
        e.props.onChange(i);
      }, e.handleClickOutside = function() {
        e.props.onCancel();
      }, e.shiftYears = function(i) {
        var c = e.state.yearsList.map(function(l) {
          return l + i;
        });
        e.setState({
          yearsList: c
        });
      }, e.incrementYears = function() {
        return e.shiftYears(1);
      }, e.decrementYears = function() {
        return e.shiftYears(-1);
      };
      var n = t.yearDropdownItemNumber, o = t.scrollableYearDropdown, s = n || (o ? 10 : 5);
      return e.state = {
        yearsList: wi(e.props.year, s, e.props.minDate, e.props.maxDate)
      }, e.dropdownRef = Me(), e;
    }
    return a.prototype.componentDidMount = function() {
      var t = this.dropdownRef.current;
      if (t) {
        var e = t.children ? Array.from(t.children) : null, n = e ? e.find(function(o) {
          return o.ariaSelected;
        }) : null;
        t.scrollTop = n && n instanceof HTMLElement ? n.offsetTop + (n.clientHeight - t.clientHeight) / 2 : (t.scrollHeight - t.clientHeight) / 2;
      }
    }, a.prototype.render = function() {
      var t = Z({
        "react-datepicker__year-dropdown": !0,
        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
      });
      return h.createElement("div", { className: t, ref: this.dropdownRef }, this.renderOptions());
    }, a;
  }(G)
), bi = Yt(yi), _i = (
  /** @class */
  function(r) {
    J(a, r);
    function a() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.state = {
        dropdownVisible: !1
      }, t.renderSelectOptions = function() {
        for (var e = t.props.minDate ? R(t.props.minDate) : 1900, n = t.props.maxDate ? R(t.props.maxDate) : 2100, o = [], s = e; s <= n; s++)
          o.push(h.createElement("option", { key: s, value: s }, s));
        return o;
      }, t.onSelectChange = function(e) {
        t.onChange(parseInt(e.target.value));
      }, t.renderSelectMode = function() {
        return h.createElement("select", { value: t.props.year, className: "react-datepicker__year-select", onChange: t.onSelectChange }, t.renderSelectOptions());
      }, t.renderReadView = function(e) {
        return h.createElement(
          "div",
          { key: "read", style: { visibility: e ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: function(n) {
            return t.toggleDropdown(n);
          } },
          h.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
          h.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, t.props.year)
        );
      }, t.renderDropdown = function() {
        return h.createElement(bi, L({ key: "dropdown" }, t.props, { onChange: t.onChange, onCancel: t.toggleDropdown }));
      }, t.renderScrollMode = function() {
        var e = t.state.dropdownVisible, n = [t.renderReadView(!e)];
        return e && n.unshift(t.renderDropdown()), n;
      }, t.onChange = function(e) {
        t.toggleDropdown(), e !== t.props.year && t.props.onChange(e);
      }, t.toggleDropdown = function(e) {
        t.setState({
          dropdownVisible: !t.state.dropdownVisible
        }, function() {
          t.props.adjustDateOnChange && t.handleYearChange(t.props.date, e);
        });
      }, t.handleYearChange = function(e, n) {
        t.onSelect(e, n), t.setOpen();
      }, t.onSelect = function(e, n) {
        t.props.onSelect && t.props.onSelect(e, n);
      }, t.setOpen = function() {
        t.props.setOpen && t.props.setOpen(!0);
      }, t;
    }
    return a.prototype.render = function() {
      var t;
      switch (this.props.dropdownMode) {
        case "scroll":
          t = this.renderScrollMode();
          break;
        case "select":
          t = this.renderSelectMode();
          break;
      }
      return h.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, t);
    }, a;
  }(G)
), ki = [
  "react-datepicker__year-select",
  "react-datepicker__month-select",
  "react-datepicker__month-year-select"
], xi = function(r) {
  var a = (r.className || "").split(/\s+/);
  return ki.some(function(t) {
    return a.indexOf(t) >= 0;
  });
}, Ci = (
  /** @class */
  function(r) {
    J(a, r);
    function a(t) {
      var e = r.call(this, t) || this;
      return e.monthContainer = void 0, e.handleClickOutside = function(n) {
        e.props.onClickOutside(n);
      }, e.setClickOutsideRef = function() {
        return e.containerRef.current;
      }, e.handleDropdownFocus = function(n) {
        var o, s;
        xi(n.target) && ((s = (o = e.props).onDropdownFocus) === null || s === void 0 || s.call(o, n));
      }, e.getDateInView = function() {
        var n = e.props, o = n.preSelection, s = n.selected, i = n.openToDate, c = Nr(e.props), l = Rr(e.props), u = W(), d = i || s || o;
        return d || (c && Ye(u, c) ? c : l && Se(u, l) ? l : u);
      }, e.increaseMonth = function() {
        e.setState(function(n) {
          var o = n.date;
          return {
            date: me(o, 1)
          };
        }, function() {
          return e.handleMonthChange(e.state.date);
        });
      }, e.decreaseMonth = function() {
        e.setState(function(n) {
          var o = n.date;
          return {
            date: We(o, 1)
          };
        }, function() {
          return e.handleMonthChange(e.state.date);
        });
      }, e.handleDayClick = function(n, o, s) {
        e.props.onSelect(n, o, s), e.props.setPreSelection && e.props.setPreSelection(n);
      }, e.handleDayMouseEnter = function(n) {
        e.setState({ selectingDate: n }), e.props.onDayMouseEnter && e.props.onDayMouseEnter(n);
      }, e.handleMonthMouseLeave = function() {
        e.setState({ selectingDate: void 0 }), e.props.onMonthMouseLeave && e.props.onMonthMouseLeave();
      }, e.handleYearMouseEnter = function(n, o) {
        e.setState({ selectingDate: ce(W(), o) }), e.props.onYearMouseEnter && e.props.onYearMouseEnter(n, o);
      }, e.handleYearMouseLeave = function(n, o) {
        e.props.onYearMouseLeave && e.props.onYearMouseLeave(n, o);
      }, e.handleYearChange = function(n) {
        e.props.onYearChange && (e.props.onYearChange(n), e.setState({ isRenderAriaLiveMessage: !0 })), e.props.adjustDateOnChange && (e.props.onSelect && e.props.onSelect(n), e.props.setOpen && e.props.setOpen(!0)), e.props.setPreSelection && e.props.setPreSelection(n);
      }, e.handleMonthChange = function(n) {
        e.handleCustomMonthChange(n), e.props.adjustDateOnChange && (e.props.onSelect && e.props.onSelect(n), e.props.setOpen && e.props.setOpen(!0)), e.props.setPreSelection && e.props.setPreSelection(n);
      }, e.handleCustomMonthChange = function(n) {
        e.props.onMonthChange && (e.props.onMonthChange(n), e.setState({ isRenderAriaLiveMessage: !0 }));
      }, e.handleMonthYearChange = function(n) {
        e.handleYearChange(n), e.handleMonthChange(n);
      }, e.changeYear = function(n) {
        e.setState(function(o) {
          var s = o.date;
          return {
            date: ce(s, Number(n))
          };
        }, function() {
          return e.handleYearChange(e.state.date);
        });
      }, e.changeMonth = function(n) {
        e.setState(function(o) {
          var s = o.date;
          return {
            date: ae(s, Number(n))
          };
        }, function() {
          return e.handleMonthChange(e.state.date);
        });
      }, e.changeMonthYear = function(n) {
        e.setState(function(o) {
          var s = o.date;
          return {
            date: ce(ae(s, re(n)), R(n))
          };
        }, function() {
          return e.handleMonthYearChange(e.state.date);
        });
      }, e.header = function(n) {
        n === void 0 && (n = e.state.date);
        var o = xe(n, e.props.locale, e.props.calendarStartDay), s = [];
        return e.props.showWeekNumbers && s.push(h.createElement("div", { key: "W", className: "react-datepicker__day-name" }, e.props.weekLabel || "#")), s.concat([0, 1, 2, 3, 4, 5, 6].map(function(i) {
          var c = Le(o, i), l = e.formatWeekday(c, e.props.locale), u = e.props.weekDayClassName ? e.props.weekDayClassName(c) : void 0;
          return h.createElement("div", { key: i, "aria-label": U(c, "EEEE", e.props.locale), className: Z("react-datepicker__day-name", u) }, l);
        }));
      }, e.formatWeekday = function(n, o) {
        return e.props.formatWeekDay ? Vs(n, e.props.formatWeekDay, o) : e.props.useWeekdaysShort ? qs(n, o) : Us(n, o);
      }, e.decreaseYear = function() {
        e.setState(function(n) {
          var o, s = n.date;
          return {
            date: Be(s, e.props.showYearPicker ? (o = e.props.yearItemNumber) !== null && o !== void 0 ? o : a.defaultProps.yearItemNumber : 1)
          };
        }, function() {
          return e.handleYearChange(e.state.date);
        });
      }, e.clearSelectingDate = function() {
        e.setState({ selectingDate: void 0 });
      }, e.renderPreviousButton = function() {
        var n;
        if (!e.props.renderCustomHeader) {
          var o;
          switch (!0) {
            case e.props.showMonthYearPicker:
              o = Kn(e.state.date, e.props);
              break;
            case e.props.showYearPicker:
              o = Gs(e.state.date, e.props);
              break;
            case e.props.showQuarterYearPicker:
              o = zs(e.state.date, e.props);
              break;
            default:
              o = Bn(e.state.date, e.props);
              break;
          }
          if (!(!((n = e.props.forceShowMonthNavigation) !== null && n !== void 0 ? n : a.defaultProps.forceShowMonthNavigation) && !e.props.showDisabledMonthNavigation && o || e.props.showTimeSelectOnly)) {
            var s = [
              "react-datepicker__navigation-icon",
              "react-datepicker__navigation-icon--previous"
            ], i = [
              "react-datepicker__navigation",
              "react-datepicker__navigation--previous"
            ], c = e.decreaseMonth;
            (e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker) && (c = e.decreaseYear), o && e.props.showDisabledMonthNavigation && (i.push("react-datepicker__navigation--previous--disabled"), c = void 0);
            var l = e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker, u = e.props, d = u.previousMonthButtonLabel, p = d === void 0 ? a.defaultProps.previousMonthButtonLabel : d, f = u.previousYearButtonLabel, m = f === void 0 ? a.defaultProps.previousYearButtonLabel : f, g = e.props, v = g.previousMonthAriaLabel, D = v === void 0 ? typeof p == "string" ? p : "Previous Month" : v, C = g.previousYearAriaLabel, b = C === void 0 ? typeof m == "string" ? m : "Previous Year" : C;
            return h.createElement(
              "button",
              { type: "button", className: i.join(" "), onClick: c, onKeyDown: e.props.handleOnKeyDown, "aria-label": l ? b : D },
              h.createElement("span", { className: s.join(" ") }, l ? m : p)
            );
          }
        }
      }, e.increaseYear = function() {
        e.setState(function(n) {
          var o, s = n.date;
          return {
            date: De(s, e.props.showYearPicker ? (o = e.props.yearItemNumber) !== null && o !== void 0 ? o : a.defaultProps.yearItemNumber : 1)
          };
        }, function() {
          return e.handleYearChange(e.state.date);
        });
      }, e.renderNextButton = function() {
        var n;
        if (!e.props.renderCustomHeader) {
          var o;
          switch (!0) {
            case e.props.showMonthYearPicker:
              o = Vn(e.state.date, e.props);
              break;
            case e.props.showYearPicker:
              o = Zs(e.state.date, e.props);
              break;
            case e.props.showQuarterYearPicker:
              o = Xs(e.state.date, e.props);
              break;
            default:
              o = Qn(e.state.date, e.props);
              break;
          }
          if (!(!((n = e.props.forceShowMonthNavigation) !== null && n !== void 0 ? n : a.defaultProps.forceShowMonthNavigation) && !e.props.showDisabledMonthNavigation && o || e.props.showTimeSelectOnly)) {
            var s = [
              "react-datepicker__navigation",
              "react-datepicker__navigation--next"
            ], i = [
              "react-datepicker__navigation-icon",
              "react-datepicker__navigation-icon--next"
            ];
            e.props.showTimeSelect && s.push("react-datepicker__navigation--next--with-time"), e.props.todayButton && s.push("react-datepicker__navigation--next--with-today-button");
            var c = e.increaseMonth;
            (e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker) && (c = e.increaseYear), o && e.props.showDisabledMonthNavigation && (s.push("react-datepicker__navigation--next--disabled"), c = void 0);
            var l = e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker, u = e.props, d = u.nextMonthButtonLabel, p = d === void 0 ? a.defaultProps.nextMonthButtonLabel : d, f = u.nextYearButtonLabel, m = f === void 0 ? a.defaultProps.nextYearButtonLabel : f, g = e.props, v = g.nextMonthAriaLabel, D = v === void 0 ? typeof p == "string" ? p : "Next Month" : v, C = g.nextYearAriaLabel, b = C === void 0 ? typeof m == "string" ? m : "Next Year" : C;
            return h.createElement(
              "button",
              { type: "button", className: s.join(" "), onClick: c, onKeyDown: e.props.handleOnKeyDown, "aria-label": l ? b : D },
              h.createElement("span", { className: i.join(" ") }, l ? m : p)
            );
          }
        }
      }, e.renderCurrentMonth = function(n) {
        n === void 0 && (n = e.state.date);
        var o = ["react-datepicker__current-month"];
        return e.props.showYearDropdown && o.push("react-datepicker__current-month--hasYearDropdown"), e.props.showMonthDropdown && o.push("react-datepicker__current-month--hasMonthDropdown"), e.props.showMonthYearDropdown && o.push("react-datepicker__current-month--hasMonthYearDropdown"), h.createElement("h2", { className: o.join(" ") }, U(n, e.props.dateFormat, e.props.locale));
      }, e.renderYearDropdown = function(n) {
        if (n === void 0 && (n = !1), !(!e.props.showYearDropdown || n))
          return h.createElement(_i, L({}, a.defaultProps, e.props, { date: e.state.date, onChange: e.changeYear, year: R(e.state.date) }));
      }, e.renderMonthDropdown = function(n) {
        if (n === void 0 && (n = !1), !(!e.props.showMonthDropdown || n))
          return h.createElement(pi, L({}, a.defaultProps, e.props, { month: re(e.state.date), onChange: e.changeMonth }));
      }, e.renderMonthYearDropdown = function(n) {
        if (n === void 0 && (n = !1), !(!e.props.showMonthYearDropdown || n))
          return h.createElement(vi, L({}, a.defaultProps, e.props, { date: e.state.date, onChange: e.changeMonthYear }));
      }, e.handleTodayButtonClick = function(n) {
        e.props.onSelect(Ln(), n), e.props.setPreSelection && e.props.setPreSelection(Ln());
      }, e.renderTodayButton = function() {
        if (!(!e.props.todayButton || e.props.showTimeSelectOnly))
          return h.createElement("div", { className: "react-datepicker__today-button", onClick: e.handleTodayButtonClick }, e.props.todayButton);
      }, e.renderDefaultHeader = function(n) {
        var o = n.monthDate, s = n.i;
        return h.createElement(
          "div",
          { className: "react-datepicker__header ".concat(e.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "") },
          e.renderCurrentMonth(o),
          h.createElement(
            "div",
            { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(e.props.dropdownMode), onFocus: e.handleDropdownFocus },
            e.renderMonthDropdown(s !== 0),
            e.renderMonthYearDropdown(s !== 0),
            e.renderYearDropdown(s !== 0)
          ),
          h.createElement("div", { className: "react-datepicker__day-names" }, e.header(o))
        );
      }, e.renderCustomHeader = function(n) {
        var o, s, i = n.monthDate, c = n.i;
        if (e.props.showTimeSelect && !e.state.monthContainer || e.props.showTimeSelectOnly)
          return null;
        var l = Bn(e.state.date, e.props), u = Qn(e.state.date, e.props), d = Kn(e.state.date, e.props), p = Vn(e.state.date, e.props), f = !e.props.showMonthYearPicker && !e.props.showQuarterYearPicker && !e.props.showYearPicker;
        return h.createElement(
          "div",
          { className: "react-datepicker__header react-datepicker__header--custom", onFocus: e.props.onDropdownFocus },
          (s = (o = e.props).renderCustomHeader) === null || s === void 0 ? void 0 : s.call(o, L(L({}, e.state), { customHeaderCount: c, monthDate: i, changeMonth: e.changeMonth, changeYear: e.changeYear, decreaseMonth: e.decreaseMonth, increaseMonth: e.increaseMonth, decreaseYear: e.decreaseYear, increaseYear: e.increaseYear, prevMonthButtonDisabled: l, nextMonthButtonDisabled: u, prevYearButtonDisabled: d, nextYearButtonDisabled: p })),
          f && h.createElement("div", { className: "react-datepicker__day-names" }, e.header(i))
        );
      }, e.renderYearHeader = function(n) {
        var o = n.monthDate, s = e.props, i = s.showYearPicker, c = s.yearItemNumber, l = c === void 0 ? a.defaultProps.yearItemNumber : c, u = _e(o, l), d = u.startPeriod, p = u.endPeriod;
        return h.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, i ? "".concat(d, " - ").concat(p) : R(o));
      }, e.renderHeader = function(n) {
        var o = n.monthDate, s = n.i, i = s === void 0 ? 0 : s, c = { monthDate: o, i };
        switch (!0) {
          case e.props.renderCustomHeader !== void 0:
            return e.renderCustomHeader(c);
          case (e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker):
            return e.renderYearHeader(c);
          default:
            return e.renderDefaultHeader(c);
        }
      }, e.renderMonths = function() {
        var n, o;
        if (!(e.props.showTimeSelectOnly || e.props.showYearPicker)) {
          for (var s = [], i = (n = e.props.monthsShown) !== null && n !== void 0 ? n : a.defaultProps.monthsShown, c = e.props.showPreviousMonths ? i - 1 : 0, l = e.props.showMonthYearPicker || e.props.showQuarterYearPicker ? De(e.state.date, c) : We(e.state.date, c), u = (o = e.props.monthSelectedIn) !== null && o !== void 0 ? o : c, d = 0; d < i; ++d) {
            var p = d - u + c, f = e.props.showMonthYearPicker || e.props.showQuarterYearPicker ? De(l, p) : me(l, p), m = "month-".concat(d), g = d < i - 1, v = d > 0;
            s.push(h.createElement(
              "div",
              { key: m, ref: function(D) {
                e.monthContainer = D ?? void 0;
              }, className: "react-datepicker__month-container" },
              e.renderHeader({ monthDate: f, i: d }),
              h.createElement(li, L({}, a.defaultProps, e.props, { ariaLabelPrefix: e.props.monthAriaLabelPrefix, day: f, onDayClick: e.handleDayClick, handleOnKeyDown: e.props.handleOnDayKeyDown, handleOnMonthKeyDown: e.props.handleOnKeyDown, onDayMouseEnter: e.handleDayMouseEnter, onMouseLeave: e.handleMonthMouseLeave, orderInDisplay: d, selectingDate: e.state.selectingDate, monthShowsDuplicateDaysEnd: g, monthShowsDuplicateDaysStart: v }))
            ));
          }
          return s;
        }
      }, e.renderYears = function() {
        if (!e.props.showTimeSelectOnly && e.props.showYearPicker)
          return h.createElement(
            "div",
            { className: "react-datepicker__year--container" },
            e.renderHeader({ monthDate: e.state.date }),
            h.createElement(Di, L({}, a.defaultProps, e.props, { selectingDate: e.state.selectingDate, date: e.state.date, onDayClick: e.handleDayClick, clearSelectingDate: e.clearSelectingDate, onYearMouseEnter: e.handleYearMouseEnter, onYearMouseLeave: e.handleYearMouseLeave }))
          );
      }, e.renderTimeSection = function() {
        if (e.props.showTimeSelect && (e.state.monthContainer || e.props.showTimeSelectOnly))
          return h.createElement(gi, L({}, a.defaultProps, e.props, { onChange: e.props.onTimeChange, format: e.props.timeFormat, intervals: e.props.timeIntervals, monthRef: e.state.monthContainer }));
      }, e.renderInputTimeSection = function() {
        var n = e.props.selected ? new Date(e.props.selected) : void 0, o = n && ge(n) && !!e.props.selected, s = o ? "".concat(qn(n.getHours()), ":").concat(qn(n.getMinutes())) : "";
        if (e.props.showTimeInput)
          return h.createElement(ai, L({}, a.defaultProps, e.props, { date: n, timeString: s, onChange: e.props.onTimeChange }));
      }, e.renderAriaLiveRegion = function() {
        var n, o = _e(e.state.date, (n = e.props.yearItemNumber) !== null && n !== void 0 ? n : a.defaultProps.yearItemNumber), s = o.startPeriod, i = o.endPeriod, c;
        return e.props.showYearPicker ? c = "".concat(s, " - ").concat(i) : e.props.showMonthYearPicker || e.props.showQuarterYearPicker ? c = R(e.state.date) : c = "".concat(gn(re(e.state.date), e.props.locale), " ").concat(R(e.state.date)), h.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, e.state.isRenderAriaLiveMessage && c);
      }, e.renderChildren = function() {
        if (e.props.children)
          return h.createElement("div", { className: "react-datepicker__children-container" }, e.props.children);
      }, e.containerRef = Me(), e.state = {
        date: e.getDateInView(),
        selectingDate: void 0,
        monthContainer: void 0,
        isRenderAriaLiveMessage: !1
      }, e;
    }
    return Object.defineProperty(a, "defaultProps", {
      get: function() {
        return {
          monthsShown: 1,
          forceShowMonthNavigation: !1,
          timeCaption: "Time",
          previousYearButtonLabel: "Previous Year",
          nextYearButtonLabel: "Next Year",
          previousMonthButtonLabel: "Previous Month",
          nextMonthButtonLabel: "Next Month",
          yearItemNumber: at
        };
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.componentDidMount = function() {
      var t = this;
      this.props.showTimeSelect && (this.assignMonthContainer = function() {
        t.setState({ monthContainer: t.monthContainer });
      }());
    }, a.prototype.componentDidUpdate = function(t) {
      var e = this;
      if (this.props.preSelection && (!I(this.props.preSelection, t.preSelection) || this.props.monthSelectedIn !== t.monthSelectedIn)) {
        var n = !ne(this.state.date, this.props.preSelection);
        this.setState({
          date: this.props.preSelection
        }, function() {
          return n && e.handleCustomMonthChange(e.state.date);
        });
      } else this.props.openToDate && !I(this.props.openToDate, t.openToDate) && this.setState({
        date: this.props.openToDate
      });
    }, a.prototype.render = function() {
      var t = this.props.container || Ls;
      return h.createElement(
        "div",
        { style: { display: "contents" }, ref: this.containerRef },
        h.createElement(
          t,
          { className: Z("react-datepicker", this.props.className, {
            "react-datepicker--time-only": this.props.showTimeSelectOnly
          }), showTime: this.props.showTimeSelect || this.props.showTimeInput, showTimeSelectOnly: this.props.showTimeSelectOnly },
          this.renderAriaLiveRegion(),
          this.renderPreviousButton(),
          this.renderNextButton(),
          this.renderMonths(),
          this.renderYears(),
          this.renderTodayButton(),
          this.renderTimeSection(),
          this.renderInputTimeSection(),
          this.renderChildren()
        )
      );
    }, a;
  }(G)
), Mi = function(r) {
  var a = r.icon, t = r.className, e = t === void 0 ? "" : t, n = r.onClick, o = "react-datepicker__calendar-icon";
  return typeof a == "string" ? h.createElement("i", { className: "".concat(o, " ").concat(a, " ").concat(e), "aria-hidden": "true", onClick: n }) : h.isValidElement(a) ? h.cloneElement(a, {
    className: "".concat(a.props.className || "", " ").concat(o, " ").concat(e),
    onClick: function(s) {
      typeof a.props.onClick == "function" && a.props.onClick(s), typeof n == "function" && n(s);
    }
  }) : h.createElement(
    "svg",
    { className: "".concat(o, " ").concat(e), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", onClick: n },
    h.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" })
  );
}, Ir = (
  /** @class */
  function(r) {
    J(a, r);
    function a(t) {
      var e = r.call(this, t) || this;
      return e.portalRoot = null, e.el = document.createElement("div"), e;
    }
    return a.prototype.componentDidMount = function() {
      this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
    }, a.prototype.componentWillUnmount = function() {
      this.portalRoot && this.portalRoot.removeChild(this.el);
    }, a.prototype.render = function() {
      return Kr.createPortal(this.props.children, this.el);
    }, a;
  }(G)
), Si = "[tabindex], a, button, input, select, textarea", Ei = function(r) {
  return (r instanceof HTMLAnchorElement || !r.disabled) && r.tabIndex !== -1;
}, Lr = (
  /** @class */
  function(r) {
    J(a, r);
    function a(t) {
      var e = r.call(this, t) || this;
      return e.getTabChildren = function() {
        var n;
        return Array.prototype.slice.call((n = e.tabLoopRef.current) === null || n === void 0 ? void 0 : n.querySelectorAll(Si), 1, -1).filter(Ei);
      }, e.handleFocusStart = function() {
        var n = e.getTabChildren();
        n && n.length > 1 && n[n.length - 1].focus();
      }, e.handleFocusEnd = function() {
        var n = e.getTabChildren();
        n && n.length > 1 && n[0].focus();
      }, e.tabLoopRef = Me(), e;
    }
    return a.prototype.render = function() {
      var t;
      return ((t = this.props.enableTabLoop) !== null && t !== void 0 ? t : a.defaultProps.enableTabLoop) ? h.createElement(
        "div",
        { className: "react-datepicker__tab-loop", ref: this.tabLoopRef },
        h.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: 0, onFocus: this.handleFocusStart }),
        this.props.children,
        h.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: 0, onFocus: this.handleFocusEnd })
      ) : this.props.children;
    }, a.defaultProps = {
      enableTabLoop: !0
    }, a;
  }(G)
);
function Pi(r) {
  var a = function(t) {
    var e, n = typeof t.hidePopper == "boolean" ? t.hidePopper : !0, o = rr(null), s = Is(L({ open: !n, whileElementsMounted: ds, placement: t.popperPlacement, middleware: pe([
      Ds({ padding: 15 }),
      gs(10),
      ws({ element: o })
    ], (e = t.popperModifiers) !== null && e !== void 0 ? e : [], !0) }, t.popperProps)), i = L(L({}, t), { hidePopper: n, popperProps: L(L({}, s), { arrowRef: o }) });
    return h.createElement(r, L({}, i));
  };
  return a;
}
var Oi = (
  /** @class */
  function(r) {
    J(a, r);
    function a() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return Object.defineProperty(a, "defaultProps", {
      get: function() {
        return {
          hidePopper: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.render = function() {
      var t = this.props, e = t.className, n = t.wrapperClassName, o = t.hidePopper, s = o === void 0 ? a.defaultProps.hidePopper : o, i = t.popperComponent, c = t.targetComponent, l = t.enableTabLoop, u = t.popperOnKeyDown, d = t.portalId, p = t.portalHost, f = t.popperProps, m = t.showArrow, g = void 0;
      if (!s) {
        var v = Z("react-datepicker-popper", e);
        g = h.createElement(
          Lr,
          { enableTabLoop: l },
          h.createElement(
            "div",
            { ref: f.refs.setFloating, style: f.floatingStyles, className: v, "data-placement": f.placement, onKeyDown: u },
            i,
            m && h.createElement(Es, { ref: f.arrowRef, context: f.context, fill: "currentColor", strokeWidth: 1, height: 8, width: 16, style: { transform: "translateY(-1px)" }, className: "react-datepicker__triangle" })
          )
        );
      }
      this.props.popperContainer && (g = Jn(this.props.popperContainer, {}, g)), d && !s && (g = h.createElement(Ir, { portalId: d, portalHost: p }, g));
      var D = Z("react-datepicker-wrapper", n);
      return h.createElement(
        h.Fragment,
        null,
        h.createElement("div", { ref: f.refs.setReference, className: D }, c),
        g
      );
    }, a;
  }(G)
), Ti = Pi(Oi), Zn = "react-datepicker-ignore-onclickoutside", Ni = Yt(Ci);
function Ri(r, a) {
  return r && a ? re(r) !== re(a) || R(r) !== R(a) : r !== a;
}
var Ut = "Date input not valid.", Yi = (
  /** @class */
  function(r) {
    J(a, r);
    function a(t) {
      var e = r.call(this, t) || this;
      return e.calendar = null, e.input = null, e.getPreSelection = function() {
        return e.props.openToDate ? e.props.openToDate : e.props.selectsEnd && e.props.startDate ? e.props.startDate : e.props.selectsStart && e.props.endDate ? e.props.endDate : W();
      }, e.modifyHolidays = function() {
        var n;
        return (n = e.props.holidays) === null || n === void 0 ? void 0 : n.reduce(function(o, s) {
          var i = new Date(s.date);
          return ge(i) ? pe(pe([], o, !0), [L(L({}, s), { date: i })], !1) : o;
        }, []);
      }, e.calcInitialState = function() {
        var n, o = e.getPreSelection(), s = Nr(e.props), i = Rr(e.props), c = s && Ye(o, Dt(s)) ? s : i && Se(o, An(i)) ? i : o;
        return {
          open: e.props.startOpen || !1,
          preventFocus: !1,
          inputValue: null,
          preSelection: (n = e.props.selectsRange ? e.props.startDate : e.props.selected) !== null && n !== void 0 ? n : c,
          // transforming highlighted days (perhaps nested array)
          // to flat Map for faster access in day.jsx
          highlightDates: Un(e.props.highlightDates),
          focused: !1,
          // used to focus day in inline version after month has changed, but not on
          // initial render
          shouldFocusDayInline: !1,
          isRenderAriaLiveMessage: !1,
          wasHidden: !1
        };
      }, e.resetHiddenStatus = function() {
        e.setState(L(L({}, e.state), { wasHidden: !1 }));
      }, e.setHiddenStatus = function() {
        e.setState(L(L({}, e.state), { wasHidden: !0 }));
      }, e.setHiddenStateOnVisibilityHidden = function() {
        document.visibilityState === "hidden" && e.setHiddenStatus();
      }, e.clearPreventFocusTimeout = function() {
        e.preventFocusTimeout && clearTimeout(e.preventFocusTimeout);
      }, e.setFocus = function() {
        e.input && e.input.focus && e.input.focus({ preventScroll: !0 });
      }, e.setBlur = function() {
        e.input && e.input.blur && e.input.blur(), e.cancelFocusInput();
      }, e.setOpen = function(n, o) {
        o === void 0 && (o = !1), e.setState({
          open: n,
          preSelection: n && e.state.open ? e.state.preSelection : e.calcInitialState().preSelection,
          lastPreSelectChange: qt
        }, function() {
          n || e.setState(function(s) {
            return {
              focused: o ? s.focused : !1
            };
          }, function() {
            !o && e.setBlur(), e.setState({ inputValue: null });
          });
        });
      }, e.inputOk = function() {
        return ke(e.state.preSelection);
      }, e.isCalendarOpen = function() {
        return e.props.open === void 0 ? e.state.open && !e.props.disabled && !e.props.readOnly : e.props.open;
      }, e.handleFocus = function(n) {
        var o, s, i = e.state.wasHidden, c = i ? e.state.open : !0;
        i && e.resetHiddenStatus(), !e.state.preventFocus && c && ((s = (o = e.props).onFocus) === null || s === void 0 || s.call(o, n), !e.props.preventOpenOnFocus && !e.props.readOnly && e.setOpen(!0)), e.setState({ focused: !0 });
      }, e.sendFocusBackToInput = function() {
        e.preventFocusTimeout && e.clearPreventFocusTimeout(), e.setState({ preventFocus: !0 }, function() {
          e.preventFocusTimeout = setTimeout(function() {
            e.setFocus(), e.setState({ preventFocus: !1 });
          });
        });
      }, e.cancelFocusInput = function() {
        clearTimeout(e.inputFocusTimeout), e.inputFocusTimeout = void 0;
      }, e.deferFocusInput = function() {
        e.cancelFocusInput(), e.inputFocusTimeout = setTimeout(function() {
          return e.setFocus();
        }, 1);
      }, e.handleDropdownFocus = function() {
        e.cancelFocusInput();
      }, e.handleBlur = function(n) {
        var o, s;
        (!e.state.open || e.props.withPortal || e.props.showTimeInput) && ((s = (o = e.props).onBlur) === null || s === void 0 || s.call(o, n)), e.setState({ focused: !1 });
      }, e.handleCalendarClickOutside = function(n) {
        var o, s;
        e.props.inline || e.setOpen(!1), (s = (o = e.props).onClickOutside) === null || s === void 0 || s.call(o, n), e.props.withPortal && n.preventDefault();
      }, e.handleChange = function() {
        for (var n = [], o = 0; o < arguments.length; o++)
          n[o] = arguments[o];
        var s = n[0];
        if (!(e.props.onChangeRaw && (e.props.onChangeRaw.apply(e, n), !s || typeof s.isDefaultPrevented != "function" || s.isDefaultPrevented()))) {
          e.setState({
            inputValue: (s == null ? void 0 : s.target) instanceof HTMLInputElement ? s.target.value : null,
            lastPreSelectChange: Ii
          });
          var i = e.props, c = i.dateFormat, l = c === void 0 ? a.defaultProps.dateFormat : c, u = i.strictParsing, d = u === void 0 ? a.defaultProps.strictParsing : u, p = Fs((s == null ? void 0 : s.target) instanceof HTMLInputElement ? s.target.value : "", l, e.props.locale, d, e.props.minDate);
          e.props.showTimeSelectOnly && e.props.selected && p && !I(p, e.props.selected) && (p = _o(e.props.selected, {
            hours: fe(p),
            minutes: he(p),
            seconds: we(p)
          })), (p || !((s == null ? void 0 : s.target) instanceof HTMLInputElement) || !(s != null && s.target.value)) && e.setSelected(p, s, !0);
        }
      }, e.handleSelect = function(n, o, s) {
        if (e.props.shouldCloseOnSelect && !e.props.showTimeSelect && e.sendFocusBackToInput(), e.props.onChangeRaw && e.props.onChangeRaw(o), e.setSelected(n, o, !1, s), e.props.showDateSelect && e.setState({ isRenderAriaLiveMessage: !0 }), !e.props.shouldCloseOnSelect || e.props.showTimeSelect)
          e.setPreSelection(n);
        else if (!e.props.inline) {
          e.props.selectsRange || e.setOpen(!1);
          var i = e.props, c = i.startDate, l = i.endDate;
          c && !l && (e.props.swapRange || !zn(n, c)) && e.setOpen(!1);
        }
      }, e.setSelected = function(n, o, s, i) {
        var c, l = n;
        if (e.props.showYearPicker) {
          if (l !== null && an(R(l), e.props))
            return;
        } else if (e.props.showMonthYearPicker) {
          if (l !== null && Tr(l, e.props))
            return;
        } else if (l !== null && be(l, e.props))
          return;
        var u = e.props, d = u.onChange, p = u.selectsRange, f = u.startDate, m = u.endDate, g = u.selectsMultiple, v = u.selectedDates, D = u.minTime, C = u.swapRange;
        if (!Oe(e.props.selected, l) || e.props.allowSameDay || p || g)
          if (l !== null && (e.props.selected && (!s || !e.props.showTimeSelect && !e.props.showTimeSelectOnly && !e.props.showTimeInput) && (l = Qt(l, {
            hour: fe(e.props.selected),
            minute: he(e.props.selected),
            second: we(e.props.selected)
          })), !s && (e.props.showTimeSelect || e.props.showTimeSelectOnly) && D && (l = Qt(l, {
            hour: D.getHours(),
            minute: D.getMinutes(),
            second: D.getSeconds()
          })), e.props.inline || e.setState({
            preSelection: l
          }), e.props.focusSelectedMonth || e.setState({ monthSelectedIn: i })), p) {
            var b = !f && !m, P = f && !m, E = f && m;
            b ? d ? d([l, null], o) : a.defaultProps.onChange : P && (l === null ? d ? d([null, null], o) : a.defaultProps.onChange : zn(l, f) ? C ? d ? d([l, f], o) : a.defaultProps.onChange : d ? d([l, null], o) : a.defaultProps.onChange : d ? d([f, l], o) : a.defaultProps.onChange), E && (d ? d([l, null], o) : a.defaultProps.onChange);
          } else if (g) {
            if (l !== null)
              if (!(v != null && v.length))
                d ? d([l], o) : a.defaultProps.onChange;
              else {
                var A = v.some(function(M) {
                  return I(M, l);
                });
                if (A) {
                  var _ = v.filter(function(M) {
                    return !I(M, l);
                  });
                  d ? d(_, o) : a.defaultProps.onChange;
                } else
                  d ? d(pe(pe([], v, !0), [l], !1), o) : a.defaultProps.onChange;
              }
          } else
            d ? d(l, o) : a.defaultProps.onChange;
        if (!s) {
          var k = (c = e.props.onSelect) !== null && c !== void 0 ? c : a.defaultProps.onSelect;
          k(l, o), e.setState({ inputValue: null });
        }
      }, e.setPreSelection = function(n) {
        var o = ke(e.props.minDate), s = ke(e.props.maxDate), i = !0;
        if (n) {
          var c = Dt(n);
          if (o && s)
            i = ze(n, e.props.minDate, e.props.maxDate);
          else if (o) {
            var l = Dt(e.props.minDate);
            i = Se(n, l) || Oe(c, l);
          } else if (s) {
            var u = An(e.props.maxDate);
            i = Ye(n, u) || Oe(c, u);
          }
        }
        i && e.setState({
          preSelection: n
        });
      }, e.toggleCalendar = function() {
        e.setOpen(!e.state.open);
      }, e.handleTimeChange = function(n) {
        var o;
        if (!(e.props.selectsRange || e.props.selectsMultiple)) {
          var s = e.props.selected ? e.props.selected : e.getPreSelection(), i = e.props.selected ? n : Qt(s, {
            hour: fe(n),
            minute: he(n)
          });
          e.setState({
            preSelection: i
          });
          var c = (o = e.props.onChange) !== null && o !== void 0 ? o : a.defaultProps.onChange;
          c(i), e.props.shouldCloseOnSelect && !e.props.showTimeInput && (e.sendFocusBackToInput(), e.setOpen(!1)), e.props.showTimeInput && e.setOpen(!0), (e.props.showTimeSelectOnly || e.props.showTimeSelect) && e.setState({ isRenderAriaLiveMessage: !0 }), e.setState({ inputValue: null });
        }
      }, e.onInputClick = function() {
        var n, o;
        !e.props.disabled && !e.props.readOnly && e.setOpen(!0), (o = (n = e.props).onInputClick) === null || o === void 0 || o.call(n);
      }, e.onInputKeyDown = function(n) {
        var o, s, i, c, l;
        (s = (o = e.props).onKeyDown) === null || s === void 0 || s.call(o, n);
        var u = n.key;
        if (!e.state.open && !e.props.inline && !e.props.preventOpenOnFocus) {
          (u === w.ArrowDown || u === w.ArrowUp || u === w.Enter) && e.onInputClick();
          return;
        }
        if (e.state.open) {
          if (u === w.ArrowDown || u === w.ArrowUp) {
            n.preventDefault();
            var d = e.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : e.props.showWeekPicker && e.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : e.props.showFullMonthYearPicker || e.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', p = ((i = e.calendar) === null || i === void 0 ? void 0 : i.componentNode) instanceof Element && e.calendar.componentNode.querySelector(d);
            p instanceof HTMLElement && p.focus({ preventScroll: !0 });
            return;
          }
          var f = W(e.state.preSelection);
          u === w.Enter ? (n.preventDefault(), e.inputOk() && e.state.lastPreSelectChange === qt ? (e.handleSelect(f, n), !e.props.shouldCloseOnSelect && e.setPreSelection(f)) : e.setOpen(!1)) : u === w.Escape ? (n.preventDefault(), e.sendFocusBackToInput(), e.setOpen(!1)) : u === w.Tab && e.setOpen(!1), e.inputOk() || (l = (c = e.props).onInputError) === null || l === void 0 || l.call(c, { code: 1, msg: Ut });
        }
      }, e.onPortalKeyDown = function(n) {
        var o = n.key;
        o === w.Escape && (n.preventDefault(), e.setState({
          preventFocus: !0
        }, function() {
          e.setOpen(!1), setTimeout(function() {
            e.setFocus(), e.setState({ preventFocus: !1 });
          });
        }));
      }, e.onDayKeyDown = function(n) {
        var o, s, i, c, l = e.props, u = l.minDate, d = l.maxDate, p = l.disabledKeyboardNavigation, f = l.showWeekPicker, m = l.shouldCloseOnSelect, g = l.locale, v = l.calendarStartDay, D = l.adjustDateOnChange, C = l.inline;
        if ((s = (o = e.props).onKeyDown) === null || s === void 0 || s.call(o, n), !p) {
          var b = n.key, P = n.shiftKey, E = W(e.state.preSelection), A = function(Q, T) {
            var O = T;
            switch (Q) {
              case w.ArrowRight:
                O = f ? bt(T, 1) : Le(T, 1);
                break;
              case w.ArrowLeft:
                O = f ? kn(T, 1) : Xr(T, 1);
                break;
              case w.ArrowUp:
                O = kn(T, 1);
                break;
              case w.ArrowDown:
                O = bt(T, 1);
                break;
              case w.PageUp:
                O = P ? Be(T, 1) : We(T, 1);
                break;
              case w.PageDown:
                O = P ? De(T, 1) : me(T, 1);
                break;
              case w.Home:
                O = xe(T, g, v);
                break;
              case w.End:
                O = Ks(T);
                break;
            }
            return O;
          }, _ = function(Q, T) {
            for (var O = 40, Y = Q, N = !1, ee = 0, K = A(Q, T); !N; ) {
              if (ee >= O) {
                K = T;
                break;
              }
              u && K < u && (Y = w.ArrowRight, K = be(u, e.props) ? A(Y, K) : u), d && K > d && (Y = w.ArrowLeft, K = be(d, e.props) ? A(Y, K) : d), be(K, e.props) ? ((Y === w.PageUp || Y === w.Home) && (Y = w.ArrowRight), (Y === w.PageDown || Y === w.End) && (Y = w.ArrowLeft), K = A(Y, K)) : N = !0, ee++;
            }
            return K;
          };
          if (b === w.Enter) {
            n.preventDefault(), e.handleSelect(E, n), !m && e.setPreSelection(E);
            return;
          } else if (b === w.Escape) {
            n.preventDefault(), e.setOpen(!1), e.inputOk() || (c = (i = e.props).onInputError) === null || c === void 0 || c.call(i, { code: 1, msg: Ut });
            return;
          }
          var k = null;
          switch (b) {
            case w.ArrowLeft:
            case w.ArrowRight:
            case w.ArrowUp:
            case w.ArrowDown:
            case w.PageUp:
            case w.PageDown:
            case w.Home:
            case w.End:
              k = _(b, E);
              break;
          }
          if (!k) {
            e.props.onInputError && e.props.onInputError({ code: 1, msg: Ut });
            return;
          }
          if (n.preventDefault(), e.setState({ lastPreSelectChange: qt }), D && e.setSelected(k), e.setPreSelection(k), C) {
            var M = re(E), V = re(k), B = R(E), H = R(k);
            M !== V || B !== H ? e.setState({ shouldFocusDayInline: !0 }) : e.setState({ shouldFocusDayInline: !1 });
          }
        }
      }, e.onPopperKeyDown = function(n) {
        var o = n.key;
        o === w.Escape && (n.preventDefault(), e.sendFocusBackToInput());
      }, e.onClearClick = function(n) {
        n && n.preventDefault && n.preventDefault(), e.sendFocusBackToInput();
        var o = e.props, s = o.selectsRange, i = o.onChange;
        s ? i ? i([null, null], n) : a.defaultProps.onChange() : i ? i(null, n) : a.defaultProps.onChange(), e.setState({ inputValue: null });
      }, e.clear = function() {
        e.onClearClick();
      }, e.onScroll = function(n) {
        typeof e.props.closeOnScroll == "boolean" && e.props.closeOnScroll ? (n.target === document || n.target === document.documentElement || n.target === document.body) && e.setOpen(!1) : typeof e.props.closeOnScroll == "function" && e.props.closeOnScroll(n) && e.setOpen(!1);
      }, e.renderCalendar = function() {
        var n, o;
        return !e.props.inline && !e.isCalendarOpen() ? null : h.createElement(Ni, L({ ref: function(s) {
          e.calendar = s;
        } }, e.props, e.state, { setOpen: e.setOpen, dateFormat: (n = e.props.dateFormatCalendar) !== null && n !== void 0 ? n : a.defaultProps.dateFormatCalendar, onSelect: e.handleSelect, onClickOutside: e.handleCalendarClickOutside, holidays: ei(e.modifyHolidays()), outsideClickIgnoreClass: Zn, onDropdownFocus: e.handleDropdownFocus, onTimeChange: e.handleTimeChange, className: e.props.calendarClassName, container: e.props.calendarContainer, handleOnKeyDown: e.props.onKeyDown, handleOnDayKeyDown: e.onDayKeyDown, setPreSelection: e.setPreSelection, dropdownMode: (o = e.props.dropdownMode) !== null && o !== void 0 ? o : a.defaultProps.dropdownMode }), e.props.children);
      }, e.renderAriaLiveRegion = function() {
        var n = e.props, o = n.dateFormat, s = o === void 0 ? a.defaultProps.dateFormat : o, i = n.locale, c = e.props.showTimeInput || e.props.showTimeSelect, l = c ? "PPPPp" : "PPPP", u;
        return e.props.selectsRange ? u = "Selected start date: ".concat(se(e.props.startDate, {
          dateFormat: l,
          locale: i
        }), ". ").concat(e.props.endDate ? "End date: " + se(e.props.endDate, {
          dateFormat: l,
          locale: i
        }) : "") : e.props.showTimeSelectOnly ? u = "Selected time: ".concat(se(e.props.selected, { dateFormat: s, locale: i })) : e.props.showYearPicker ? u = "Selected year: ".concat(se(e.props.selected, { dateFormat: "yyyy", locale: i })) : e.props.showMonthYearPicker ? u = "Selected month: ".concat(se(e.props.selected, { dateFormat: "MMMM yyyy", locale: i })) : e.props.showQuarterYearPicker ? u = "Selected quarter: ".concat(se(e.props.selected, {
          dateFormat: "yyyy, QQQ",
          locale: i
        })) : u = "Selected date: ".concat(se(e.props.selected, {
          dateFormat: l,
          locale: i
        })), h.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, u);
      }, e.renderDateInput = function() {
        var n, o, s, i = Z(e.props.className, (n = {}, n[Zn] = e.state.open, n)), c = e.props.customInput || h.createElement("input", { type: "text" }), l = e.props.customInputRef || "ref", u = e.props, d = u.dateFormat, p = d === void 0 ? a.defaultProps.dateFormat : d, f = u.locale, m = typeof e.props.value == "string" ? e.props.value : typeof e.state.inputValue == "string" ? e.state.inputValue : e.props.selectsRange ? Hs(e.props.startDate, e.props.endDate, {
          dateFormat: p,
          locale: f
        }) : e.props.selectsMultiple ? Ws((s = e.props.selectedDates) !== null && s !== void 0 ? s : [], {
          dateFormat: p,
          locale: f
        }) : se(e.props.selected, {
          dateFormat: p,
          locale: f
        });
        return nr(c, (o = {}, o[l] = function(g) {
          e.input = g;
        }, o.value = m, o.onBlur = e.handleBlur, o.onChange = e.handleChange, o.onClick = e.onInputClick, o.onFocus = e.handleFocus, o.onKeyDown = e.onInputKeyDown, o.id = e.props.id, o.name = e.props.name, o.form = e.props.form, o.autoFocus = e.props.autoFocus, o.placeholder = e.props.placeholderText, o.disabled = e.props.disabled, o.autoComplete = e.props.autoComplete, o.className = Z(c.props.className, i), o.title = e.props.title, o.readOnly = e.props.readOnly, o.required = e.props.required, o.tabIndex = e.props.tabIndex, o["aria-describedby"] = e.props.ariaDescribedBy, o["aria-invalid"] = e.props.ariaInvalid, o["aria-labelledby"] = e.props.ariaLabelledBy, o["aria-required"] = e.props.ariaRequired, o));
      }, e.renderClearButton = function() {
        var n = e.props, o = n.isClearable, s = n.disabled, i = n.selected, c = n.startDate, l = n.endDate, u = n.clearButtonTitle, d = n.clearButtonClassName, p = d === void 0 ? "" : d, f = n.ariaLabelClose, m = f === void 0 ? "Close" : f, g = n.selectedDates;
        return o && (i != null || c != null || l != null || g != null && g.length) ? h.createElement("button", { type: "button", className: Z("react-datepicker__close-icon", p, { "react-datepicker__close-icon--disabled": s }), disabled: s, "aria-label": m, onClick: e.onClearClick, title: u, tabIndex: -1 }) : null;
      }, e.state = e.calcInitialState(), e.preventFocusTimeout = void 0, e;
    }
    return Object.defineProperty(a, "defaultProps", {
      get: function() {
        return {
          allowSameDay: !1,
          dateFormat: "MM/dd/yyyy",
          dateFormatCalendar: "LLLL yyyy",
          onChange: function() {
          },
          disabled: !1,
          disabledKeyboardNavigation: !1,
          dropdownMode: "scroll",
          onFocus: function() {
          },
          onBlur: function() {
          },
          onKeyDown: function() {
          },
          onInputClick: function() {
          },
          onSelect: function() {
          },
          onClickOutside: function() {
          },
          onMonthChange: function() {
          },
          onCalendarOpen: function() {
          },
          onCalendarClose: function() {
          },
          preventOpenOnFocus: !1,
          onYearChange: function() {
          },
          onInputError: function() {
          },
          monthsShown: 1,
          readOnly: !1,
          withPortal: !1,
          selectsDisabledDaysInRange: !1,
          shouldCloseOnSelect: !0,
          showTimeSelect: !1,
          showTimeInput: !1,
          showPreviousMonths: !1,
          showMonthYearPicker: !1,
          showFullMonthYearPicker: !1,
          showTwoColumnMonthYearPicker: !1,
          showFourColumnMonthYearPicker: !1,
          showYearPicker: !1,
          showQuarterYearPicker: !1,
          showWeekPicker: !1,
          strictParsing: !1,
          swapRange: !1,
          timeIntervals: 30,
          timeCaption: "Time",
          previousMonthAriaLabel: "Previous Month",
          previousMonthButtonLabel: "Previous Month",
          nextMonthAriaLabel: "Next Month",
          nextMonthButtonLabel: "Next Month",
          previousYearAriaLabel: "Previous Year",
          previousYearButtonLabel: "Previous Year",
          nextYearAriaLabel: "Next Year",
          nextYearButtonLabel: "Next Year",
          timeInputLabel: "Time",
          enableTabLoop: !0,
          yearItemNumber: at,
          focusSelectedMonth: !1,
          showPopperArrow: !0,
          excludeScrollbar: !0,
          customTimeInput: null,
          calendarStartDay: void 0,
          toggleCalendarOnIconClick: !1,
          usePointerEvent: !1
        };
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.componentDidMount = function() {
      window.addEventListener("scroll", this.onScroll, !0), document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    }, a.prototype.componentDidUpdate = function(t, e) {
      var n, o, s, i;
      t.inline && Ri(t.selected, this.props.selected) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && t.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), t.highlightDates !== this.props.highlightDates && this.setState({
        highlightDates: Un(this.props.highlightDates)
      }), !e.focused && !Oe(t.selected, this.props.selected) && this.setState({ inputValue: null }), e.open !== this.state.open && (e.open === !1 && this.state.open === !0 && ((o = (n = this.props).onCalendarOpen) === null || o === void 0 || o.call(n)), e.open === !0 && this.state.open === !1 && ((i = (s = this.props).onCalendarClose) === null || i === void 0 || i.call(s)));
    }, a.prototype.componentWillUnmount = function() {
      this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0), document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    }, a.prototype.renderInputContainer = function() {
      var t = this.props, e = t.showIcon, n = t.icon, o = t.calendarIconClassname, s = t.calendarIconClassName, i = t.toggleCalendarOnIconClick, c = this.state.open;
      return o && console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props."), h.createElement(
        "div",
        { className: "react-datepicker__input-container".concat(e ? " react-datepicker__view-calendar-icon" : "") },
        e && h.createElement(Mi, L({ icon: n, className: Z(s, !s && o, c && "react-datepicker-ignore-onclickoutside") }, i ? {
          onClick: this.toggleCalendar
        } : null)),
        this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(),
        this.renderDateInput(),
        this.renderClearButton()
      );
    }, a.prototype.render = function() {
      var t = this.renderCalendar();
      if (this.props.inline)
        return t;
      if (this.props.withPortal) {
        var e = this.state.open ? h.createElement(
          Lr,
          { enableTabLoop: this.props.enableTabLoop },
          h.createElement("div", { className: "react-datepicker__portal", tabIndex: -1, onKeyDown: this.onPortalKeyDown }, t)
        ) : null;
        return this.state.open && this.props.portalId && (e = h.createElement(Ir, L({ portalId: this.props.portalId }, this.props), e)), h.createElement(
          "div",
          null,
          this.renderInputContainer(),
          e
        );
      }
      return h.createElement(Ti, L({}, this.props, { className: this.props.popperClassName, hidePopper: !this.isCalendarOpen(), targetComponent: this.renderInputContainer(), popperComponent: t, popperOnKeyDown: this.onPopperKeyDown, showArrow: this.props.showPopperArrow }));
    }, a;
  }(G)
), Ii = "input", qt = "navigate";
function Vi({
  onChange: r = null,
  name: a = "selectedDate",
  selected: t = null,
  label: e = "",
  width: n = 100,
  helpText: o = "",
  ...s
}) {
  const i = rr(null), [c, l] = Br(t), u = (p) => {
    l(p), i !== null && (i.current.value = zt(p, "yyyy-MM-dd"));
  }, d = Qr(({ value: p, onClick: f }, m) => /* @__PURE__ */ st(Gr, { onClick: f, defaultValue: p, label: e, width: n, showValidation: !1, helpText: o, ref: m }));
  return /* @__PURE__ */ Wr(
    "div",
    {
      onClick: (p) => {
        p.target.classList.contains("react-datepicker__day") || p.stopPropagation();
      },
      style: {
        display: "contents",
        "--react-datepicker-wrapper-width": `${n}%`
      },
      children: [
        /* @__PURE__ */ st(
          Yi,
          {
            onChange: r ?? u,
            selected: c,
            customInput: /* @__PURE__ */ st(d, {}),
            ...s
          }
        ),
        /* @__PURE__ */ st("input", { type: "hidden", ref: i, name: a })
      ]
    }
  );
}
export {
  Vi as DatePicker,
  Vi as default
};
